{
  "a11y": {
    "activeBatches": "Lotes activos, {{count}} pendientes",
    "activeBatchesButton": "Lotes activos",
    "addToFavorites": "Añadir a favoritos",
    "addTag": "Añadir etiqueta",
    "audioPlayer": "Reproductor de audio",
    "backupCode": "Código de respaldo",
    "cancelAllDownloads": "Cancelar todas las descargas",
    "clearAllNotifications": "Borrar todas las notificaciones",
    "clearSelection": "Borrar selección",
    "clearUploadQueue": "Vaciar cola de carga",
    "copyLink": "Copiar enlace",
    "closePanel": "Cerrar panel",
    "composerFab": "Redactar nuevo correo",
    "detailsPanel": "Panel de detalles",
    "emailSending": "Enviando correo",
    "emptyFilesTable": "No hay archivos para mostrar",
    "editFileTags": "Editar etiquetas del archivo",
    "fileTagsCount": "Etiquetas, {{count}}",
    "enterFilePasswordForm": "Introducir contraseña del archivo",
    "expandUploadProgress": "Expandir progreso de carga",
    "fileTypesFilter": "Filtrar por tipo de archivo",
    "onlyExpiredFilter": "Filtrar compartidos caducados",
    "expiringWithinDaysFilter": "Filtrar compartidos que caducan en días",
    "filters": "Filtros",
    "fullscreen": "Pantalla completa",
    "fileMoveForm": "Mover archivos",
    "filePublicLinkForm": "Configuración de enlace público",
    "filesTable": "Lista de archivos",
    "globalSearch": "Buscar archivos",
    "goBack": "Volver",
    "groupForm": "Formulario de grupo",
    "loading": "Cargando, espere por favor",
    "minimizeUploadProgress": "Minimizar progreso de carga",
    "mute": "Silenciar",
    "mainNavigation": "Navegación principal",
    "markAllRead": "Marcar todas las notificaciones como leídas",
    "notificationsButton": "Notificaciones",
    "notificationsCount": "Notificaciones, {{count}} sin leer",
    "notificationsList": "Lista de notificaciones",
    "openEmailsSection": "Abrir sección Correos",
    "openFileMenu": "Abrir menú de acciones del archivo",
    "openFolder": "Abrir carpeta {{name}}",
    "openList": "Abrir {{name}}",
    "openMoreActions": "Abrir más acciones",
    "openFilesSection": "Abrir sección Archivos",
    "otpCode": "Código de un solo uso",
    "pendingGrants": "Solicitudes de acceso pendientes, {{count}}",
    "pendingGrantsButton": "Solicitudes de acceso pendientes",
    "playbackProgress": "Progreso de reproducción, {{current}} de {{duration}}",
    "playPause": "Reproducir o pausar",
    "quickShare": "Carga de uso compartido rápido, {{percent}} por ciento",
    "removeFromFavorites": "Quitar de favoritos",
    "removeException": "Eliminar excepción",
    "removeSharedFile": "Quitar archivo compartido",
    "searchExactMatch": "Búsqueda exacta",
    "searchWholeWord": "Palabra completa",
    "sectionSelector": "Selector de sección",
    "selectCountry": "Seleccionar {{country}}",
    "settingsSearch": "Buscar en ajustes",
    "skipToMain": "Saltar al contenido principal",
    "tagActions": "Acciones para la etiqueta {{name}}",
    "tagNotSelected": "no seleccionada",
    "tagSelected": "seleccionada",
    "tagToggle": "{{name}}, {{state}}",
    "textEditor": "Editor de texto",
    "totpCode": "Código del autenticador",
    "unmute": "Activar sonido",
    "activityMap": "Mapa mundial de actividad por país",
    "cancelAllFailed": "Cancelar todos los lotes fallidos",
    "copyBackupCodes": "Copiar códigos de respaldo",
    "deleteSelected": "Eliminar seleccionados",
    "downloadBackupCodes": "Descargar códigos de respaldo",
    "downloadProgress": "Progreso de descarga",
    "exitEditMode": "Salir del modo edición",
    "expandDownloadProgress": "Expandir progreso de descarga",
    "exportCsv": "Exportar a CSV",
    "imageEditor": "Editor de imágenes",
    "markdownEditor": "Editor markdown",
    "markdownHeading": "Estilo de encabezado",
    "markdownLinkActions": "Acciones de enlace",
    "markdownToolbar": "Barra de formato",
    "minimizeDownloadProgress": "Minimizar progreso de descarga",
    "pdfViewer": "Visor de documentos PDF",
    "printDashboard": "Imprimir panel",
    "refreshFolderStats": "Actualizar estadísticas de carpeta",
    "refreshList": "Actualizar lista",
    "removeFile": "Eliminar archivo",
    "saveFile": "Guardar archivo",
    "selectUser": "Seleccionar {{name}}",
    "viewUploadErrors": "Ver errores de carga",
    "uploadProgress": "Progreso de carga",
    "viewAsGrid": "Ver como cuadrícula",
    "viewAsList": "Ver como lista",
    "userForm": "Formulario de usuario",
    "userMenu": "Menú de cuenta de usuario",
    "viewRiskIndicator": "{{name}}, ver detalles",
    "verifyingFile": "Verificando archivo",
    "videoPlayer": "Reproductor de vídeo",
    "volume": "Volumen, {{percent}} por ciento",
    "messageInput": "Entrada de mensaje",
    "sendMessage": "Enviar mensaje",
    "stopGenerating": "Detener generación"
  },
  "antivirus": {
    "quarantine": {
      "title": "Cuarentena",
      "description": "Revise archivos infectados, errores de análisis y omitidos; libere falsos positivos.",
      "empty": "Ningún archivo coincide con este filtro",
      "rescan": "Reanalizar",
      "release": "Liberar",
      "delete": "Eliminar",
      "rescanSuccess": "Reanálisis en cola",
      "releaseSuccess": "Archivo liberado de la cuarentena",
      "releaseModalTitle": "Liberar archivo de la cuarentena",
      "releaseConfirmDescription": "¿Liberar \"{{fileName}}\" de la cuarentena? El archivo volverá a estar disponible. Indique un motivo para el registro de auditoría.",
      "releaseReasonLabel": "Motivo",
      "releaseReasonPlaceholder": "Explique por qué debe liberarse el archivo",
      "releaseReasonRequired": "El motivo de liberación es obligatorio",
      "deleteConfirmTitle": "¿Eliminar archivo en cuarentena?",
      "deleteConfirmDescription": "¿Mover \"{{fileName}}\" a la papelera? Usa la ruta ordinaria de eliminación de archivos.",
      "status": {
        "infected": "Infectado",
        "error": "Error",
        "skipped": "Omitido",
        "toolarge": "Demasiado grande"
      },
      "columns": {
        "name": "Nombre del archivo",
        "threat": "Amenaza",
        "engine": "Motor",
        "ownerEmail": "Correo del propietario",
        "scannedAt": "Analizado el",
        "actions": "Acciones"
      },
      "errors": {
        "loadFailed": "No se pudieron cargar los archivos en cuarentena",
        "rescanFailed": "No se pudo encolar el reanálisis",
        "releaseFailed": "No se pudo liberar el archivo",
        "deleteFailed": "No se pudo eliminar el archivo",
        "invalidParams": "Filtro o motivo de liberación no válido"
      }
    }
  },
  "account": {
    "title": "Cuenta",
    "description": "Gestiona tu perfil, preferencias y seguridad.",
    "navAria": "Secciones de la cuenta",
    "profile": "Perfil",
    "profileDescription": "Actualiza tu nombre. El correo no se puede cambiar aquí.",
    "profileUnavailable": "El perfil no está disponible.",
    "profileUpdated": "Perfil actualizado",
    "preferences": "Preferencias",
    "preferencesDescription": "Idioma, apariencia y accesibilidad.",
    "languageDescription": "Elige el idioma de la interfaz.",
    "appearanceDescription": "Elige claro, oscuro o seguir el sistema.",
    "accessibilityDescription": "Activa alto contraste y reducción de movimiento.",
    "security": "Seguridad",
    "securityDescription": "Autenticación en dos pasos y passkeys.",
    "twoFactorDescription": "Añade o gestiona códigos de la app autenticadora.",
    "passkeysDescription": "Registra y gestiona passkeys de esta cuenta.",
    "openTwoFactor": "Gestionar 2FA",
    "openPasskeys": "Gestionar passkeys",
    "sessions": "Sesiones",
    "sessionsDescription": "Gestiona sesiones activas y desbloqueos de carpetas.",
    "activeSessionsDescription": "Revisa y revoca sesiones de navegador activas.",
    "folderSessionsDescription": "Gestiona sesiones de desbloqueo con contraseña.",
    "openActiveSessions": "Gestionar sesiones activas",
    "openFolderSessions": "Gestionar sesiones de carpeta",
    "publicLinks": "Enlaces públicos",
    "publicLinksDescription": "Consulta y revoca enlaces públicos que creaste.",
    "publicLinksCtaDescription": "Abre la lista de tus enlaces públicos.",
    "openPublicLinks": "Gestionar enlaces públicos"
  },
  "pageTitle": {
    "app": "Filegrant",
    "login": "Iniciar sesión",
    "logout": "Cerrar sesión",
    "settings": "Configuración",
    "account": "Cuenta",
    "filesPersonal": "Archivos",
    "filesReceived": "Recibidos",
    "filesShared": "Compartidos",
    "filesFavorites": "Favoritos",
    "filesRecent": "Recientes",
    "filesHidden": "Ocultos",
    "filesTrash": "Papelera",
    "publicLink": "Enlace público",
    "emails": "Correos",
    "emailsInbox": "Bandeja de entrada",
    "emailsSent": "Enviados",
    "emailsDrafts": "Borradores",
    "emailsFavorites": "Correos favoritos",
    "emailsArchive": "Archivo",
    "emailsTrash": "Papelera de correo",
    "users": "Usuarios",
    "groups": "Grupos",
    "dashboard": "Panel",
    "salesDashboard": "Panel de ventas",
    "activityLogs": "Registros de actividad",
    "antivirusQuarantine": "Cuarentena",
    "viewer": "Visor",
    "office": "Office",
    "quickShare": "Quick Share",
    "store": "Tienda",
    "purchase": "Compra",
    "paymentSuccess": "Pago exitoso",
    "fileShareRequests": "Solicitudes de uso compartido",
    "protectedFile": "Archivo protegido",
    "extensionAuthorize": "Autorización de extensión",
    "sharePointStatus": "Estado de SharePoint"
  },
  "activityLogOperationTypes": {
    "CreateFile": "Archivo creado",
    "CreateFolder": "Carpeta creada",
    "CreateFileFailed": "Error al crear archivo",
    "CreateFolderFailed": "Error al crear carpeta",
    "ReadFile": "Archivo visualizado",
    "ReadFolder": "Carpeta visualizada",
    "DownloadFile": "Archivo descargado",
    "DownloadFileEncrypted": "Archivo cifrado descargado",
    "DownloadFileZip": "Archivo descargado como Zip",
    "SearchFiles": "Archivos buscados",
    "ReadFileFailed": "Error al visualizar archivo",
    "ReadFolderFailed": "Error al visualizar carpeta",
    "DownloadFileFailed": "Error al descargar archivo",
    "DownloadFileEncFailed": "Error al descargar archivo cifrado",
    "DownloadFileZipFailed": "Error al descargar archivo Zip",
    "UpdateFile": "Archivo actualizado",
    "RenameFile": "Archivo renombrado",
    "MoveFile": "Archivo movido",
    "DuplicateFile": "Archivo duplicado",
    "UploadFile": "Archivo subido",
    "UpdateFileFailed": "Error al actualizar archivo",
    "RenameFileFailed": "Error al renombrar archivo",
    "MoveFileFailed": "Error al mover archivo",
    "DuplicateFileFailed": "Error al duplicar archivo",
    "UploadFileFailed": "Error al subir archivo",
    "DeleteFileToRecycleBin": "Archivo movido a papelera",
    "DeleteFolderToRecycleBin": "Carpeta movida a papelera",
    "DeleteFileToRecycleBinFailed": "Error al mover archivo a papelera",
    "DeleteFolderToRecycleBinFailed": "Error al mover carpeta a papelera",
    "DeleteFilePermanently": "Archivo eliminado permanentemente",
    "DeleteFolderPermanently": "Carpeta eliminada permanentemente",
    "DeleteFilePermanentlyFailed": "Error al eliminar archivo permanentemente",
    "DeleteFolderPermanentlyFailed": "Error al eliminar carpeta permanentemente",
    "ShareFile": "Archivo compartido",
    "ShareFolder": "Carpeta compartida",
    "RevokeShare": "Compartición revocada",
    "ShareFileFailed": "Error al compartir archivo",
    "ShareFolderFailed": "Error al compartir carpeta",
    "RevokeShareFailed": "Error al revocar compartición",
    "ViewAuditLog": "Registro de auditoría visualizado",
    "ExportAuditLog": "Registro de auditoría exportado",
    "ViewAuditLogFailed": "Error al visualizar registro de auditoría",
    "ExportAuditLogFailed": "Error al exportar registro de auditoría",
    "PurgeAuditLog": "Registro de auditoría purgado (retención)",
    "GrantAccess": "Acceso concedido",
    "RevokeAccess": "Acceso revocado",
    "GrantAccessFailed": "Error al conceder acceso",
    "RevokeAccessFailed": "Error al revocar acceso",
    "CreateVersion": "Versión creada",
    "RevertVersion": "Versión revertida",
    "CreateVersionFailed": "Error al crear versión",
    "RevertVersionFailed": "Error al revertir versión",
    "CommentFile": "Comentario añadido",
    "ReplyComment": "Comentario respondido",
    "AssignTask": "Tarea asignada",
    "CommentFileFailed": "Error al comentar",
    "ReplyCommentFailed": "Error al responder comentario",
    "AssignTaskFailed": "Error al asignar tarea",
    "PreviewFile": "Archivo previsualizando",
    "HiddenFile": "Archivo oculto",
    "UnhiddenFile": "Archivo mostrado",
    "AddToFavorites": "Añadido a favoritos",
    "RemoveFromFavorites": "Eliminado de favoritos",
    "PreviewFileFailed": "Error al previsualizar archivo",
    "HiddenFileFailed": "Error al ocultar archivo",
    "UnhiddenFileFailed": "Error al mostrar archivo",
    "AddToFavoritesFailed": "Error al añadir a favoritos",
    "RemoveFromFavoritesFailed": "Error al eliminar de favoritos",
    "CreateUser": "Usuario creado",
    "EditUser": "Usuario editado",
    "RemoveUser": "Usuario eliminado",
    "CreateGroup": "Grupo creado",
    "EditGroup": "Grupo editado",
    "RemoveGroup": "Grupo eliminado",
    "OnBehalfOfAccess": "Accedido en nombre del usuario",
    "OnBehalfOfOperation": "Operado en nombre del usuario",
    "CreateUserFailed": "Error al crear usuario",
    "EditUserFailed": "Error al editar usuario",
    "RemoveUserFailed": "Error al eliminar usuario",
    "CreateGroupFailed": "Error al crear grupo",
    "EditGroupFailed": "Error al editar grupo",
    "RemoveGroupFailed": "Error al eliminar grupo",
    "OnBehalfOfAccessFailed": "Error al acceder en nombre del usuario",
    "OnBehalfOfOperationFailed": "Error al operar en nombre del usuario",
    "LogIn": "Usuario inició sesión",
    "LogOut": "Usuario cerró sesión",
    "OTPRequest": "OTP solicitado",
    "LogInFailed": "Error al iniciar sesión",
    "LogOutFailed": "Error al cerrar sesión",
    "OTPRequestFailed": "Error al solicitar OTP",
    "AddTag": "Etiqueta añadida",
    "RemoveTag": "Etiqueta eliminada",
    "UpdateTag": "Etiqueta actualizada",
    "ListTags": "Etiquetas listadas",
    "AddTagFailed": "Error al añadir etiqueta",
    "RemoveTagFailed": "Error al eliminar etiqueta",
    "UpdateTagFailed": "Error al actualizar etiqueta",
    "ListTagsFailed": "Error al listar etiquetas",
    "RestoreFile": "Archivo restaurado",
    "TagFile": "Etiquetas añadidas al archivo",
    "RemoveTagFile": "Etiquetas eliminadas del archivo",
    "EncryptFile": "Archivo cifrado",
    "DecryptFile": "Archivo descifrado",
    "ChangeFileOwner": "Propietario del archivo cambiado",
    "SetFileExpiration": "Expiración del archivo establecida",
    "GenerateShareLink": "Enlace de compartición generado",
    "ValidateUser": "Usuario validado",
    "SignFile": "Archivo firmado",
    "FileDescription": "Descripción del archivo establecida",
    "ShortCut": "Acceso directo al archivo creado",
    "RestoreFileFailed": "Error al restaurar archivo",
    "TagFileFailed": "Error al etiquetar archivo",
    "RemoveTagFileFailed": "Error al eliminar etiquetas del archivo",
    "EncryptFileFailed": "Error al cifrar archivo",
    "DecryptFileFailed": "Error al descifrar archivo",
    "ChangeFileOwnerFailed": "Error al cambiar propietario del archivo",
    "SetFileExpirationFailed": "Error al establecer expiración",
    "GenerateShareLinkFailed": "Error al generar enlace de compartición",
    "ValidateUserFailed": "Error al validar usuario",
    "SignFileFailed": "Error al firmar archivo",
    "FileDescriptionFailed": "Error al establecer descripción del archivo",
    "ShortCutFailed": "Error al crear acceso directo del archivo",
    "ScreenCaptureAttempt": "Intento de captura de pantalla",
    "ClipboardCopyAttempt": "Intento de copia al portapapeles",
    "UnauthorizedAccessAttempt": "Intento de acceso no autorizado",
    "ScreenCaptureAttemptFailed": "Error en intento de captura de pantalla",
    "ClipboardCopyAttemptFailed": "Error en intento de copia al portapapeles",
    "UnauthorizedAccessAttemptFailed": "Error en intento de acceso no autorizado",
    "MalwareDetection": "Malware detectado",
    "MalwareRemoval": "Malware eliminado",
    "SuspiciousActivityDetected": "Actividad sospechosa detectada",
    "IntrusionDetection": "Intrusión detectada",
    "IntrusionPrevention": "Intrusión prevenida",
    "DataLeakageAttempt": "Intento de fuga de datos",
    "DataLeakageAttemptFailed": "Error en intento de fuga de datos",
    "PhishingAttemptDetected": "Intento de phishing detectado",
    "RansomwareAttackDetected": "Ataque de ransomware detectado",
    "BruteForceAttackDetected": "Ataque de fuerza bruta detectado",
    "TwoFactorAuthEnabled": "Autenticación de dos factores habilitada",
    "TwoFactorAuthDisabled": "Autenticación de dos factores deshabilitada",
    "TwoFactorAuthAttemptFailed": "Error en intento de autenticación de dos factores",
    "PasswordChange": "Contraseña cambiada",
    "PasswordChangeFailed": "Error al cambiar contraseña",
    "SecuritySettingsUpdate": "Configuración de seguridad actualizada",
    "SecuritySettingsUpdateFailed": "Error al actualizar configuración de seguridad",
    "FirewallRuleChange": "Regla de firewall cambiada",
    "FirewallRuleChangeFailed": "Error al cambiar regla de firewall",
    "EncryptionKeyManagement": "Clave de cifrado gestionada",
    "EncryptionKeyManagementFailed": "Error al gestionar clave de cifrado",
    "AccessControlPolicyChange": "Política de control de acceso cambiada",
    "AccessControlPolicyChangeFailed": "Error al cambiar política de control de acceso",
    "SecurityPatchApplied": "Parche de seguridad aplicado",
    "SecurityPatchAppliedFailed": "Error al aplicar parche de seguridad",
    "LastCheckToken": "Última verificación de token",
    "UpdateSetting": "Configuración de actualización",
    "ViewGroupsList": "Lista de grupos visualizada",
    "ViewUsersList": "Lista de usuarios visualizada",
    "ViewTrash": "Papelera visualizada",
    "ViewArchivedFiles": "Archivos ocultos visualizados",
    "ViewFavoriteFiles": "Archivos favoritos visualizados",
    "ViewSharedFiles": "Archivos compartidos visualizados",
    "ViewReceivedFiles": "Archivos recibidos visualizados",
    "ViewSettings": "Configuración visualizada",
    "EmailSent": "Correo enviado",
    "EmailRead": "Correo leído",
    "EmailSaveDraft": "Borrador guardado",
    "EmailUpdateDraft": "Borrador actualizado",
    "EmailTrash": "Correo movido a papelera",
    "EmailRestore": "Correo restaurado de papelera",
    "EmailDelete": "Correo eliminado permanentemente",
    "EmailArchive": "Correo archivado",
    "EmailUnarchive": "Correo desarchivado",
    "EmailFavourite": "Correo marcado como favorito",
    "EmailUnfavourite": "Correo desmarcado como favorito",
    "EmailAttachmentRemoved": "Adjunto eliminado del correo enviado",
    "EmailRecipientRemoved": "Destinatario eliminado del correo enviado",
    "EmailReplied": "Respuesta de correo enviada",
    "EmailForwarded": "Correo reenviado",
    "CreateSetting": "Configuración creada",
    "DeleteSetting": "Configuración eliminada",
    "PaymentSessionCreated": "Sesión de pago creada",
    "PaymentCompleted": "Pago completado",
    "SessionRevoked": "Sesión revocada",
    "AllSessionsRevoked": "Todas las sesiones revocadas",
    "AdminSessionRevoked": "Sesión de usuario revocada por admin",
    "CreateCompany": "Empresa creada",
    "UpdateCompany": "Empresa actualizada",
    "BackOfficeCreateUser": "Usuario creado vía back office",
    "BackOfficeUpdateUser": "Usuario actualizado vía back office",
    "SystemMaintenance": "Mantenimiento del sistema",
    "CreateCertificate": "Certificado creado",
    "CreateAccessRule": "Regla de acceso creada",
    "VersionRetention": "Retención de versiones aplicada",
    "CleanupDeletedVersions": "Versiones eliminadas limpiadas",
    "CreateIdentityProvider": "Proveedor de identidad creado",
    "UpdateIdentityProvider": "Proveedor de identidad actualizado",
    "CreateAIAgent": "Agente IA creado",
    "UpdateAIAgent": "Agente IA actualizado",
    "DeleteAIAgent": "Agente IA eliminado",
    "AIChatRequest": "Solicitud de chat IA",
    "AIChatWithDocument": "Chat IA con documento",
    "AIChatDeleteConversation": "Conversación de chat IA eliminada",
    "CancelBatch": "Lote cancelado",
    "CancelFileJobs": "Trabajos de archivo cancelados",
    "RetryFileJobs": "Reintento de trabajos de archivo",
    "InviteUsers": "Usuarios invitados",
    "ViewExecutiveReport": "Informe ejecutivo visualizado",
    "CreatePublicLink": "Enlace público creado",
    "RevokePublicLink": "Enlace público revocado",
    "PublicLinkAccess": "Acceso por enlace público",
    "PublicLinkDownload": "Descarga por enlace público",
    "PublicLinkViewerAccess": "Acceso al visor por enlace público",
    "PublicLinkAccessFailed": "Error al acceder por enlace público",
    "IpRegionLoginBlocked": "Inicio de sesión bloqueado por IP/región",
    "IpRegionFileOperationBlocked": "Operación de archivo bloqueada por IP/región",
    "EntraIdSyncStarted": "Sincronización Entra ID iniciada",
    "EntraIdSyncCompleted": "Sincronización Entra ID completada",
    "EntraIdUserImported": "Usuario importado desde Entra ID",
    "EntraIdGroupImported": "Grupo importado desde Entra ID",
    "EntraIdSyncFailed": "Sincronización Entra ID fallida",
    "SetFolderPassword": "Contraseña de carpeta establecida",
    "RemoveFolderPassword": "Contraseña de carpeta eliminada",
    "FolderPasswordVerified": "Contraseña de carpeta verificada",
    "FolderPasswordFailed": "Verificación de contraseña de carpeta fallida",
    "FolderPasswordLockout": "Bloqueo por intentos de contraseña de carpeta",
    "FolderPasswordSessionRevoked": "Sesión de contraseña de carpeta revocada",
    "FolderPasswordResetOtpRequested": "OTP de restablecimiento de contraseña solicitado",
    "FolderPasswordResetWithOtp": "Restablecimiento de contraseña de carpeta con OTP",
    "FolderPasswordResetOtpFailed": "Restablecimiento de contraseña de carpeta con OTP fallido",
    "TotpExemptionGranted": "Exención TOTP concedida",
    "TotpExemptionRevoked": "Exención TOTP revocada",
    "TotpExemptionExpired": "Exención TOTP expirada",
    "TransferOwnership": "Propiedad transferida",
    "TransferOwnershipFailed": "Error al transferir la propiedad",
    "UserLoginTokenCreated": "Token de inicio de sesión creado",
    "UserLoginTokenDeleted": "Token de inicio de sesión eliminado",
    "UserLoginTokenStatusChanged": "Estado del token de inicio de sesión cambiado",
    "UserLoginTokenUsed": "Inicio de sesión con token",
    "UserLoginTokenFailed": "Error de autenticación con token",
    "PasskeyRegistered": "Passkey registrada",
    "PasskeyRemoved": "Passkey eliminada",
    "PasskeyRemovedByAdmin": "Passkey eliminada por el administrador",
    "PasskeyAuthenticationFailed": "Error de autenticación con passkey",
    "PasskeyPasswordlessLogin": "Inicio de sesión sin contraseña con passkey",
    "PasskeyBlocked": "Passkey bloqueada",
    "SharePointFileEncrypted": "Archivo de SharePoint cifrado",
    "SharePointFileEncryptionFailed": "Error al cifrar el archivo de SharePoint",
    "SharePointFileEncryptionSkipped": "Archivo de SharePoint omitido",
    "SharePointScanCycleCompleted": "Ciclo de análisis de SharePoint completado",
    "SharePointScanCycleFailed": "Error en el ciclo de análisis de SharePoint",
    "SharePointConnectionTested": "Conexión de SharePoint verificada",
    "SharePointConnectionTestFailed": "Error al verificar la conexión de SharePoint",
    "SharePointPerimeterBrowsed": "Perímetro de SharePoint explorado",
    "SharePointViewerTokenIssued": "Token de visualización de SharePoint emitido",
    "SharePointViewerTokenDenied": "Token de visualización de SharePoint denegado",
    "SharePointEditSessionOpened": "Sesión de edición de SharePoint abierta",
    "SharePointEditSessionDenied": "Sesión de edición de SharePoint denegada",
    "SharePointFileEdited": "Archivo de SharePoint editado",
    "DirectorySyncUserDisabled": "Sincronización de directorio deshabilitó usuario",
    "DirectorySyncUserEnabled": "Sincronización de directorio habilitó usuario",
    "DirectorySyncGroupMembersChanged": "Sincronización de directorio cambió miembros del grupo",
    "DirectorySyncStarted": "Sincronización de directorio iniciada",
    "DirectorySyncCompleted": "Sincronización de directorio completada",
    "DirectorySyncFailed": "Sincronización de directorio fallida",
    "DirectorySyncUserImported": "Usuario importado por sincronización de directorio",
    "DirectorySyncGroupImported": "Grupo importado por sincronización de directorio",
    "DirectorySyncConnectionTested": "Conexión de directorio comprobada"
  },
  "activityLogTargetTypes": {
    "File": "Archivo",
    "Folder": "Carpeta",
    "Files": "Archivos",
    "FilesAndFolders": "Archivos y Carpetas",
    "FilesAndTags": "Archivos y Etiquetas",
    "FilesFoldersAndTags": "Archivos, Carpetas y Etiquetas",
    "User": "Usuario",
    "Group": "Grupo",
    "Share": "Entrada compartida",
    "ShareLink": "Enlace compartido",
    "Version": "Versión de un archivo o documento",
    "Comment": "Comentario en un documento o archivo",
    "Task": "Tarea asignada en un entorno colaborativo",
    "Permission": "Permiso",
    "AccessControl": "Entradas de control de acceso",
    "Admin": "Operaciones relacionadas con administración",
    "Configuration": "Configuración del sistema",
    "Setting": "Configuración individual",
    "Tag": "Etiqueta o rótulo",
    "Metadata": "Entrada de metadatos",
    "Notification": "Entrada de notificación",
    "Workflow": "Flujo de trabajo o definición de proceso",
    "Template": "Plantilla para documentos o archivos",
    "AuditLog": "Registro de auditoría",
    "Security": "Objetivos relacionados con seguridad",
    "Monitoring": "Objetivos de monitorización y registro",
    "Authentication": "Objetivos relacionados con autenticación",
    "TwoFactorAuth": "Objetivos de autenticación de dos factores",
    "Session": "Sesión o token de usuario",
    "Encryption": "Objetivos relacionados con encriptación",
    "EncryptionKey": "Gestión de claves de encriptación",
    "Payment": "Pago o transacción",
    "Company": "Empresa o inquilino",
    "Certificate": "Certificado RSA para acceso empresarial",
    "AccessRule": "Regla de control de acceso",
    "IdentityProvider": "Proveedor de identidad (p. ej. Microsoft, Google)",
    "AIAgent": "Agente de clasificación IA",
    "AIChat": "Conversación de chat IA",
    "Batch": "Operación por lotes",
    "Report": "Informe ejecutivo u otro",
    "Other": "Otros objetivos genéricos",
    "GroupsList": "Grupos",
    "UsersList": "Usuarios",
    "SpecialFolder": "Carpeta especial",
    "SettingsList": "Configuraciones del sistema",
    "Email": "Correo electrónico",
    "SharePointFile": "Archivo de SharePoint"
  },
  "realtime": {
    "connected": "Conectado",
    "connecting": "Conectando…",
    "disconnected": "Desconectado",
    "reconnecting": "Reconectando…"
  },
  "settings": {
    "settings": "Configuración",
    "unavailable": "Configuraciones no disponibles en este momento",
    "retry": "Haz clic para reintentar",
    "authentication": "Autenticación",
    "saveCard": {
      "message": "Haz clic en <strong>Guardar</strong> cuando hayas completado los cambios."
    },
    "informations": "Información",
    "preview": "Vista Previa",
    "externalUserEnforcement": "Aplicación de Usuario Externo",
    "externalUserEnforcementDescription": "Forzar visualización en modo Anti-Captura para todos los usuarios externos.",
    "tagBasedEncryption": "Encriptación Basada en Etiquetas",
    "tagBasedEncryptionDescription": "Forzar visualización en modo Anti-Captura para archivos con etiquetas específicas.",
    "tagBasedEncryptionPlaceholder": "Etiquetas (separadas por comas), - ej. 'confidencial, secreto'",
    "companyBranding": {
      "title": "Marca de la empresa",
      "description": "Personalizar la apariencia de la plataforma con la marca de tu empresa. Esto incluye establecer el logotipo, colores y otros elementos visuales que se mostrarán a los usuarios.",
      "companyName": "Nombre de la Empresa",
      "preferredLanguage": "Idioma Preferido",
      "companyLogos": "Logotipos de la Empresa",
      "companyLogosDescription": "El tamaño del archivo no puede ser mayor a 1MB",
      "loginPageLogo": "Logotipo de la Página de Inicio de Sesión",
      "loginPageLogoDescription": "Establecer el logotipo que se mostrará en la página de inicio de sesión para los usuarios. Sugerencias: Logotipo cuadrado u horizontal con fondo transparente con un ancho máximo de 200px.",
      "topBarLogo": "Logotipo de la Barra Superior",
      "topBarLogoDescription": "Establecer el logotipo que se mostrará en la barra superior de la plataforma. Sugerencias: Logotipo cuadrado u horizontal con fondo transparente.",
      "emailNotificationLogo": "Logotipo de Notificación por Correo Electrónico",
      "emailNotificationLogoDescription": "Establecer el logotipo que se utilizará en las notificaciones por correo electrónico enviadas a los usuarios.",
      "quickShareBackground": "Fondo de Compartición Rápida",
      "quickShareBackgroundDescription": "Establecer la imagen de fondo que se mostrará en la página de compartición rápida. Tamaño sugerido: 1200x1920 píxeles",
      "companyColors": "Colores de la Empresa",
      "topBarColors": "Colores de la Barra Superior",
      "topBarColorsDescription": "Establecer el color de fondo y texto para la barra superior de la plataforma.",
      "mainButtonsColors": "Colores de Botones Principales",
      "mainButtonsColorsDescription": "Establecer el color de fondo y texto para el botón principal.",
      "loginPageTitle": "Título de la Página de Inicio de Sesión",
      "loginPageSubtitle": "Subtítulo de la Página de Inicio de Sesión",
      "loginTermsAndConditions": "Términos y Condiciones de Inicio de Sesión",
      "loginPagePreview": "Vista Previa de la Página de Inicio de Sesión y Barra Superior",
      "mainButtonsPreview": "Vista Previa de textos y colores de botones principales",
      "emailNotificationsPreview": "Vista Previa de Notificaciones por Correo Electrónico",
      "quickSharePreview": "Vista Previa del Fondo de Compartición Rápida",
      "addLogo": "Añadir logotipo"
    },
    "emailCustomizations": {
      "title": "Personalización de email",
      "description": "Personaliza las plantillas HTML utilizadas para las notificaciones por correo electrónico enviadas por la plataforma.",
      "language": "Idioma",
      "noTemplates": "No hay plantillas de correo disponibles",
      "subject": "Asunto",
      "availablePlaceholders": "Marcadores disponibles (haz clic para insertar)",
      "preview": "Vista previa",
      "customized": "Personalizado",
      "default": "Predeterminado",
      "resetToDefault": "Restablecer predeterminado",
      "resetTitle": "Restablecer plantilla",
      "resetConfirm": "Restablecer",
      "resetConfirmDescription": "Se eliminarán las personalizaciones y la plantilla volverá a la predeterminada. Esta acción no se puede deshacer.",
      "resetSuccess": "Plantilla restablecida",
      "resetError": "Error al restablecer la plantilla",
      "saveSuccess": "Plantilla guardada correctamente",
      "saveError": "Error al guardar la plantilla",
      "sendTest": "Enviar Email de Prueba",
      "testSuccess": "Email de prueba enviado",
      "testError": "Error al enviar el email de prueba"
    },
    "downloadRestrictions": {
      "title": "Aplicación de encriptación de descarga",
      "description": "Controlar la configuración para restricciones de descarga para todos los miembros. Esto incluye forzar encriptación en descargas, aplicar reglas específicas para usuarios externos, y anular estas configuraciones basándose en etiquetas de archivos.",
      "activeForAllTitle": "Ámbito de Usuario",
      "activeForAllDescription": "Forzar encriptación de descarga para miembros que ya tienen permisos de descarga, ya sea porque son propietarios o se les han otorgado permisos de edición. Si no está habilitado, las descargas funcionarán normalmente donde sea aplicable.",
      "exceptionHandlingTitle": "Manejo de Excepciones",
      "exceptionHandlingDescription": "Especificar miembros que son excepciones a las restricciones anteriores.",
      "externalUserEnforcementTitle": "Aplicación de Usuario Externo",
      "externalUserEnforcementDescription": "Forzar encriptación de descarga para todos los usuarios externos",
      "tagBasedEncryptionTitle": "Encriptación Basada en Etiquetas",
      "tagBasedEncryptionDescription": "Forzar descarga encriptada con etiquetas específicas",
      "tagBasedEncryptionPlaceholder": "Etiquetas (separadas por comas), - ej. 'confidencial, secreto'",
      "exceptionsRequiredForTags": "Se requieren excepciones para configurar etiquetas",
      "tagsRequired": "Se requiere al menos una etiqueta cuando hay múltiples reglas"
    },
    "downloadAllowedTags": {
      "title": "Etiquetas permitidas para descarga",
      "description": "Permite a los miembros descargar documentos compartidos con permisos de solo lectura.",
      "activeForAllTitle": "Ámbito de Usuario",
      "activeForAllDescription": "Controlar si los usuarios están sujetos a las restricciones establecidas por el administrador. Esta configuración puede definir el alcance de los permisos, las condiciones bajo las cuales se aplican y las excepciones permitidas.",
      "exceptionHandlingTitle": "Manejo de Excepciones",
      "exceptionHandlingDescription": "Especificar los miembros que son excepciones a las restricciones anteriores.",
      "externalUserEnforcementTitle": "Aplicación de Usuario Externo",
      "externalUserEnforcementDescription": "Forzar encriptación de descarga para todos los usuarios externos",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Habilitar descarga para archivos de solo lectura solo para archivos con estas etiquetas.",
      "tagsPlaceholder": "Etiquetas (separadas por comas), ej. 'confidencial, secreto'",
      "tagsRequired": "Se requiere al menos una etiqueta cuando hay múltiples reglas"
    },
    "forcedAntiCaptureMode": {
      "title": "Modo Anti-Captura forzado",
      "description": "Forzar la visualización de archivos compartidos con etiquetas específicas solo en modo Anti-Captura.",
      "forcedAntiCaptureModeTitle": "Aplicación de Anti-captura",
      "forcedAntiCaptureModeDescription": "Seleccionar si aplicar anti-captura a todos o ninguno. Habilitar anti-captura también activará descargas seguras de archivos.",
      "exceptionHandlingTitle": "Manejo de Excepciones",
      "exceptionHandlingDescription": "Especificar miembros que son excepciones a las restricciones anteriores.",
      "tagBasedEncryptionTitle": "Encriptación Basada en Etiquetas",
      "tagBasedEncryptionDescription": "Aplicar esta regla solo a archivos con etiquetas específicas"
    },
    "aiTagging": {
      "title": "Etiquetado por IA",
      "description": "Habilitar etiquetado por IA para archivos. Esto etiquetará automáticamente archivos basándose en su contenido.",
      "descriptionInternal": "Habilitar etiquetado por IA para archivos. Esto etiquetará automáticamente archivos basándose en su contenido. <DangerText>Nota: esto solo se aplica a archivos de tamaño inferior a 250 MB. Los cambios en estas configuraciones NO se aplican retroactivamente, lo que significa que los archivos con etiquetas existentes no se clasificarán automáticamente.</DangerText>",
      "isRuleEnabledTitle": "Habilitar regla de etiquetado por IA",
      "isRuleEnabledDescription": "Habilitar la capacidad para que los usuarios (Administradores y Colaboradores) permitan que la IA etiquete sus archivos basándose en su contenido.",
      "isAutomaticClassificationEnabledTitle": "Habilitar clasificación automática",
      "isAutomaticClassificationEnabledDescription": "Habilitar la clasificación automática de archivos basándose en su contenido.",
      "ruleTargetTitle": "Objetivo de la regla",
      "ruleTargetDescription": "Seleccionar el objetivo de la regla.",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Aplicar esta regla solo a archivos con etiquetas específicas",
      "aiAgentTitle": "Agente de IA",
      "aiAgentDescription": "Seleccionar el agente de IA a usar para etiquetar archivos.",
      "aiAgentPlaceholder": "Seleccionar un agente de IA",
      "membersTitle": "Quién Puede Clasificar con el Agente Seleccionado",
      "membersDescription": "Elegir a qué miembros se aplica el agente seleccionado.",
      "exceptionsTitle": "Gestión de excepciones",
      "exceptionsDescription": "Agrega los usuarios que no deseas que tengan la clasificación automática",
      "exceptionsButtonText": "Gestionar usuarios",
      "exceptionHandlingTitle": "Manejo de Excepciones",
      "exceptionHandlingDescription": "Especificar miembros que son excepciones a las restricciones anteriores.",
      "filesTypeTitle": "Gestión de Extensiones de Archivo",
      "filesTypeDescription": "Especificar las extensiones de archivo que serán clasificadas por el agente seleccionado.",
      "externalUserTitle": "Usuario Externo",
      "externalUserDescription": "Permitir clasificación por usuarios externos.",
      "filesTypePlaceholder": "Seleccionar una o más",
      "folderIdsTitle": "Carpetas a clasificar",
      "folderIdsDescription": "Seleccionar las carpetas a clasificar por el agente seleccionado."
    },
    "singleSignOn": {
      "title": "Inicio de sesión único (SSO)",
      "enableTitle": "Habilitar inicio de sesión único",
      "description": "Habilitar Inicio de Sesión Único (SSO) para tu organización. Esto permitirá a tus usuarios iniciar sesión en Filegrant Enterprise usando sus credenciales existentes de un proveedor de identidad compatible.",
      "providers": "Proveedores",
      "providersDescription": "Seleccionar los proveedores que quieres habilitar for Single Sign-On (SSO).",
      "google": "Google",
      "microsoft": "Microsoft",
      "cybergrant": "CyberGrant",
      "notificationSsoEnableMessage": "La función de Inicio de Sesión Único (SSO) se está habilitando. Este proceso puede tomar unos minutos en completarse. Por favor permanece en esta página hasta que el proceso se complete.",
      "notificationSsoEnabledMessage": "La función de Inicio de Sesión Único (SSO) ha sido habilitada exitosamente.",
      "copyRedirectUriHint": "Cópialo y añádelo en la configuración de tu IdP.",
      "redirectUri": "URI de Redirección",
      "copyRedirectUriDesc": "Cópialo y añádelo en la configuración de tu IdP.",
      "notificationSsoEnableTimeout": "Error al habilitar SSO",
      "notificationSsoEnableTimeoutDesc": "No fue posible habilitar la función de Inicio de Sesión Único (SSO). Por favor, inténtalo de nuevo.",
      "domainAlreadySet": "Este dominio ya está configurado",
      "mobileRedirectUri": "URI de Redirección Móvil",
      "mobileRedirectUriHint": "Agrega este URI de redirección solo si deseas habilitar SSO en la aplicación móvil.",
      "clientCertificate": "Certificado de cliente",
      "certificateInUse": "Certificado en uso",
      "certificateThumbprint": "Huella",
      "certificateExpiresAt": "Caduca",
      "certificateExpired": "Este certificado caducó el {{date}}. El inicio de sesión SSO y la sync de Entra ID fallarán hasta que lo reemplaces.",
      "certificateExpiringSoon": "Este certificado caduca el {{date}} (en {{days}} días).",
      "certificateTooLarge": "El archivo del certificado es demasiado grande. Usa un PKCS#12 (.pfx/.p12) dentro del límite de tamaño.",
      "certificateReadyToUpload": "Nuevo certificado seleccionado. Introduce su contraseña (déjala vacía si no tiene) y guarda.",
      "uploadCertificate": "Subir certificado",
      "replaceCertificate": "Reemplazar certificado",
      "clearCertificate": "Quitar certificado",
      "certificatePassword": "Contraseña del certificado",
      "certificatePasswordHint": "Introduce la contraseña PKCS#12 en cada nueva subida; la contraseña almacenada nunca se reutiliza. Déjala vacía si el archivo no tiene contraseña.",
      "certificatePasswordPlaceholder": "Contraseña PKCS#12 (opcional)",
      "noCredentialsWarning": "No hay secreto de cliente ni certificado configurado. Añade al menos una credencial antes de habilitar este proveedor.",
      "clientIdChangeWarning": "Client ID cambiado. Envía un nuevo secreto de cliente y/o vuelve a subir el certificado, o se borrarán las credenciales enmascaradas.",
      "clientIdChangeBlocksSave": "No se puede guardar: Client ID cambiado manteniendo credenciales enmascaradas",
      "clientIdChangeBlocksSaveHint": "Configuración Microsoft {{index}}: introduce un nuevo secreto de cliente y/o sube un certificado antes de guardar.",
      "certificateProblemEntry": "{{provider}} — configuración {{index}}: {{message}}",
      "errors": {
        "certificateInvalid": "No se pudo aceptar el certificado de cliente",
        "certificateNotSupported": "Los certificados no son compatibles con este proveedor",
        "invalidConfiguration": "Configuración de Single Sign-On no válida"
      }
    },
    "fileDeletionRestriction": {
      "title": "Restricción de eliminación de archivos",
      "description": "Habilita el control granular sobre la eliminación de archivos por parte de los usuarios. Esta configuración permite definir los permisos de eliminación según el rol del usuario con respecto al archivo: creador, propietario o destinatario. Garantiza reglas de gestión de contenidos claras y seguras, evitando eliminaciones no autorizadas y apoyando el cumplimiento de las políticas organizacionales.",
      "allowDeletionFor": "Permitir Eliminación Para",
      "allowDeletionForDescription": "Elegir si todos o ninguno de los usuarios tienen permitido eliminar archivos.",
      "exceptionHandlingTitle": "Manejo de Excepciones",
      "exceptionHandlingDescription": "Especificar miembros que son excepciones a las restricciones anteriores.",
      "fileAccessTypeTitle": "Tipos de Acceso Autorizados",
      "fileAccessTypeDescription": "Seleccionar los tipos de acceso a archivo/carpeta que están autorizados para eliminar el archivo.",
      "owner": "Propietario",
      "creator": "Creador",
      "receiver": "Receptor"
    },
    "adminRegisteredMemberVisibility": {
      "title": "Visibilidad de miembros registrados por administrador",
      "description": "Controlar la visibilidad de miembros o grupos registrados por administrador a los usuarios. Las opciones incluyen permitir a todos los colaboradores ver usuarios registrados por administrador o ninguno. La visibilidad es principalmente a través de la compartición de archivos. Cuando un colaborador comparte un archivo con una dirección de correo electrónico correspondiente a un miembro registrado por administrador, el colaborador verá el nombre y apellido del miembro después de la compartición, incluso si el colaborador no tiene permiso para ver usuarios registrados por administrador según esta configuración. Esta limitación no se aplica a colaboradores o grupos a los que se ha asignado el estado Privado.",
      "exceptionHandlingTitle": "Manejo de Excepciones",
      "exceptionHandlingDescription": "Especificar miembros que son excepciones a las restricciones anteriores.",
      "sectionTitle": "Limitaciones de Visibilidad de Colaboradores",
      "visibilityTitle": "Visibilidad de Miembros Registrados por Administrador",
      "visibilityDescription": "Controlar la visibilidad de miembros o grupos registrados por administrador a los usuarios. Las opciones incluyen permitir a todos los colaboradores ver usuarios registrados por administrador o ninguno. La visibilidad es principalmente a través de la compartición de archivos. Cuando un colaborador comparte un archivo con una dirección de correo electrónico correspondiente a un miembro registrado por administrador, el colaborador verá el nombre y apellido del miembro después de la compartición, incluso si el colaborador no tiene permiso para ver usuarios registrados por administrador según esta configuración. Esta limitación no se aplica a colaboradores o grupos a los que se ha asignado el estado Privado."
    },
    "aiFileSummary": {
      "title": "Resumen de archivo por IA",
      "description": "Habilitar resumen de archivo por IA para archivos. Esto generará automáticamente un resumen del archivo basado en su contenido.",
      "descriptionInternal": "Habilitar resumen de archivo por IA para archivos. Esto generará automáticamente un resumen del archivo basado en su contenido. <DangerText>Nota: esto solo se aplica a archivos de tamaño inferior a 250 MB.</DangerText>",
      "activeForAllTitle": "Acceso a Resumen de Archivo por IA",
      "activeForAllDescription": "Elegir si los resúmenes de archivo generados por IA están disponibles para todos los usuarios o para ninguno.",
      "exceptionsTitle": "Manejo de excepciones",
      "exceptionsDescription": "Especificar miembros que son excepciones a las restricciones anteriores.",
      "externalUserTitle": "Usuario Externo",
      "externalUserDescription": "Permitir generación de resúmenes por usuarios externos.",
      "filesTypeTitle": "Gestión de Extensiones de Archivo",
      "filesTypeDescription": "Especificar las extensiones de archivo que serán resumidas por la IA.",
      "filesTypePlaceholder": "Seleccionar una o más"
    },
    "aiFileChat": {
      "title": "Chat de archivo por IA",
      "description": "Habilitar chat de archivo por IA para archivos. Esto permitirá a los usuarios chatear con el contenido del archivo.",
      "descriptionInternal": "Habilitar chat de archivo por IA para archivos. Esto permitirá a los usuarios chatear con el contenido del archivo. <DangerText>Nota: esto solo se aplica a archivos de tamaño inferior a 250 MB.</DangerText>",
      "activeForAllTitle": "Acceso a Chat de Archivo por IA",
      "activeForAllDescription": "Elegir si el chat de archivo generado por IA está disponible para todos los usuarios o para ninguno.",
      "exceptionsTitle": "Manejo de excepciones",
      "exceptionsDescription": "Especificar miembros que son excepciones a las restricciones anteriores.",
      "externalUserTitle": "Usuario Externo",
      "externalUserDescription": "Permitir chat con el contenido del archivo por usuarios externos.",
      "filesTypeTitle": "Gestión de Extensiones de Archivo",
      "filesTypeDescription": "Especificar las extensiones de archivo para chatear con la IA.",
      "filesTypePlaceholder": "Seleccionar una o más"
    },
    "aiScraping": {
      "title": "Extracción por IA",
      "description": "Denegar extracción por IA para archivos. Esto denegará cualquier herramienta de IA para extraer el contenido del archivo.",
      "descriptionInternal": "Denegar extracción por IA para archivos. Esto denegará cualquier herramienta de IA para extraer el contenido del archivo. <DangerText>Nota: la extracción por IA se aplica solo a archivos abiertos en modo Read-Only y de tamaño inferior a 250 MB. La protección contra scraping está activa actualmente solo en archivos PDF y Office.</DangerText>",
      "activeForAllTitle": "Ámbito de usuario",
      "activeForAllDescription": "Controla si los usuarios están sujetos a las restricciones establecidas por el administrador. Esta configuración puede definir el alcance de los permisos, las condiciones bajo las cuales se aplican y las posibles excepciones permitidas.",
      "exceptionsTitle": "Manejo de excepciones",
      "exceptionsDescription": "Especificar miembros que son excepciones a las restricciones anteriores.",
      "externalUserTitle": "Usuario Externo",
      "externalUserDescription": "Permitir extracción del contenido del archivo por usuarios externos.",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Aplicar estas reglas solo a archivos con etiquetas específicas",
      "exceptionsRequiredForTags": "Se requieren excepciones para configurar etiquetas"
    },
    "onBehalfMode": {
      "title": "Modo en nombre de",
      "description": "Controlar el modo en nombre de para la plataforma. Esto te permitirá especificar qué colaboradores pueden realizar acciones en nombre de otros colaboradores.",
      "internalTitle": "Acciones de Administrador en Nombre de Usuarios",
      "internalDescription": "Los administradores autorizados pueden ver la lista de archivos de colaboradores y realizar acciones necesarias como mover, eliminar o compartir archivos en nombre de los usuarios. Sin embargo, no pueden abrir o ver el contenido de los archivos, manteniendo la privacidad del usuario. Solo el súper administrador tiene la autoridad para habilitar o deshabilitar esta función para administradores individuales. Esto asegura que solo administradores confiables tengan la capacidad de gestionar archivos de usuarios",
      "activeForAllTitle": "Alcance de Administradores",
      "activeForAllDescription": "Controlar la capacidad de definir si los administradores pueden realizar acciones en nombre de todos los usuarios o ninguno. Esta configuración te permite especificar si los administradores tienen el permiso para gestionar archivos y realizar tareas en nombre de otros usuarios dentro de la plataforma.",
      "exceptionsTitle": "Manejo de excepciones",
      "exceptionsDescription": "Los administradores seleccionados aquí serán excepciones a los permisos 'en nombre de' anteriores."
    },
    "fileSalesPermission": {
      "title": "Permiso de venta de archivos",
      "description": "Permitir a los usuarios vender sus propios archivos a través de la plataforma.",
      "internalTitle": "Habilitar Venta de Archivos para Miembros",
      "activeForAllTitle": "Alcance del Usuario",
      "activeForAllDescription": "Permitir a los miembros vender sus propios archivos a través de la plataforma. Las opciones incluyen habilitar esta función para todos los miembros o ninguno. Los archivos listados para venta serán gestionados por la plataforma, asegurando transacciones seguras y manejo apropiado de pagos.",
      "exceptionsTitle": "Manejo de excepciones",
      "exceptionsDescription": "Especificar usuarios que son excepciones a la función anterior.",
      "externalUserTitle": "Usuario Externo",
      "externalUserDescription": "Permitir venta de archivos por usuarios externos."
    },
    "resharingPermission": {
      "title": "Permiso de re-compartición de archivos",
      "description": "Permite a los usuarios volver a compartir archivos con otros, aplicando reglas basadas en opciones predefinidas y en las etiquetas asignadas a cada archivo. Esto garantiza una distribución controlada del contenido y ayuda a mantener el cumplimiento de las políticas organizacionales.",
      "activeForAllTitle": "Alcance del Usuario",
      "activeForAllDescription": "Controlar si los usuarios están sujetos a restricciones para compartir archivos con opciones específicas y etiquetas establecidas por el administrador. Las opciones incluyen aplicar este permiso a todos los usuarios o a ninguno. Los archivos existentes que ya han sido compartidos permanecerán activos, y los cambios en las etiquetas no afectarán estos archivos previamente compartidos.",
      "exceptionsTitle": "Manejo de excepciones",
      "exceptionsDescription": "Especificar usuarios que son excepciones a la regla anterior.",
      "showUsers": "Mostrar usuarios que ya han recibido acceso de otros.",
      "allowEdit": "Permite a los usuarios cambiar, anular o eliminar configuraciones de compartición existentes.",
      "readOnly": "Habilitar compartición de archivos por usuarios con acceso de solo lectura (Visualizador).",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Aplicar estas reglas solo a archivos con etiquetas específicas",
      "exceptionsRequiredForTags": "Se requieren excepciones para configurar etiquetas"
    },
    "fileVersioningRetentionPolicies": {
      "title": "Versionado de archivos",
      "description": "Configura cómo se retienen las versiones de los archivos. El recuento de retención es obligatorio, mientras que la antigüedad de retención es opcional y puede establecerse en 0.",
      "retentionByCountTitle": "Retención por Cantidad",
      "retentionByCountDescription": "Establece la retención por cantidad: mantén solo las últimas N versiones de cada archivo; las versiones más antiguas se eliminan automáticamente una vez que se alcanza este límite.",
      "retentionByAgeTitle": "Retención por Antigüedad",
      "retentionByAgeDescription": "Establece la retención por antigüedad: elimina las versiones más antiguas que N días; cualquier versión que supere este límite se eliminará automáticamente para evitar el crecimiento descontrolado del almacenamiento."
    },
    "retentionPolicies": {
      "title": "Políticas de retención",
      "description": "Configura cuánto tiempo se mantienen los archivos en la plataforma. Gestiona la eliminación automática de la papelera y define reglas de retención para los archivos activos.",
      "exceptionHandlingTitle": "Gestión de Excepciones",
      "trash": {
        "title": "Retención de papelera",
        "description": "Los archivos movidos a la papelera se eliminan definitivamente después del número de días configurado.",
        "activeForAllTitle": "Ámbito de retención de papelera",
        "activeForAllDescription": "Elige si la retención de la papelera se aplica a todos los usuarios o a ninguno. Los valores de la política siguen siendo editables; usa la lista de excepciones para excluir usuarios o grupos específicos.",
        "retentionDaysTitle": "Días en la Papelera",
        "retentionDaysDescription": "Días que un archivo permanece en la papelera antes de la eliminación definitiva. Debe ser mayor que 0.",
        "exceptionHandlingDescription": "Los usuarios y grupos de esta lista no están sujetos a la retención de la papelera; sus archivos permanecen en la papelera indefinidamente."
      },
      "files": {
        "title": "Retención de archivos",
        "description": "Aplica una regla de retención a los archivos activos. El periodo se calcula desde la fecha elegida abajo (creación o última modificación).",
        "activeForAllTitle": "Ámbito de retención de archivos",
        "activeForAllDescription": "Elige si la retención de archivos se aplica a todos los usuarios o a ninguno. Los valores de la política siguen siendo editables; usa la lista de excepciones para excluir usuarios o grupos específicos.",
        "retentionDaysTitle": "Periodo de Retención (días)",
        "retentionDaysDescription": "Número de días desde la fecha de referencia elegida (creación o modificación) tras los cuales se activa la acción. Debe ser mayor que 0.",
        "retentionTriggerTitle": "Calcular retención desde",
        "retentionTriggerDescription": "Elige si el periodo de retención se calcula desde la creación del archivo o desde su última modificación.",
        "retentionTrigger": {
          "created_at": "Fecha de creación del archivo",
          "updated_at": "Fecha de última modificación"
        },
        "actionOnExpiryTitle": "Acción al Vencimiento",
        "actionOnExpiryDescription": "Qué sucede con los archivos que superan el periodo de retención.",
        "actionOnExpiry": {
          "MoveToTrash": "Mover a la papelera",
          "DeletePermanently": "Eliminar definitivamente",
          "RetainedTagWorkflow": "Aplicar etiqueta *RETAINED, luego eliminar"
        },
        "retainedTag": {
          "title": "Cómo funciona la etiqueta *RETAINED",
          "step1": "Al guardar esta política, el servidor crea una etiqueta de sistema llamada *RETAINED (visible en la lista de etiquetas de la empresa, pero en solo lectura).",
          "step2": "Tras el periodo de retención configurado arriba, la etiqueta *RETAINED se aplica automáticamente a todos los archivos creados hace más de esa cantidad de días.",
          "step3": "Una vez etiquetado, el archivo sigue accesible pero la etiqueta no puede ser eliminada por nadie: la interfaz oculta el control para quitarla y el servidor rechaza cualquier intento de eliminar una etiqueta de sistema.",
          "step4": "Cuando pasan los días indicados abajo desde que se aplicó la etiqueta, el archivo se elimina definitivamente (BD + almacenamiento). Añade usuarios o grupos a las excepciones para excluirlos de todo el flujo."
        },
        "retainedTagDaysTitle": "Días con etiqueta *RETAINED",
        "retainedTagDaysDescription": "Tras aplicar la etiqueta *RETAINED, los archivos se eliminan definitivamente después de este número de días. Debe ser mayor que 0.",
        "tagsTitle": "Aplicar solo a archivos con estas etiquetas",
        "tagsDescription": "Deja vacío para aplicar la política a todos los archivos. Solo se admiten etiquetas públicas.",
        "exceptionHandlingDescription": "Los usuarios y grupos de esta lista no están sujetos a la retención de archivos; sus archivos nunca se mueven a la papelera, se eliminan ni se etiquetan como *RETAINED."
      },
      "deletePermanentlyConfirm": {
        "title": "Confirmar política de eliminación definitiva",
        "description": "<DangerText>Esta acción eliminará DEFINITIVAMENTE todos los archivos de la empresa que superen el periodo de retención. La operación no es reversible.</DangerText>"
      },
      "deletePermanentlySelectWarning": {
        "title": "Eliminación permanente",
        "description": "Al seleccionar esta acción, los archivos que superen el periodo de retención se eliminarán de forma permanente. <DangerText>Esta acción no se puede deshacer y los archivos eliminados no podrán recuperarse.</DangerText><br></br>Para continuar, escribe <DangerText>{{confirmKeyword}}</DangerText> en el campo de abajo."
      },
      "errors": {
        "trashRetentionDays": "Los días en la papelera deben ser mayores que 0.",
        "retentionDays": "El periodo de retención debe ser mayor que 0.",
        "retainedTagDays": "Los días con etiqueta *RETAINED deben ser mayores que 0."
      }
    },
    "mandatoryExpirationSharedFile": {
      "title": "Expiración obligatoria de archivos compartidos",
      "description": "Controla la expiración obligatoria de archivos compartidos. Esto te permitirá especificar qué archivos compartidos deben tener una fecha de expiración.",
      "descriptionInternal": "Esta sección impone límites de tiempo en la compartición de archivos para evitar acceso indefinido. Los administradores pueden requerir una fecha de expiración para cada archivo compartido, establecer una duración máxima permitida y bloquear comparticiones sin fecha de expiración. Estas reglas garantizan que el acceso compartido sea temporal y alineado con los requisitos de seguridad y cumplimiento. <DangerText>Los cambios a estas configuraciones NO se aplican retroactivamente, lo que significa que las comparticiones que exceden los nuevos límites NO se actualizarán.</DangerText>",
      "activeForAllTitle": "Alcance del Usuario",
      "activeForAllDescription": "Controla si los usuarios están sujetos a restricciones establecidas por el administrador. Esta configuración puede definir el alcance de los permisos, las condiciones bajo las cuales se aplican y cualquier excepción permitida. Esto garantiza que la actividad del usuario permanezca alineada con las políticas organizacionales al mismo tiempo que permite flexibilidad cuando sea apropiado.",
      "exceptionsTitle": "Manejo de Excepciones",
      "exceptionsDescription": "Especifica miembros que son excepciones a las restricciones anteriores.",
      "maxAllowedByAgeTitle": "Duración Máxima Permitida",
      "maxAllowedByAgeDescription": "Establece un límite de duración máxima (por ejemplo, 90 días) para cualquier compartición de archivo.",
      "excludedDomainsTitle": "Dominios excluidos",
      "excludedDomainsDescription": "Las comparticiones hacia estos dominios exactos no requieren fecha de expiración. Introduce solo dominios (p. ej. company.com), sin comodines ni URL. Déjalo vacío si no hay exención.",
      "excludedDomainsPlaceholder": "No hay dominios excluidos, haz clic para añadir",
      "excludedGroupsTitle": "Grupos excluidos",
      "excludedGroupsDescription": "Las comparticiones con grupos pueden quedar exentas de la caducidad obligatoria. Elige ninguno, todos los grupos o grupos concretos. La pertenencia de un usuario a un grupo exento no exime las comparticiones de usuario.",
      "excludedGroupsModeNone": "Ningún grupo exento",
      "excludedGroupsModeAll": "Todos los grupos exentos",
      "excludedGroupsModeSome": "Solo los grupos seleccionados exentos",
      "excludedGroupsPlaceholder": "Selecciona grupos exentos",
      "excludedGroupsExceptionsTitle": "Grupos que siguen sujetos",
      "excludedGroupsExceptionsPlaceholder": "Selecciona grupos que aún requieren caducidad",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Aplica el límite de tiempo de compartición solo a archivos con etiquetas específicas.",
      "tagsRequired": "Se requiere al menos una etiqueta cuando hay múltiples reglas",
      "exceptionsRequiredForTags": "Se requieren excepciones para configurar etiquetas"
    },
    "fileTagManagement": {
      "title": "Reglas de eliminación de etiquetas",
      "description": "Define qué etiquetas no se pueden eliminar de los archivos. Los usuarios sujetos a una regla no pueden eliminar las etiquetas seleccionadas de los archivos; se pueden conceder excepciones a la regla por usuario o grupo.",
      "activeForAllTitle": "Alcance del Usuario",
      "activeForAllDescription": "Controlar si los usuarios están sujetos a restricciones en la eliminación de etiquetas como lo define el administrador. Las etiquetas existentes en archivos permanecerán sin cambios, y las actualizaciones de permisos no afectarán las etiquetas previamente aplicadas.",
      "exceptionsTitle": "Manejo de excepciones",
      "exceptionsDescription": "Especificar usuarios que son excepciones a la regla anterior.",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Etiquetas que no se pueden eliminar de los archivos. Deja vacío para proteger todas las etiquetas.",
      "tagsRequired": "Se requiere al menos una etiqueta cuando hay múltiples reglas"
    },
    "fileTagAdditionRestriction": {
      "title": "Reglas de adición de etiquetas",
      "description": "Define qué etiquetas no se pueden añadir a los archivos. Los usuarios sujetos a una regla no pueden añadir las etiquetas seleccionadas a los archivos; se pueden conceder excepciones a la regla por usuario o grupo.",
      "exceptionsTitle": "Manejo de excepciones",
      "exceptionsDescription": "Especificar usuarios que son excepciones a la regla anterior.",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Etiquetas que no se pueden añadir a los archivos. Deja vacío para restringir todas las etiquetas.",
      "tagsRequired": "Se requiere al menos una etiqueta cuando hay múltiples reglas"
    },
    "externalFileSharingRestriction": {
      "title": "Restricciones de compartición externa",
      "description": "Esta sección permite a los administradores decidir si los colaboradores pueden compartir archivos fuera de la organización y bajo qué condiciones. El uso compartido puede estar completamente habilitado, deshabilitado o limitado a dominios específicos de confianza. Las reglas también pueden restringir el uso compartido externo en función de las etiquetas de los archivos o permitir que ciertos remitentes y destinatarios omitan las políticas de Prevención de Pérdida de Datos (DLP). Estos controles ayudan a proteger la información confidencial y garantizan que las colaboraciones externas se realicen únicamente con partes aprobadas.",
      "descriptionInternal": "Esta sección permite a los administradores decidir si los colaboradores pueden compartir archivos fuera de la organización y bajo qué condiciones. El uso compartido puede estar completamente habilitado, deshabilitado o limitado a dominios específicos de confianza. Las reglas también pueden restringir el uso compartido externo en función de las etiquetas de los archivos o permitir que ciertos remitentes y destinatarios omitan las políticas de Prevención de Pérdida de Datos (DLP). Estos controles ayudan a proteger la información confidencial y garantizan que las colaboraciones externas se realicen únicamente con partes aprobadas.",
      "activeForAllTitle": "Alcance del Usuario",
      "activeForAllDescription": "Controlar si los usuarios están sujetos a restricciones establecidas por el administrador. Esta configuración puede definir el alcance de los permisos, las condiciones bajo las cuales se aplican, y cualquier excepción permitida. Esto asegura que la actividad de los usuarios permanezca alineada con las políticas organizacionales mientras se permite flexibilidad donde sea apropiado.",
      "exceptionsTitle": "Manejo de excepciones",
      "exceptionsDescription": "Especificar miembros que son excepciones a la regla anterior.",
      "approvedDomainsTitle": "Dominios Aprobados Solo",
      "approvedDomainsDescription": "Limita la compartición a una lista de dominios aprobados.",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Permite compartir con dominios externos solo para archivos que tienen etiquetas específicas.",
      "tagsRequired": "Se requiere al menos una etiqueta cuando hay múltiples reglas",
      "exceptionsRequiredForTags": "Se requieren excepciones para configurar etiquetas",
      "approvedDomainsPlaceholder": "No hay dominios aprobados, haz clic para añadir"
    },
    "secureFileLocalAccess": {
      "title": "Acceso seguro a archivos locales",
      "description": "Control el acceso seguro a archivos locales. Esto te permitirá especificar qué archivos pueden ser accedidos localmente.",
      "descriptionInternal": "Esta configuración define cómo se pueden abrir documentos localmente (en Windows o macOS) a través del agente de una manera segura y cifrada. Si un usuario tiene los permisos requeridos, puede abrir archivos protegidos con las aplicaciones autorizadas, garantizando la conformidad con las políticas de Prevención de Pérdida de Datos (DLP).",
      "activeForAllTitle": "Alcance del Usuario",
      "activeForAllDescription": "Controlar si los usuarios están sujetos a restricciones establecidas por el administrador. Esta configuración puede definir el alcance de los permisos, las condiciones bajo las cuales se aplican, y cualquier excepción permitida. Esto asegura que la actividad de los usuarios permanezca alineada con las políticas organizacionales mientras se permite flexibilidad donde sea apropiado.",
      "exceptionsTitle": "Manejo de excepciones",
      "exceptionsDescription": "Especificar miembros que son excepciones a la regla anterior.",
      "tagsTitle": "Tags",
      "tagsDescription": "Aplicar estas regulas solo a archivos con etiquetas específicas",
      "tagsRequired": "Al menos una etiqueta es requerida cuando hay múltiples reglas",
      "exceptionsRequiredForTags": "Se requieren excepciones para configurar etiquetas",
      "restrictionsTitle": "Restricciones",
      "restrictionsDescription": "Define qué acciones de usuario están limitadas cuando acceden a documentos protegidos:",
      "restrictCopyPaste": "Restringir las operaciones de copia-pegado",
      "restrictCopyPasteDescription": "Restringir las operaciones de copia-pegado para archivos con etiquetas específicas.",
      "restrictPrint": "Restringir la impresión",
      "restrictPrintDescription": "Restringir la impresión para archivos con etiquetas específicas.",
      "restrictAppInternetAccess": "Restringir el acceso a Internet de la aplicación",
      "restrictAppInternetAccessDescription": "Restringir el acceso a Internet de la aplicación para archivos con etiquetas específicas.",
      "restrictScreenCapture": "Restringir la captura de pantalla",
      "restrictScreenCaptureDescription": "Restringir la captura de pantalla para archivos con etiquetas específicas.",
      "localAccessSettingsTitle": "Configuración de acceso local",
      "localAccessSettingsDescription": "Configure cómo los usuarios pueden abrir y trabajar con archivos protegidos en sus dispositivos:",
      "defaultLocalFileOpen": "Apertura de archivo local predeterminada",
      "defaultLocalFileOpenDescription": "Elegir si abrir archivos protegidos con la aplicación predeterminada o con la aplicación especificada en el campo 'Aplicaciones permitidas'.",
      "allowedApplicationsTitle": "Aplicaciones permitidas",
      "allowedApplicationsDescription": "Elegir las aplicaciones que son permitidas para abrir archivos protegidos.",
      "offlineMode": "Habilitar el acceso a archivos cuando no hay conexión a Internet",
      "offlineModeDescription": "Almacenar el certificado localmente permite descifrar archivos sin conexión. Los contenidos de los archivos pueden exponerse si el usuario local tiene acceso al certificado almacenado"
    },
    "tagBasedAccessControl": {
      "title": "Visibilidad de archivos con etiquetas",
      "description": "Gestiona el acceso a documentos mediante etiquetas (ej. Público), otorgando visibilidad a todos los usuarios o invitados externos, con permisos opcionales de solo lectura o lectura/escritura y protección por contraseña.",
      "descriptionInternal": "Controla el acceso a documentos usando etiquetas de usuario o grupo para simplificar la búsqueda y la gestión de políticas. Las etiquetas (como Público) pueden ampliar la visibilidad, ya sea a todos los usuarios registrados (Público Interno) o a invitados externos no autenticados (Cualquiera), con permisos opcionales de solo lectura o lectura/escritura y protección por contraseña.",
      "activeForAllTitle": "Ámbito de Usuarios",
      "activeForAllDescription": "Controla si los usuarios están sujetos a las restricciones definidas por el administrador. Esta configuración define el alcance de los permisos, las condiciones bajo las que se aplican y las excepciones permitidas. Garantiza que la actividad de los usuarios se mantenga alineada con las políticas organizativas, manteniendo la flexibilidad cuando sea apropiado.",
      "exceptionsTitle": "Gestión de Excepciones",
      "exceptionsDescription": "Especifica los miembros que constituyen excepciones a la regla anterior.",
      "accessPolicyTagsTitle": "Etiquetas de Políticas de Acceso",
      "accessPolicyTagsDescription": "Define qué etiquetas controlan la visibilidad y el acceso a los documentos.",
      "accessPolicyTagsRequired": "Se requieren etiquetas de política de acceso",
      "audienceTitle": "Audiencia",
      "audienceDescription": "Define quién puede acceder a los documentos etiquetados.",
      "registeredUsers": "Usuarios Registrados",
      "unregisteredUsers": "Usuarios No Registrados",
      "admin": "Administrador",
      "contributors": "Contribuidores",
      "readers": "Lectores",
      "external": "Externos",
      "readAndWrite": "Lectura y Escritura",
      "readOnly": "Solo Lectura",
      "passwordRequired": "Requerir contraseña para el acceso",
      "setLinkExpiration": "Establecer vencimiento del enlace (fecha/hora)",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Permite compartir con dominios externos solo para archivos con etiquetas específicas.",
      "tagsRequired": "Se requiere al menos una etiqueta cuando existen múltiples reglas.",
      "exceptionsRequiredForTags": "Se requieren excepciones para configurar etiquetas."
    },
    "contributorStorageLimit": {
      "title": "Limitaciones de almacenamiento",
      "allocationTitle": "Asignación de Almacenamiento para Colaboradores",
      "allocationDescription": "Define el espacio de almacenamiento disponible para los colaboradores para subir y compartir archivos. Esta opción te permite establecer límites de almacenamiento específicos para colaboradores o elegir \"Limitado por Licencia\" para almacenamiento que está vinculado al espacio total comprado por la empresa bajo su licencia."
    },
    "deviceAccessLimitation": {
      "title": "Manejo de conexiones simultáneas",
      "browsersTitle": "Navegadores",
      "browsersDescription": "Establecer el número de conexiones simultáneas que cada miembro puede hacer a Filegrant Enterprise vía diferentes navegadores usando la aplicación web",
      "exceedingConnectionsTitle": "Excediendo Conexiones de Navegador",
      "exceedingConnectionsDescription": "Especificar la acción a tomar cuando el número de navegadores conectados excede el límite permitido.",
      "invalidateOldSessionsOption": "Invalidar automáticamente el token de sesión de las conexiones más antiguas.",
      "blockAccessOption": "Denegar acceso hasta que las sesiones más antiguas sean desconectadas manualmente o expiren."
    },
    "editorFileManagement": {
      "title": "Control de gestión de archivos de colaboradores",
      "subtitle": "Controlar los permisos para que los colaboradores eliminen y renombren archivos y carpetas dentro de sus cuentas. Las opciones incluyen permitir a todos los colaboradores o ninguno, con acciones restringidas a archivos que han subido o recibido con acceso de editor.",
      "deletionPermissionsTitle": "Permisos de Eliminación",
      "deletionPermissionsDescription": "Controlar si los colaboradores pueden eliminar archivos. Las opciones incluyen permitir o no permitir a los colaboradores eliminar archivos que han subido o recibido con acceso de editor.",
      "userScopeTitle": "Alcance del Usuario",
      "userScopeDescription": "Controlar la aplicación de los permisos anteriores a todos los colaboradores o ninguno.",
      "exceptionHandlingTitle": "Manejo de Excepciones",
      "exceptionHandlingDescription": "Especificar usuarios que son excepciones a los permisos anteriores. Estos usuarios tendrán acceso personalizado para eliminar y renombrar archivos y carpetas independientemente de las configuraciones generales."
    },
    "fileSizeLimit": {
      "title": "Límite de tamaño de archivo por miembro",
      "limitTitle": "Limitación de Tamaño de Archivo",
      "limitDescription": "Define el tamaño máximo de archivo que los miembros pueden subir. Esta configuración te permite controlar el tamaño de archivo más grande que puede añadirse a la plataforma por cualquier miembro, asegurando un uso eficiente del espacio de almacenamiento y manteniendo un rendimiento óptimo."
    },
    "quickShareMode": {
      "title": "Quick Share",
      "description": "Gestiona la configuración de Compartición Rápida. Controla activación, apertura por defecto tras el login y duración máxima de compartición.",
      "isVisibleTitle": "Visible",
      "isVisibleDescription": "Activa o desactiva Compartición Rápida para los usuarios",
      "activeForAllTitle": "Acceso a Compartición Rápida",
      "activeForAllDescription": "Elige si Compartición Rápida está disponible para todos los usuarios o para ninguno.",
      "exceptionsTitle": "Gestión de excepciones",
      "exceptionsDescription": "Especifica los miembros que son excepciones a la regla anterior.",
      "showQuickShareByDefaultTitle": "Mostrar Compartición Rápida por defecto",
      "showQuickShareByDefaultDescription": "Haz que Compartición Rápida sea la página de inicio por defecto tras el login",
      "maxSharingDaysTitle": "Duración máxima de compartición (días)",
      "maxSharingDaysDescription": "Indica cuántos días dura la compartición. Las comparticiones caducan automáticamente tras el número de días seleccionado (máximo 365).",
      "enabledTitle": "Activar Compartición Rápida",
      "enabledDescription": "Cuando está activada, los usuarios pueden compartir archivos mediante Compartición Rápida. Cuando está desactivada, la función no está disponible.",
      "daysTitle": "Duración máxima de compartición",
      "daysDescription": "Tras este número de días el enlace del archivo compartido caducará y se eliminará la compartición.",
      "daysOption1": "Compartición durante 1 día",
      "daysOption3": "Compartición durante 3 días",
      "daysOption7": "Compartición durante 7 días",
      "daysOption14": "Compartición durante 14 días",
      "daysOption30": "Compartición durante 30 días",
      "daysOption90": "Compartición durante 90 días"
    },
    "totpRequired": {
      "title": "Autenticación de dos factores (TOTP)",
      "description": "Configura TOTP 2FA a nivel de empresa. Exige TOTP para todos los usuarios, establece un período de gracia para nuevas cuentas y permite a los administradores restablecer el TOTP de los usuarios.",
      "requiredTitle": "Requerir TOTP para todos los usuarios",
      "requiredDescription": "Cuando está activado, todos los usuarios deben configurar TOTP. Los nuevos usuarios tienen un período de gracia para activarlo tras la creación de la cuenta.",
      "gracePeriodDaysTitle": "Período de gracia (días)",
      "gracePeriodDaysDescription": "Los usuarios tienen este número de días desde la creación de la cuenta para activar TOTP antes de que se bloquee el inicio de sesión.",
      "allowAdminResetTitle": "Permitir a los administradores restablecer el TOTP del usuario",
      "allowAdminResetDescription": "Cuando está activado, los administradores pueden desactivar el TOTP de usuarios que hayan perdido el acceso a su aplicación de autenticación.",
      "maxExemptionDaysTitle": "Días máximos de exención",
      "maxExemptionDaysDescription": "Número máximo de días (1–365) para una exención TOTP temporal cuando un administrador la concede. Por defecto 30.",
      "allowPermanentExemptionTitle": "Permitir exenciones permanentes",
      "allowPermanentExemptionDescription": "Cuando está activado, los administradores pueden conceder exenciones TOTP permanentes (sin caducidad). Cuando está desactivado, solo se permiten exenciones temporales.",
      "gracePeriodOption0": "Sin período de gracia (inmediato)",
      "gracePeriodOption1": "1 día",
      "gracePeriodOption3": "3 días",
      "gracePeriodOption7": "7 días (recomendado)",
      "gracePeriodOption14": "14 días",
      "gracePeriodOption30": "30 días"
    },
    "passkeySettings": {
      "allowAdminRemoveDescription": "Si está activado, los administradores pueden eliminar passkeys concretas o borrar todas las credenciales de un usuario desde las herramientas de administración.",
      "allowAdminRemoveTitle": "Permitir a los administradores eliminar passkeys de usuarios",
      "allowAs2faDescription": "Si está activado, los usuarios que completen el OTP por correo pueden finalizar el inicio de sesión con una passkey en lugar de TOTP, según el registro y otras políticas.",
      "allowAs2faTitle": "Permitir passkeys como segundo factor",
      "allowPasswordlessDescription": "Si está activado, los usuarios elegibles pueden iniciar sesión con passkey sin OTP por correo. Requiere que las passkeys como segundo factor estén permitidas.",
      "allowPasswordlessTitle": "Permitir inicio de sesión sin contraseña con passkey",
      "attestationOptionDirect": "Directa",
      "attestationOptionIndirect": "Indirecta",
      "attestationOptionNone": "Ninguna (habitual en la mayoría de organizaciones)",
      "attestationPreferenceDescription": "Grado en que el servidor solicita attestación durante el registro. Valores más altos pueden aumentar la garantía pero reducir la compatibilidad de autenticadores.",
      "attestationPreferenceTitle": "Preferencia de attestación",
      "authenticatorAttachmentAny": "Cualquiera (sin restricción)",
      "authenticatorAttachmentCrossPlatform": "Multiplataforma (p. ej. llave de seguridad)",
      "authenticatorAttachmentDescription": "Restringe opcionalmente el registro a autenticadores de plataforma en este dispositivo, llaves de seguridad multiplataforma o sin restricción para máxima compatibilidad.",
      "authenticatorAttachmentPlatform": "Plataforma (este dispositivo)",
      "authenticatorAttachmentTitle": "Tipo de autenticador (opcional)",
      "description": "Configure las passkeys (WebAuthn) a nivel de organización: activación, segundo factor frente a inicio sin contraseña, límites por usuario, eliminación por administradores y preferencias de la ceremonia de registro.",
      "enabledDescription": "Si está desactivado, el registro de passkeys y el inicio de sesión basado en passkey no estarán disponibles bajo esta política.",
      "enabledTitle": "Activar passkeys para la organización",
      "maxCredentialsPerUserDescription": "Número máximo de passkeys que cada usuario puede registrar (1–50). Limita la proliferación y el soporte.",
      "maxCredentialsPerUserTitle": "Máximo de passkeys por usuario",
      "title": "Passkeys (WebAuthn)",
      "userVerificationDescription": "Qué tan estrictamente el autenticador debe verificar al usuario al registrar una passkey. Requerido es el más estricto; desalentado el más débil.",
      "userVerificationOptionDiscouraged": "Desalentado",
      "userVerificationOptionPreferred": "Preferido",
      "userVerificationOptionRequired": "Requerido",
      "userVerificationTitle": "Verificación de usuario en el registro"
    },
    "antivirusScan": {
      "title": "Análisis antivirus",
      "description": "Configure qué tipos de archivo subidos analiza el motor antivirus. El filtro de extensiones controla el coste, no la política de seguridad.",
      "enabledTitle": "Activar análisis antivirus",
      "enabledDescription": "Si está activo, las subidas coincidentes se analizan de forma asíncrona. Si está desactivado, las nuevas subidas no se analizan, pero los veredictos existentes permanecen en los archivos.",
      "extensionsTitle": "Extensiones de archivo analizadas",
      "extensionsDescription": "Solo se envían al escáner los archivos cuya extensión esté en la lista. Restrinja la lista para reducir volumen y coste.",
      "extensionsPlaceholder": "Seleccionar extensiones a analizar",
      "costNoticeTitle": "El filtro de extensiones controla el coste",
      "costNoticeDescription": "Analizar más extensiones aumenta el uso del antivirus. Este ajuste no sustituye otros controles de seguridad.",
      "saveError": "Ajustes de análisis antivirus no válidos. Active el análisis solo con al menos una extensión seleccionada.",
      "stickyInfectedNote": "Desactivar el análisis no borra los veredictos infectados existentes ni quita archivos de la cuarentena."
    },
    "activityLogRetention": {
      "title": "Retención del registro de actividad",
      "description": "Define cuánto tiempo conserva la empresa su registro de actividad. Una vez transcurrido el periodo de retención desde la creación de una entrada, la entrada se elimina de forma permanente.",
      "activeTitle": "Política de retención",
      "activeDescription": "Cuando está deshabilitada, el registro de actividad se conserva indefinidamente y nunca se elimina nada.",
      "windowTitle": "Periodo de retención",
      "windowDescription": "Las entradas del registro más antiguas que este periodo se eliminan de forma permanente. Rango permitido: de {{min}} meses a {{max}} años.",
      "warningTitle": "La eliminación es permanente y retroactiva",
      "warningDescription": "Al habilitar la política también se eliminan las entradas que ya superan el periodo de retención. Las entradas eliminadas no se pueden recuperar: exporta el registro de actividad antes si necesitas conservar una copia."
    },
    "securityAnalysis": {
      "title": "Executive Report & Security Notification",
      "description": "Configuración única para el Executive Report (dominios internos, umbrales de los indicadores de riesgo), para los umbrales de detección de anomalías de seguridad y para las notificaciones por correo de las anomalías detectadas.",
      "enableTitle": "Habilitar notificaciones por correo",
      "enableDescription": "Si está activo, se envía un correo a los destinatarios seleccionados para las nuevas anomalías de seguridad con severidad igual o superior a la elegida.",
      "recipientsTitle": "Destinatarios",
      "recipientsDescription": "Usuarios y grupos de la plataforma que recibirán las notificaciones. Para los grupos se notifica a todos los miembros.",
      "recipientsPlaceholder": "Buscar usuarios o grupos",
      "minSeverityTitle": "Severidad mínima",
      "minSeverityDescription": "Enviar notificaciones solo a partir de esta severidad. Warning incluye Warning y Critical; Critical envía solo Critical.",
      "severityWarning": "Warning y superiores",
      "severityCritical": "Solo Critical",
      "domainsTitle": "Dominios internos",
      "domainsDescription": "Lista de dominios de correo separados por comas considerados internos cuando el Executive Report distingue el uso compartido interno del externo. Si está vacío, se usa el dominio de correo del primer administrador.",
      "domainsPlaceholder": "empresa.com, filial.com",
      "domainsError": "Uno o más dominios no tienen un formato válido (p. ej. empresa.com).",
      "thresholdsTitle": "Umbrales de indicadores de riesgo",
      "thresholdsDescription": "Umbrales porcentuales que definen qué se considera warning y qué se considera critical para cada indicador de riesgo del Executive Report.",
      "warningLabel": "Warning ≥",
      "criticalLabel": "Critical ≥",
      "thresholdError": "El umbral warning debe ser inferior al umbral critical.",
      "detectorThresholdsTitle": "Umbrales de detección de anomalías",
      "detectorThresholdsDescription": "Recuentos de eventos que definen qué se considera warning y qué se considera critical para cada detector de anomalías de seguridad. Los detectores sin umbrales numéricos (IP de administrador bloqueada, señales de seguridad explícitas) no son personalizables.",
      "detectorThresholdError": "El umbral warning debe ser inferior al umbral critical.",
      "detectors": {
        "bruteForceLogin": "Inicios de sesión fallidos en la misma cuenta (ventana de 15 min)",
        "folderPassword": "Intentos fallidos de contraseña de carpeta (por carpeta y usuario)",
        "publicLinkBruteForce": "Accesos fallidos a enlaces públicos (por enlace e IP)",
        "massDownload": "Archivos descargados por un usuario (ventana de 60 min)",
        "passwordSpray": "Password spray: cuentas distintas intentadas desde una IP",
        "unauthorizedCountry": "Accesos bloqueados desde país no autorizado (por usuario y país)"
      }
    },
    "ipRegionRestriction": {
      "title": "Restricción por IP/región",
      "description": "Restringir el acceso a la plataforma según dirección IP, país o región",
      "warningMessage": "Advertencia: Esta configuración bloquea a todos los usuarios que no cumplan los criterios",
      "warningDescription": "Los usuarios fuera de las IPs, países o regiones permitidos no podrán acceder. Configure excepciones para usuarios o grupos específicos.",
      "confirmTitle": "Confirmar Configuración",
      "confirmWarning": "Esta configuración restringirá el acceso. Los usuarios fuera de las IPs, países o regiones permitidos no podrán acceder. ¿Estás seguro?",
      "scopeTitle": "Alcance de Aplicación",
      "scopeDescription": "¿Cuándo debe aplicarse esta restricción?",
      "scopeLogin": "Solo Inicio de Sesión",
      "scopeFileOps": "Solo Operaciones de Archivos",
      "scopeBoth": "Ambos (Recomendado)",
      "allowedIpsTitle": "Direcciones IP / Rangos CIDR Permitidos",
      "allowedIpsDescription": "Lista separada por comas de IPs o rangos CIDR (IPv4/IPv6)",
      "allowedCountriesTitle": "Países Permitidos",
      "allowedCountriesDescription": "Seleccionar países (códigos ISO 3166-1 alpha-2)",
      "allowedRegionsTitle": "Regiones Permitidas",
      "allowedRegionsDescription": "Seleccionar regiones (códigos ISO 3166-2 o 'EU' para Unión Europea)",
      "allowPrivateNetworksTitle": "Permitir Redes Privadas",
      "allowPrivateNetworksDescription": "Omitir restricción para rangos de IP privadas (10.x, 192.168.x, 172.16-31.x)",
      "adminAccessSectionTitle": "Acceso de administración",
      "restrictAdminAccessTitle": "Restringir configuración de administración por IP",
      "restrictAdminAccessDescription": "Permitir el acceso a la configuración de administración solo desde las direcciones IP o rangos CIDR especificados",
      "adminAllowedIpsTitle": "Direcciones IP permitidas para administración",
      "adminAllowedIpsDescription": "Lista separada por comas de IPs o rangos CIDR autorizados para abrir la configuración de administración",
      "addAdminIp": "Añadir IP",
      "addAllowedIp": "Añadir IP o CIDR",
      "logBlockedAttemptsTitle": "Registrar Intentos Bloqueados",
      "logBlockedAttemptsDescription": "Registrar todos los intentos de acceso denegado en el registro de actividad",
      "blockedMessageTitle": "Mensaje Personalizado de Bloqueo",
      "blockedMessageDescription": "Mensaje mostrado a los usuarios bloqueados (máx. 200 caracteres)",
      "blockedMessagePlaceholder": "Acceso denegado desde tu ubicación.",
      "exceptionsTitle": "Excepciones",
      "exceptionsDescription": "Usuarios o grupos con criterios de acceso adicionales",
      "validationAtLeastOne": "Se debe especificar al menos un criterio (IP, país o región)",
      "validationInvalidIp": "Formato de IP/CIDR no válido: {{entries}}",
      "validationInvalidCountry": "Códigos de país no válidos: {{codes}}",
      "validationInvalidRegion": "Códigos de región no válidos: {{codes}}",
      "adminAllowedIpsHelper": "Solo IP/CIDR: sin geolocalización, sin excepción para redes privadas, y las excepciones anteriores no se aplican aquí."
    },
    "fileTypeRestriction": {
      "title": "Control de restricción de tipo de archivo",
      "description": "Permite definir qué tipos de archivos están bloqueados para la carga.",
      "blockedExtensionsTitle": "Extensiones de Archivo Bloqueadas",
      "blockedExtensionsDescription": "Especifica qué extensiones de archivo están bloqueadas. Esto te permite definir exactamente qué tipos de archivos están sujetos a las restricciones.",
      "userScopeTitle": "Alcance del Usuario",
      "userScopeDescription": "Controla si los usuarios serán bloqueados para subir o compartir archivos en la plataforma de acuerdo con el tipo de archivo especificado definido anteriormente. Las opciones incluyen bloquear a todos los usuarios o a ninguno. Los archivos existentes subidos o compartidos permanecerán activos incluso si el permiso es revocado posteriormente.",
      "exceptionHandlingTitle": "Manejo de Excepciones",
      "exceptionHandlingDescription": "Especificar usuarios que son excepciones a la función anterior.",
      "activeForAllTitle": "Alcance del Usuario",
      "activeForAllDescription": "Controla si los usuarios están sujetos a las restricciones establecidas por el administrador. Esta configuración puede definir el alcance de los permisos, las condiciones bajo las cuales se aplican y cualquier excepción permitida.",
      "exceptionsTitle": "Manejo de Excepciones",
      "exceptionsDescription": "Especifica los usuarios que son excepciones a las restricciones anteriores.",
      "showUsers": "Mostrar usuarios que ya han recibido acceso otorgado por otros.",
      "allowEdit": "Permite que los usuarios cambien, sobrescriban o eliminen configuraciones de compartición existentes.",
      "readOnly": "Permitir el uso compartido de archivos por parte de usuarios con acceso solo de lectura (Visualizador).",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Aplicar estas reglas solo a archivos con etiquetas específicas.",
      "exceptionsRequiredForTags": "Se requieren excepciones para configurar etiquetas.",
      "tagsRequired": "Se requiere al menos una etiqueta cuando existen múltiples reglas.",
      "fileTypesTitle": "Tipos de Archivo",
      "fileTypesDescription": "Selecciona los tipos de archivos sujetos a esta regla.",
      "fileTypesPlaceholder": "Selecciona tipos de archivo o extensiones"
    },
    "folderCreationPermission": {
      "title": "Limitaciones de carpeta",
      "creationTitle": "Creación de Carpetas por Colaboradores",
      "creationDescription": "Controlar qué colaboradores pueden crear carpetas en la plataforma. Las opciones incluyen permitir a todos los colaboradores o ninguno. Las carpetas existentes permanecen accesibles incluso si el permiso es revocado posteriormente.",
      "exceptionHandlingTitle": "Manejo de Excepciones",
      "exceptionHandlingDescription": "Especificar usuarios que son excepciones a la función anterior."
    },
    "groupCreationControl": {
      "title": "Limitaciones de grupo",
      "creationTitle": "Creación de Grupos por Colaboradores",
      "creationDescription": "Controlar qué colaboradores pueden crear grupos en la plataforma. Las opciones incluyen permitir a todos los colaboradores o ninguno. Los grupos creados son visibles solo para el usuario que los creó. Los grupos existentes permanecen accesibles incluso si el permiso es revocado posteriormente.",
      "exceptionHandlingTitle": "Manejo de Excepciones",
      "exceptionHandlingDescription": "Especificar usuarios que son excepciones a la función anterior."
    },
    "publicAccessLink": {
      "title": "Enlace de acceso público",
      "description": "Controlar la capacidad de los colaboradores para generar enlaces para acceder a archivos y carpetas sin autenticación. Las opciones incluyen permitir a todos los miembros o ninguno crear estos enlaces. Los enlaces existentes permanecerán activos incluso si el permiso es revocado posteriormente.",
      "activeForAllTitle": "Generación de enlaces por colaboradores",
      "activeForAllDescription": "Controlar la capacidad de los colaboradores para generar enlaces para acceder a archivos y carpetas sin autenticación. Las opciones incluyen permitir a todos los miembros o ninguno crear estos enlaces. Los enlaces existentes permanecerán activos incluso si el permiso es revocado posteriormente.",
      "exceptionHandlingTitle": "Manejo de excepciones",
      "exceptionHandlingDescription": "Especificar colaboradores que son excepciones a los permisos de generación de enlaces anteriores.",
      "forcePasswordTitle": "Forzar contraseña",
      "forcePasswordDescription": "Si está activo, el usuario debe establecer una contraseña al crear un enlace público.",
      "mandatoryMaxAccessCountTitle": "Número máximo de accesos obligatorio",
      "mandatoryMaxAccessCountDescription": "Si es mayor que 0, el usuario debe especificar un número máximo de accesos (0–10000). 0 = no obligatorio.",
      "maxExpirationDaysTitle": "Días máximos de expiración",
      "maxExpirationDaysDescription": "Si es mayor que 0, el usuario debe establecer una expiración dentro de este número de días (0–365). 0 = sin restricción. <br /> <DangerText> Si «Expiración obligatoria de archivos compartidos» está activada, la fecha de expiración definida en esa configuración tendrá prioridad sobre los días máximos de expiración configurados aquí. </DangerText>",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Solo se podrán crear enlaces públicos para archivos que tengan estas etiquetas aplicadas."
    },
    "sessionControl": {
      "title": "Límite de sesiones concurrentes",
      "description": "Limita el número de sesiones activas por usuario. Cuando un usuario supera el límite, la sesión más antigua se cierra automáticamente.",
      "maxSessionsTitle": "Sesiones Máximas",
      "maxActiveSessions": "Sesiones activas máximas",
      "maxSessionsDescription": "Establece el número máximo de sesiones concurrentes permitidas por usuario. Cuando se alcanza el límite, la sesión más antigua se desconecta automáticamente.",
      "unlimited": "Sin límite",
      "exceptionsTitle": "Excepciones",
      "exceptionsDescription": "Personaliza el límite de sesiones para usuarios o grupos específicos.",
      "pendingExceptionsTitle": "Excepciones pendientes",
      "savedExceptionsTitle": "Excepciones guardadas",
      "selectUsersOrGroups": "Seleccionar usuarios o grupos..."
    },
    "uploadWithTag": {
      "title": "Gestión automática de etiquetas",
      "description": "Filegrant Enterprise escaneará los metadatos de los archivos clasificados subidos en busca de palabras clave específicas. Si se detecta alguna de las palabras clave especificadas, el valor correspondiente se aplicará al archivo como una etiqueta. Si una etiqueta no existe ya en la plataforma, se crea automáticamente. Este proceso asegura que cada archivo esté apropiadamente categorizado y etiquetado basándose en su contenido.",
      "keywordsTitle": "Palabras Clave",
      "keywordsDescription": "Especificar las palabras clave cuyos valores serán utilizados como etiquetas para el archivo después de la subida.",
      "userScopeTitle": "Alcance del Usuario",
      "userScopeDescription": "Controlar si los miembros están sujetos a detección automática de etiquetas para subidas de archivos en la plataforma. Las opciones incluyen aplicar esto a todos los miembros o ninguno. Los archivos existentes que ya han sido subidos y etiquetados permanecerán activos, y los cambios en las palabras clave no afectarán estos archivos previamente etiquetados.",
      "exceptionHandlingTitle": "Manejo de Excepciones",
      "exceptionHandlingDescription": "Especificar usuarios que son excepciones a la función anterior."
    },
    "watermarkProtection": {
      "title": "Habilitar protección de marca de agua para miembros",
      "description": "Controla la protección con marca de agua para archivos compartidos. Habilita para todos los miembros o ninguno, gestiona excepciones y configura qué datos aparecen en la marca de agua (ej. fecha de compartición, propietario, destinatario, fecha de creación, IP).",
      "descriptionInternal": "Controla la protección con marca de agua para archivos compartidos. Habilita para todos los miembros o ninguno, gestiona excepciones y configura qué datos aparecen en la marca de agua (ej. fecha de compartición, propietario, destinatario, fecha de creación, IP). <DangerText>Por el momento, las marcas de agua se aplican a archivos PDF e imágenes (jpeg, png, svg), y únicamente a los destinatarios que reciben archivos Office (doc, docx, ppt, pptx, xls, xlsx) en modo de solo lectura.</DangerText>",
      "enabledTitle": "Habilitado",
      "enabledDescription": "Activa o desactiva esta configuración.",
      "userScopeTitle": "Alcance del Usuario",
      "userScopeDescription": "Permitir a los miembros proteger sus archivos con marcas de agua. Las opciones incluyen habilitar esta función para todos los miembros o ninguno. Las marcas de agua se pueden aplicar al momento de compartir. Cuando los destinatarios abran el documento, la marca de agua mostrará su dirección de correo electrónico, dirección IP y la fecha de acceso al documento, asegurando la protección y seguimiento del contenido.",
      "activeForAllTitle": "Alcance del Usuario",
      "activeForAllDescription": "Aplicar protección con marca de agua a todos los miembros o a ninguno. Si está en ninguno, puedes dirigir miembros específicos mediante excepciones y etiquetas.",
      "exceptionHandlingTitle": "Manejo de Excepciones",
      "exceptionHandlingDescription": "Especificar usuarios que son excepciones a la función anterior.",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Aplicar protección con marca de agua solo a archivos con estas etiquetas.",
      "previewTitle": "Vista previa",
      "textLabel": "Texto de la marca de agua",
      "repetitionLabel": "Repetición",
      "repetitionSingle": "Único",
      "repetitionRepetitive": "Repetitivo",
      "fieldsLabel": "Campos a mostrar",
      "fieldsSharingDate": "Fecha de compartición",
      "fieldsOwner": "Propietario",
      "fieldsRecipient": "Destinatario",
      "fieldsCreationDate": "Fecha de creación",
      "fieldsIp": "Dirección IP",
      "positionXLabel": "Posición horizontal",
      "positionYLabel": "Posición vertical",
      "positionLeft": "Izquierda",
      "positionCenter": "Centro",
      "positionRight": "Derecha",
      "positionTop": "Arriba",
      "positionMiddle": "Centro",
      "positionBottom": "Abajo",
      "positionsLabel": "Posición",
      "positionsTopLeft": "Arriba izquierda",
      "positionsTopCenter": "Arriba centro",
      "positionsTopRight": "Arriba derecha",
      "positionsBottomLeft": "Abajo izquierda",
      "positionsBottomCenter": "Abajo centro",
      "positionsBottomRight": "Abajo derecha",
      "positionsDiagonal": "Diagonal (repetido)",
      "fontSizeLabel": "Tamaño de fuente",
      "fontSizeDescription": "1–72",
      "fontColorLabel": "Color de fuente",
      "opacityLabel": "Opacidad",
      "opacityDescription": "0–100%",
      "textPlaceholderHelp": "Los botones de abajo insertan placeholders en el texto. Puedes usar \\n para saltos de línea y **negrita** para texto en negrita. El tooltip de cada botón explica su función.",
      "placeholderButtonOwner": "Propietario",
      "placeholderTooltipOwner": "En la marca de agua, {owner} se sustituye por el nombre del propietario del documento.",
      "placeholderButtonAccessDate": "Fecha/hora de visualización",
      "placeholderTooltipAccessDate": "En la marca de agua, {access_date} se sustituye por la fecha y hora de visualización del documento.",
      "placeholderButtonSharingDate": "Fecha de compartición",
      "placeholderTooltipSharingDate": "En la marca de agua, {sharing_date} se sustituye por la fecha de generación del enlace.",
      "placeholderButtonIp": "Dirección IP",
      "placeholderTooltipIp": "En la marca de agua, {ip} se sustituye por la dirección IP del visualizador.",
      "placeholderButtonRecipient": "Destinatario",
      "placeholderTooltipRecipient": "En la marca de agua, {recipient} se sustituye por el nombre del destinatario.",
      "placeholderButtonOwnerEmail": "Email del propietario",
      "placeholderTooltipOwnerEmail": "En la marca de agua, {owneremail} se sustituye por la dirección de correo del propietario del documento.",
      "placeholderButtonRecipientEmail": "Email del destinatario",
      "placeholderTooltipRecipientEmail": "En la marca de agua, {recipientemail} se sustituye por la dirección de correo del destinatario."
    },
    "remotegrantForceEncryption": {
      "title": "Encriptación forzada de Remotegrant (licencia requerida)",
      "description": "Encriptar archivos y asignar automáticamente permisos de acceso a miembros recién creados usando Remotegrant."
    },
    "sharingApprovalRequirement": {
      "title": "Requisitos de aprobación para compartir",
      "description": "Controla si la compartición de archivos y carpetas requiere aprobación previa, asegurando que los archivos sensibles sean revisados antes de su distribución y se mantenga el cumplimiento.",
      "descriptionInternal": "Esta sección permite a los administradores controlar si la compartición de archivos y carpetas requiere aprobación previa. Las reglas se pueden aplicar de manera universal, a tipos específicos de propiedad de archivos o según etiquetas de clasificación. Los administradores pueden garantizar que los archivos sensibles sean revisados antes de ser compartidos, ayudando a mantener el cumplimiento, prevenir fugas de datos y hacer cumplir las políticas organizacionales. Las solicitudes de aprobación se pueden direccionar a un supervisor designado o un equipo de revisión predefinido.",
      "activeForAllTitle": "Alcance del Usuario",
      "activeForAllDescription": "Controla si los usuarios están sujetos a las restricciones establecidas por el administrador. Esta configuración puede definir el alcance de los permisos, las condiciones bajo las cuales se aplican y cualquier excepción permitida. Garantiza que la actividad de los usuarios se mantenga alineada con las políticas organizacionales, permitiendo flexibilidad cuando sea apropiado.",
      "exceptionsTitle": "Gestión de Excepciones",
      "exceptionsDescription": "Especifica los usuarios que son excepciones a la función anterior.",
      "reviewTeamTitle": "Equipo de Revisión",
      "reviewTeamDescription": "Especifica el equipo que revisará las solicitudes de aprobación.",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Aplicar estas reglas solo a archivos con etiquetas específicas",
      "tagsRequired": "Se requiere al menos una etiqueta cuando hay múltiples reglas",
      "exceptionsRequiredForTags": "Se requieren excepciones al establecer etiquetas",
      "exceptionHandlingTitle": "Gestión de Excepciones",
      "exceptionHandlingDescription": "Especifica los usuarios que son excepciones a la función anterior.",
      "generalApprovalTitle": "Requisito General de Aprobación",
      "generalApprovalDescription": "La compartición solo está permitida después de la aprobación previa de un supervisor designado o del equipo definido en la política.",
      "resharingApprovalTitle": "Aprobación Solo para Archivos Vuelto a Compartir",
      "resharingApprovalDescription": "Aplica el requisito de aprobación únicamente a los archivos que fueron previamente recibidos y están siendo vueltos a compartir.",
      "manageReviewTeam": "Gestionar Equipo de Revisión"
    },
    "mandatoryFileClassification": {
      "title": "Clasificación obligatoria de archivos",
      "description": "Requiere que los archivos sean clasificados antes de compartirlos, asegurando que los archivos sensibles estén adecuadamente etiquetados y protegidos.",
      "descriptionInternal": "Esta sección garantiza que los archivos estén correctamente clasificados antes de poder ser compartidos. Al requerir clasificación, ayuda a prevenir el intercambio accidental o no autorizado de contenido sensible y apoya una gobernanza de datos consistente.",
      "activeForAllTitle": "Alcance del Usuario",
      "activeForAllDescription": "Controla si los usuarios están sujetos a las restricciones establecidas por el administrador. Esta configuración puede definir el alcance de los permisos, las condiciones bajo las cuales se aplican y cualquier excepción permitida. Garantiza que la actividad de los usuarios se mantenga alineada con las políticas organizacionales, permitiendo flexibilidad cuando sea apropiado.",
      "exceptionsTitle": "Gestión de Excepciones",
      "exceptionsDescription": "Especifica los usuarios que son excepciones a la función anterior.",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Aplicar estas reglas solo a archivos con etiquetas específicas",
      "tagsRequired": "Se requiere al menos una etiqueta cuando hay múltiples reglas",
      "exceptionsRequiredForTags": "Se requieren excepciones al establecer etiquetas"
    },
    "forcedFileInvisibility": {
      "title": "Invisibilidad forzada de archivos",
      "description": "Esta función permite a los administradores hacer que ciertos tipos de archivo sean invisibles para los destinatarios, aunque la acción de compartir se complete. Por ejemplo, los documentos de Office utilizados como archivos maestros editables pueden compartirse pero permanecer ocultos para el destinatario, reduciendo el riesgo de exponer los archivos fuente editables y permitiendo compartir solo formatos aprobados como PDF.",
      "descriptionInternal": "Esta función permite a los administradores hacer que ciertos tipos de archivo sean invisibles para los destinatarios, aunque la acción de compartir se complete. Por ejemplo, los documentos de Office utilizados como archivos maestros editables pueden compartirse pero permanecer ocultos para el destinatario, reduciendo el riesgo de exponer los archivos fuente editables y permitiendo compartir solo formatos aprobados como PDF.",
      "activeForAllTitle": "Alcance de Usuarios",
      "activeForAllDescription": "Controla si los usuarios están sujetos a las restricciones establecidas por el administrador. Esta configuración puede definir el alcance de los permisos, las condiciones bajo las cuales se aplican y cualquier excepción permitida. Garantiza que la actividad del usuario esté alineada con las políticas organizacionales, permitiendo flexibilidad cuando sea apropiado.",
      "exceptionsTitle": "Gestión de Excepciones",
      "exceptionsDescription": "Especifica los usuarios que son excepción para esta función.",
      "fileTypesTitle": "Invisible después de Compartir",
      "fileTypesDescription": "Hace que ciertos tipos de archivo (por ejemplo, documentos de Office) sean invisibles para los destinatarios aunque se complete el proceso de compartir.",
      "fileTypesPlaceholder": "Ingresa tipos de archivo o extensiones (por ejemplo, .docx, .xls, .pptx)",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Aplica estas reglas solo a archivos con etiquetas específicas",
      "tagsRequired": "Se requiere al menos una etiqueta cuando existen múltiples reglas",
      "exceptionsRequiredForTags": "Se requieren excepciones al establecer etiquetas"
    },
    "shortcutLink": {
      "title": "Restricción de enlace directo",
      "description": "Restringe la creación de enlaces directos para archivos que contienen etiquetas designadas.",
      "descriptionInternal": "Restringe la creación de enlaces directos para archivos que contienen etiquetas designadas.",
      "activeForAllTitle": "Alcance de Usuarios",
      "activeForAllDescription": "Controla si los usuarios están sujetos a las restricciones definidas por el administrador.",
      "exceptionsTitle": "Gestión de Excepciones",
      "exceptionsDescription": "Especifica los usuarios que son excepción para esta función.",
      "tagsTitle": "Etiquetas",
      "tagsDescription": "Aplica estas reglas solo a archivos con etiquetas específicas",
      "tagsRequired": "Se requiere al menos una etiqueta cuando existen múltiples reglas",
      "exceptionsRequiredForTags": "Se requieren excepciones al establecer etiquetas"
    },
    "adminSettingsPermissions": {
      "title": "Permisos de configuración de administrador",
      "description": "Restringe el acceso de los Admin a la configuración de la plataforma.",
      "deniedSettingsUserTitle": "Alcance del Administrador",
      "deniedSettingsUserDescription": "Selecciona el administrador al que se le denegará el acceso a la configuración.",
      "deniedSettingsTitle": "Configuraciones Denegadas",
      "deniedSettingsDescription": "Especifica las configuraciones a las que los administradores no tienen permitido acceder.",
      "selectUserFirst": "Selecciona un usuario primero"
    },
    "sharePointIntegration": {
      "title": "Integración con SharePoint",
      "description": "Cifra in situ los archivos de un perímetro de SharePoint elegido.",
      "steps": {
        "connection": "Conexión",
        "key": "Clave de cifrado",
        "perimeter": "Perímetro"
      },
      "connectionDescription": "Credenciales app-only del registro de aplicación en Entra ID.",
      "tenantIdLabel": "ID del tenant",
      "clientIdLabel": "ID de cliente",
      "spaClientIdLabel": "ID de cliente SPA (visor/editor)",
      "spaClientIdHint": "Segundo registro de aplicación, de tipo SPA (público): el navegador inicia sesión en él para leer y editar los archivos cifrados. Sin él nadie puede abrir un archivo desde la aplicación web. Nunca pongas aquí el registro de solo aplicación: ese tiene un secreto.",
      "guidHint": "Introduce un GUID válido.",
      "clientSecretLabel": "Secreto de cliente",
      "clientSecretPlaceholder": "Pega el secreto de cliente",
      "clientSecretHint": "Solo escritura: una vez guardado solo se puede sustituir.",
      "clientSecretStored": "Hay un secreto de cliente guardado",
      "replaceSecret": "Sustituir",
      "editConnection": "Editar",
      "hideConnection": "Cerrar",
      "testAction": "Verificar",
      "testOk": "Conexión verificada",
      "testKo": "Conexión rechazada",
      "saveCredentialsFirst": "Guarda primero las credenciales.",
      "lastVerifyOk": "Verificada",
      "lastVerifyKo": "Comprobación fallida",
      "lastVerifiedAt": "Última comprobación: {{date}}",
      "perimeterDescription": "Los sitios y carpetas que inspecciona el análisis.",
      "perimeter": {
        "sitesTitle": "Sitios",
        "searchSites": "Buscar sitios",
        "reloadSites": "Recargar la lista de sitios",
        "foldersTitle": "{{siteName}}",
        "foldersTitleEmpty": "Carpetas",
        "pickSiteFirst": "Elige un sitio a la izquierda.",
        "noLibraries": "Ninguna biblioteca de documentos visible aquí.",
        "wholeSiteTag": "Todo el sitio",
        "selectedTitle": "En el perímetro:",
        "scopeNone": "ninguno",
        "folderCount": "{{count}} carpeta(s)",
        "librariesCrumb": "Bibliotecas de documentos",
        "noSubfolders": "Sin subcarpetas.",
        "levelTruncatedTitle": "Demasiadas carpetas para listarlas aquí",
        "levelTruncatedBody": "Por encima del límite de 2000 carpetas algunas no aparecen en ninguna página: añádelas por ruta abajo.",
        "manualPathLabel": "Añadir una carpeta por ruta",
        "manualPathPlaceholder": "Añadir una carpeta por ruta, p. ej. Contratos/2026",
        "manualPathInvalid": "Ruta relativa a la raíz de la biblioteca, sin segmentos \".\" ni \"..\" (máx. 400 caracteres).",
        "browse": "Explorar",
        "openFolder": "Abrir {{name}}",
        "scopeLabel": "Qué supervisar en este sitio",
        "scopeOff": "Nada",
        "scopeWhole": "Todo el sitio",
        "scopeFolders": "Solo las carpetas de abajo",
        "selectedFoldersTitle": "Carpetas supervisadas",
        "librariesNotSelectable": "Abre una biblioteca. Una carpeta elegida se aplica a todas las bibliotecas del sitio.",
        "addFolder": "Añadir {{name}} a las carpetas vigiladas",
        "folderAdded": "Añadida",
        "folderAlreadyAdded": "Esta carpeta ya está vigilada",
        "noFoldersSelected": "Ninguna todavía.",
        "parentFolderWatched": "La carpeta superior \"{{folder}}\" ya está vigilada, por lo que sus subcarpetas ya están en el perímetro.",
        "emptyWarning": "Ningún sitio seleccionado: no se inspeccionará ni cifrará nada.",
        "siteCount": "{{count}} sitio(s)"
      },
      "certificateDescription": "El certificado de RemoteGrant al que se cifran los archivos.",
      "encryption": {
        "thumbprintLabel": "Huella",
        "unnamedCertificate": "Certificado n.º {{id}}",
        "reloadAction": "Recargar certificados",
        "selectPlaceholder": "Elige un certificado",
        "optionLabel": "{{name}} — creado el {{date}}",
        "rotationTitle": "Cambiar el certificado no vuelve a cifrar nada",
        "rotationBody": "Los archivos ya cifrados siguen ligados al certificado anterior: mantenlo en RemoteGrant o serán ilegibles.",
        "dryRunBlockedReason": "Elige un certificado de cifrado para desactivar el modo discovery.",
        "errors": {
          "listFailed": "No se ha podido cargar la lista de certificados.",
          "certificateNotFound": "El certificado seleccionado ya no está en tu lista de RemoteGrant. Recarga la lista y elige uno de nuevo.",
          "remoteGrantNotConfigured": "RemoteGrant no está configurado para tu empresa. Sus claves las establece CyberGrant: contacta con soporte.",
          "remoteGrantUnavailable": "RemoteGrant no está disponible temporalmente. Inténtalo de nuevo en un momento.",
          "remoteGrantDenied": "RemoteGrant ha rechazado las credenciales de tu empresa. Contacta con soporte."
        },
        "empty": "RemoteGrant no ha devuelto ningún certificado para tu empresa."
      },
      "fileExtensionsTitle": "Filtro de tipos de archivo",
      "fileExtensionsDescription": "Solo los archivos con estas extensiones entran en el perímetro. Deja la lista vacía para incluir todos los tipos de archivo.",
      "addFileExtension": "Añadir una extensión",
      "invalidFileExtension": "Introduce una sola extensión, por ejemplo .docx",
      "allFileTypesWarning": "Sin filtro: todos los tipos de archivo del perímetro están incluidos.",
      "dryRunTitle": "Modo discovery",
      "dryRunDescription": "Inspecciona el perímetro sin cifrar nada. Opción predeterminada y segura.",
      "dryRunOnTag": "Discovery",
      "dryRunOffTag": "Cifrando",
      "confirmEncryption": {
        "confirmAction": "Cifrar",
        "irreversible": "Se reescriben in situ y desde aquí no se pueden descifrar.",
        "title": "¿Cifrar los archivos de esta selección?"
      },
      "errors": {
        "notAvailableTitle": "No incluido en tu licencia",
        "notAvailable": "La integración con SharePoint no está incluida en tu licencia. Contacta con soporte para activarla.",
        "notConfigured": "Todavía no hay credenciales guardadas. Introduce y guarda primero los parámetros de conexión.",
        "configInvalid": "La configuración guardada ha sido rechazada. Corrige los problemas indicados abajo y guarda de nuevo.",
        "testFailed": "No se ha podido verificar la conexión.",
        "sitesFailed": "No se han podido cargar los sitios del tenant.",
        "foldersFailed": "No se ha podido cargar este nivel de carpetas.",
        "siteNotFound": "Este sitio ya no está disponible con estas credenciales. Recarga la lista de sitios y vuelve a seleccionarlo.",
        "graphUnauthorizedShort": "Microsoft Graph ha rechazado las credenciales.",
        "graphUnavailable": "Microsoft Graph no está disponible temporalmente. Inténtalo de nuevo en un momento.",
        "notAllowed": "No tienes permiso para gestionar este ajuste. Pide a un SuperAdmin que te dé acceso a la integración con SharePoint.",
        "invalidParams": "La solicitud ha sido rechazada por un parámetro no válido.",
        "remedyPermissions": "El registro de aplicación necesita los permisos de aplicación Sites.Read.All y Files.ReadWrite.All con consentimiento de administrador.",
        "remedySecret": "El secreto de cliente puede ser incorrecto o haber caducado: introduce uno nuevo arriba."
      }
    },
    "activeDirectoryLdap": {
      "title": "Active Directory (LDAP)",
      "description": "Conecte Filegrant a su Active Directory local para sincronizar usuarios y grupos.",
      "connectionTitle": "Conexión",
      "connectionDescription": "Controlador de dominio, cuenta de servicio y raíz de búsqueda.",
      "hostLabel": "Host",
      "portLabel": "Puerto",
      "securityLabel": "Seguridad",
      "securityNone": "Ninguna (texto claro)",
      "allowInsecureLabel": "Entiendo que la contraseña viaja en claro — permitir LDAP inseguro",
      "allowInsecureWarning": "Con seguridad en none, la contraseña de la cuenta de servicio viaja en claro por la red.",
      "bindDnLabel": "DN de enlace",
      "bindPasswordLabel": "Contraseña de enlace",
      "bindPasswordStored": "Hay una contraseña de enlace almacenada",
      "bindPasswordRequired": "Introduzca la contraseña de enlace antes de guardar.",
      "replacePassword": "Reemplazar",
      "baseDnLabel": "DN base",
      "loginAliasLabel": "Atributo de alias de inicio de sesión",
      "loginAliasNone": "Ninguno",
      "suggestRetypePassword": "Host o DN de enlace cambiados — considere volver a escribir la contraseña.",
      "testAction": "Probar conexión",
      "testOk": "Conexión verificada",
      "saveCredentialsFirst": "Guarde primero la configuración, sin cambios sin guardar.",
      "lastVerifiedAt": "Última verificación: {{date}}",
      "neverVerified": "Nunca verificado",
      "caTitle": "Certificado CA",
      "caDescription": "PEM de la CA interna que firmó el certificado del controlador. Déjelo vacío para usar el almacén del sistema.",
      "uploadCa": "Subir .cer / .pem",
      "removeCa": "Quitar CA",
      "caThumbprint": "Huella",
      "caExpiresAt": "La CA caduca el {{date}}",
      "caExpiringSoon": "La CA caduca pronto ({{date}})",
      "caExpired": "La CA caducó el {{date}}",
      "advancedTitle": "Avanzado",
      "advancedDescription": "Bases de búsqueda y filtros LDAP opcionales.",
      "advancedToggle": "Bases de búsqueda y filtros",
      "userSearchBaseLabel": "Base de búsqueda de usuarios",
      "groupSearchBaseLabel": "Base de búsqueda de grupos",
      "userFilterLabel": "Filtro de usuarios",
      "groupFilterLabel": "Filtro de grupos",
      "errors": {
        "notAvailableTitle": "No disponible"
      },
      "passwordRequiredOnTargetChange": "Vuelva a introducir la contraseña: el destino de conexión cambió.",
      "filterHelp": "Condición opcional que restringe la búsqueda predeterminada (AND), p. ej. (department=Sales).",
      "neverVerifiedInvite": "Conexión nunca verificada — pulse Probar conexión."
    },
    "outboundEmail": {
      "title": "Remitente de correo personalizado",
      "description": "Envía las notificaciones de la plataforma desde tu propio dominio vía SMTP o Mailgun.",
      "statusTitle": "Estado del remitente",
      "statusDescription": "Si las notificaciones salen actualmente desde tu dominio personalizado.",
      "refreshStatus": "Actualizar estado",
      "badgeActive": "Activo: las notificaciones salen desde {{domain}}",
      "badgeInactive": "No activo: las notificaciones siguen usando el remitente de la plataforma",
      "reasonDisabled": "El remitente personalizado está desactivado.",
      "reasonNotVerified": "La propiedad del dominio aún no está verificada.",
      "reasonMailgunNotActive": "El dominio de Mailgun aún no está activo.",
      "reasonNotActive": "El remitente personalizado no está en uso.",
      "formTitle": "Configuración",
      "formDescription": "Dominio, identidad From y modo de entrega.",
      "enabledLabel": "Activar remitente personalizado",
      "modeLabel": "Modo de entrega",
      "modeSmtp": "SMTP (servidor propio)",
      "modeMailgun": "Mailgun (cuenta de la plataforma)",
      "mailgunUnavailable": "El modo Mailgun no está disponible en esta plataforma.",
      "domainLabel": "Dominio",
      "fromAddressLabel": "Dirección From",
      "fromNameLabel": "Nombre From",
      "sendFromUserLabel": "Enviar desde el usuario",
      "sendFromUserOn": "Usar el correo del usuario que actúa como From",
      "sendFromUserOff": "Usar la dirección From de la empresa / dominio personalizado",
      "smtpHostLabel": "Host SMTP",
      "smtpPortLabel": "Puerto SMTP",
      "smtpUsernameLabel": "Usuario SMTP",
      "smtpPasswordLabel": "Contraseña SMTP",
      "smtpPasswordStored": "Hay una contraseña SMTP guardada",
      "smtpPasswordRequired": "Introduce la contraseña SMTP antes de guardar.",
      "replacePassword": "Reemplazar",
      "smtpSecurityLabel": "Seguridad SMTP",
      "suggestRetypePassword": "Host o usuario cambiado — vuelve a introducir la contraseña SMTP.",
      "domainChangeTitle": "¿Cambiar el dominio?",
      "domainChangeWarning": "Cambiar el dominio reinicia la verificación. El remitente personalizado dejará de usarse hasta verificar el nuevo dominio.",
      "dnsTitle": "DNS y verificación",
      "dnsDescription": "Publica el registro TXT de propiedad y verifica. En modo Mailgun, publica también los registros de Mailgun.",
      "verifyNow": "Verificar ahora",
      "verifyOk": "Propiedad del dominio verificada",
      "verifyPending": "TXT de propiedad aún no encontrado",
      "verifyMailgun": "Verificar registros de Mailgun",
      "verifyMailgunOk": "Registros de Mailgun verificados: el dominio está activo",
      "verifyMailgunPending": "Mailgun aún no ha verificado todos los registros",
      "autoCheckHint": "Se comprueba automáticamente cada minuto hasta que el dominio esté verificado.",
      "autoCheckVerified": "Dominio verificado: ya se puede usar el remitente personalizado.",
      "saveBeforeVerify": "Guarda un dominio primero y luego verifica.",
      "ownershipName": "Nombre",
      "ownershipValue": "Valor",
      "recordType": "Tipo",
      "recordValid": "Válido",
      "recordInvalid": "No válido",
      "verifiedAt": "Verificado: {{date}}",
      "lastCheckedAt": "Última comprobación: {{date}}",
      "dnsEmpty": "Guarda un dominio para recibir el registro TXT de propiedad.",
      "mailgunRecordsTitle": "Registros DNS de Mailgun",
      "testTitle": "Correo de prueba",
      "testDescription": "Encola un mensaje de prueba a tu propia dirección de SuperAdmin mediante el remitente personalizado.",
      "testDescriptionPlatform": "Encola un mensaje de prueba a tu propia dirección de SuperAdmin. El remitente personalizado aún no está en uso, así que se usa el remitente actual.",
      "sendTest": "Enviar correo de prueba",
      "testQueued": "Encolado a {{recipient}}",
      "testQueuedPlatform": "Encolado a {{recipient}} mediante el remitente actual (remitente personalizado no en uso)",
      "errors": {
        "notAvailableTitle": "No disponible"
      }
    }
  },
  "auth": {
    "loginPageTitle": "Bienvenido a Filegrant Enterprise",
    "loginPageSubtitle": "Por favor ingresa tu dirección de correo electrónico para acceder de forma segura al documento.",
    "resendOtpCode": "Reenviar código OTP",
    "loginTermsAndConditions": "Acepto los [**Términos de Servicio**](https://www.cybergrant.net/terms-of-service) de Cyber Grant Inc.",
    "loginPageEmailLabel": "Correo/nombre de usuario",
    "loginPageEmailPlaceholder": "Ingresa tu correo/nombre de usuario...",
    "loginPageOtpLabel": "Enviamos un código a tu correo registrado. Ingresa el código de 6 dígitos aquí. Si no lo has recibido, haz clic en 'Solicitar un nuevo código'",
    "loginButtonLabel": "Iniciar sesión",
    "loginPageResendOtp": "Solicitar un nuevo código",
    "orContinueWith": "O continuar con",
    "loginPageTooManyAttempts": "Demasiados intentos, intenta de nuevo en",
    "totpStepTitle": "Autenticación de dos factores",
    "enterTotpCode": "Introduce el código de 6 dígitos de tu aplicación de autenticación",
    "configure2FA": "Necesito configurar 2FA",
    "useBackupCode": "Usar un código de respaldo",
    "useOtpCode": "Usar código OTP",
    "enterBackupCode": "Introduce tu código de respaldo",
    "backupCodePlaceholder": "Introduce tu código de respaldo",
    "totpTimeRemaining": "Tiempo restante para completar la autenticación: {{time}}",
    "twoFactorChooseMethod": "Elige cómo verificar",
    "usePasskey": "Usar passkey",
    "useTotp": "Usar aplicación de autenticación",
    "passkeyWaiting": "Esperando tu passkey…",
    "orDivider": "o",
    "signInWithPasskey": "Iniciar sesión con passkey",
    "passkeyCancelled": "El inicio de sesión con passkey se canceló.",
    "passkeyNotSupported": "Tu navegador no admite passkeys.",
    "passwordlessNotEnabled": "El inicio de sesión con passkey no está habilitado para tu organización.",
    "totpForcedSetupIntro": "Tu organización requiere autenticación de dos factores. Configúrala ahora para terminar de iniciar sesión como {{email}}.",
    "totpForcedSetupTitle": "Configurar autenticación de dos factores",
    "totpForcedSetupDescription": "Escanea el código QR con tu aplicación de autenticación y luego introduce el código de 6 dígitos para terminar de iniciar sesión."
  },
  "secret": {
    "createTitle": "Crear archivo secreto",
    "createSecret": "Contraseña o secreto",
    "newSecret": "Nuevo secreto",
    "fileName": "Nombre del archivo",
    "fileNameRequired": "El nombre del archivo es obligatorio",
    "protectWithPassword": "Proteger con contraseña",
    "protectWithSecretKey": "Proteger con clave secreta",
    "secretKeyWarning": "Si pierdes esta clave, la información ya no será accesible",
    "changeSecretKey": "Cambiar clave secreta",
    "currentSecretKey": "Clave secreta actual",
    "wrongCurrentKey": "La clave secreta actual es incorrecta",
    "hint": "Pista",
    "hintPlaceholder": "Pista opcional para recordar la clave",
    "newSecretKey": "Nueva clave secreta",
    "confirmSecretKey": "Confirmar clave secreta",
    "secretKeyMismatch": "Las claves secretas no coinciden",
    "enterPassword": "Ingresa la contraseña",
    "confirmPassword": "Confirmar contraseña",
    "passwordRequired": "La contraseña es obligatoria",
    "passwordMinLength": "La contraseña debe tener al menos 4 caracteres",
    "confirmPasswordRequired": "Confirma la contraseña",
    "passwordMismatch": "Las contraseñas no coinciden",
    "wrongPassword": "Contraseña incorrecta",
    "addField": "Agregar campo",
    "addFieldForGroup": "Agregar campo al grupo",
    "removeField": "Eliminar campo",
    "editLabel": "Editar etiqueta",
    "fieldType": "Tipo",
    "fieldLabel": "Campo nuevo",
    "fieldValue": "Valor",
    "fields": {
      "heading": "Campos",
      "username": "Usuario",
      "password": "Contraseña",
      "website": "Sitio web",
      "cardholder": "Titular",
      "number": "Número de tarjeta",
      "brand": "Marca",
      "exp_month": "Mes de caducidad",
      "exp_year": "Año de caducidad",
      "cvv": "CVV",
      "title": "Tratamiento",
      "first_name": "Nombre",
      "last_name": "Apellidos",
      "fiscal_code": "NIF / CIF",
      "passport": "Pasaporte",
      "driving_license": "Permiso de conducir",
      "email": "Email",
      "phone": "Teléfono",
      "address1": "Dirección línea 1",
      "address2": "Dirección línea 2",
      "address3": "Dirección línea 3",
      "city": "Ciudad",
      "state": "Provincia",
      "zip": "Código postal",
      "country": "País",
      "private_key": "Clave privada",
      "public_key": "Clave pública",
      "fingerprint": "Huella",
      "notes": "Notas"
    },
    "searchFields": "Buscar campos",
    "noFieldsYet": "Aún no hay campos",
    "untitled": "Sin título",
    "types": {
      "text": "Texto",
      "password": "Contraseña",
      "url": "URL",
      "username": "Usuario",
      "email": "Email",
      "phone": "Teléfono",
      "textarea": "Área de texto",
      "number": "Número",
      "month": "Mes",
      "year": "Año"
    },
    "validation": {
      "email": "No parece un correo válido",
      "url": "No parece una URL válida",
      "phone": "No parece un número de teléfono válido",
      "number": "No parece un número válido"
    },
    "password": {
      "show": "Mostrar",
      "hide": "Ocultar",
      "generate": "Generar contraseña",
      "copy": "Copiar",
      "copied": "¡Copiado!",
      "length": "Longitud",
      "includeSymbols": "Incluir caracteres especiales",
      "strength": {
        "veryWeak": "Muy débil",
        "weak": "Débil",
        "fair": "Regular",
        "strong": "Fuerte",
        "veryStrong": "Muy fuerte"
      }
    },
    "edit": "Editar",
    "save": "Guardar",
    "saved": "Guardado con éxito",
    "cancel": "Cancelar",
    "protectedFile": "Archivo protegido",
    "enterPasswordToView": "Ingresa la contraseña para ver el contenido",
    "unlock": "Desbloquear",
    "noData": "No hay datos disponibles",
    "loadError": "Error al cargar el archivo",
    "saveError": "Error al guardar el archivo",
    "addWebsite": "Añadir sitio web",
    "addGroup": "Añadir grupo",
    "newGroup": "Nuevo grupo",
    "renameGroup": "Renombrar grupo",
    "deleteGroup": "Eliminar grupo",
    "moveUp": "Subir",
    "moveDown": "Bajar",
    "dragToReorderField": "Arrastrar para reordenar {{label}}",
    "dragToReorderGroup": "Arrastrar para reordenar el grupo {{label}}",
    "presets": {
      "credentials": "Credenciales de acceso",
      "card": "Tarjeta de pago",
      "identity": "Identidad",
      "ssh_key": "Clave SSH",
      "custom": "Secreto personalizado"
    },
    "groups": {
      "credentials_main": "Credenciales de acceso",
      "credentials_autofill": "Opciones de autocompletado",
      "card_main": "Tarjeta",
      "identity_personal": "Personal",
      "identity_ids": "Documentos",
      "identity_contact": "Contacto",
      "identity_address": "Dirección",
      "ssh_main": "Clave SSH",
      "custom_fields": "Campos personalizados",
      "additional_options": "Opciones adicionales"
    },
    "card": {
      "brands": {
        "visa": "Visa",
        "mastercard": "Mastercard",
        "amex": "American Express",
        "other": "Otro"
      }
    },
    "identity": {
      "titles": {
        "mr": "Sr.",
        "ms": "Sra.",
        "mx": "Mx",
        "dr": "Dr.",
        "prof": "Prof.",
        "other": "Otro"
      }
    },
    "ssh": {
      "upload": "Subir archivo de clave",
      "uploadError": "No se pudo leer el archivo de clave"
    }
  },
  "publicShare": {
    "createLink": "Crear enlace público",
    "revokeLink": "Revocar enlace",
    "revokeLinkConfirmDescription": "¿Revocar el enlace público de {{fileName}}?",
    "badgeSection": "Enlace público",
    "badgeActive": "Enlace público activo",
    "revoked": "Enlace público revocado correctamente",
    "createModal": {
      "title": "Crear enlace público",
      "fileLabel": "Archivo",
      "allowDownload": "Permitir descarga",
      "expirationLabel": "Caducidad (opcional)",
      "expirationPlaceholder": "Nunca",
      "maxAccessCountLabel": "Límite de accesos (opcional)",
      "maxAccessCountPlaceholder": "Ilimitado",
      "protectWithPassword": "Proteger con contraseña",
      "passwordLabel": "Contraseña",
      "passwordPlaceholder": "Introduce la contraseña",
      "passwordRequired": "La contraseña es obligatoria cuando la protección está activada",
      "createLink": "Crear enlace"
    },
    "successModal": {
      "title": "¡Enlace creado!",
      "message": "El enlace público ha sido creado.",
      "copyLink": "Copiar enlace",
      "warning": "Cualquiera con este enlace puede acceder al archivo.",
      "expiresAt": "Caduca",
      "remainingAccesses": "Accesos restantes",
      "password": "Contraseña"
    },
    "errors": {
      "linkAlreadyExists": "Ya existe un enlace público para este archivo. Revócalo antes de crear uno nuevo.",
      "linkNotFound": "No se encontró ningún enlace activo para este archivo.",
      "featureDisabled": "Los enlaces públicos están deshabilitados en tu organización.",
      "notOwner": "Debes ser el propietario para crear o revocar enlaces públicos."
    },
    "passwordTitle": "Contenido protegido",
    "passwordMessage": "Este archivo está protegido con contraseña. Introduce la contraseña para acceder.",
    "passwordRequired": "La contraseña es obligatoria.",
    "errorInvalidPassword": "La contraseña introducida no es correcta. Inténtalo de nuevo.",
    "passwordSubmit": "Acceder",
    "errorExpiredTitle": "Enlace caducado",
    "errorExpiredMessage": "Este enlace de compartición ya no es válido. La fecha de caducidad ha pasado. Contacta con quien te envió el enlace para solicitar uno nuevo.",
    "errorMaxAccessTitle": "Límite de accesos alcanzado",
    "errorMaxAccessMessage": "Este enlace ha alcanzado el número máximo de accesos permitidos. Contacta con quien te envió el enlace para solicitar uno nuevo.",
    "errorNotFoundTitle": "Enlace no válido",
    "errorNotFoundMessage": "El enlace que intentas abrir no existe o ha sido revocado por el propietario. Comprueba que has copiado la URL correctamente.",
    "folderContents": "Contenido de la carpeta",
    "items": "elementos",
    "fileSize": "Tamaño",
    "fileType": "Tipo",
    "sharedAt": "Compartido el",
    "list": {
      "title": "Mis enlaces públicos",
      "description": "Gestiona tus enlaces de compartición pública. Revoca un enlace para desactivarlo.",
      "fileName": "Nombre",
      "type": "Tipo",
      "status": "Estado",
      "statusActive": "Activo",
      "statusExpired": "Caducado",
      "statusExhausted": "Límite alcanzado",
      "expiresAt": "Caduca",
      "accessCount": "Accesos",
      "hasPassword": "Contraseña",
      "empty": "Aún no hay enlaces públicos."
    }
  },
  "common": {
    "buttons": "Botones",
    "change": "Cambiar",
    "setting": "Configuración",
    "background": "Fondo",
    "foreground": "Primer plano",
    "edit": "Editar",
    "remove": "Eliminar",
    "settings": "Configuración",
    "twoFactorAuthentication": "2FA",
    "debug": "Debug",
    "integrations": "Integraciones",
    "customizations": "Personalizaciones",
    "enable": "Habilitar",
    "logout": "Cerrar sesión",
    "features": "Funcionalidades",
    "day_one": "{{count}} día",
    "day_other": "{{count}} días",
    "files": "Archivos",
    "received": "Recibidos",
    "rename": "Renombrar",
    "versions": "Versiones",
    "version": "Versión",
    "restore": "Restaurar",
    "cancel": "Cancelar",
    "cancelUpload": "Cancelar subida",
    "canceled": "Cancelado",
    "close": "Cerrar",
    "open": "Abrir",
    "createFolder": "Crear carpeta",
    "openFolder": "Abrir carpeta",
    "uploadFolder": "Subir carpeta",
    "uploadFile": "Subir archivo",
    "downloadEncrypted": "Descargar encriptado",
    "createdBy": "Creado por",
    "login": "Iniciar sesión",
    "otpCode": "Código OTP",
    "passkeys": "Passkeys",
    "email": "Correo electrónico",
    "username": "Nombre de usuario",
    "emails": "Correos",
    "emailLabel": "Etiqueta de Correo Electrónico",
    "emailPlaceholder": "Marcador de Posición de Correo Electrónico",
    "labels": "Etiquetas",
    "inputs": "Entradas",
    "loginLabel": "Etiqueta de Inicio de Sesión",
    "resendOtpLabel": "Etiqueta de Reenviar OTP",
    "otpCodeLabel": "Etiqueta de Código OTP",
    "allUsers": "Todos los usuarios",
    "allGroups": "Todos los grupos",
    "globalSearchPlaceholder": "Buscar archivos y carpetas",
    "folderPickerSearchInFolder": "Buscar en esta carpeta",
    "globalSearchDescription": "Comienza a escribir para buscar archivos y carpetas",
    "filterExactMatch": "Coincidencia exacta (palabra completa)",
    "filterWholeWord": "Búsqueda tipo like (wildcard)",
    "loading": "Cargando...",
    "loadingDescription": "Por favor espere mientras cargamos sus datos",
    "thinking": "Pensando...",
    "thinkingDescription": "La IA está procesando su solicitud",
    "noResults": "No se encontraron resultados",
    "noFilesFound": "No se encontraron archivos",
    "hidden": "Oculto",
    "hide": "Ocultar",
    "lock": "Bloquear",
    "file": "Archivo",
    "fileSize": "Tamaño de archivo",
    "tags": "Etiquetas",
    "tag": "Etiqueta",
    "title": "Título",
    "users": "Usuarios",
    "user": "Usuario",
    "systemUser": "Sistema",
    "groups": "Grupos",
    "createdAt": "Creado el",
    "group": "Grupo",
    "reviewTeam": "Equipo de revisión",
    "folder": "Carpeta",
    "publicLink": "Enlace público",
    "publicLinkTitle": "Filegrant Enlace público",
    "logs": "Registros",
    "addUsersOrGroups": "Añadir usuarios o grupos",
    "addUsers": "Añadir usuarios",
    "userTagInputEmptyPlaceholder": "Comienza a escribir para buscar usuarios o grupos",
    "member": "Miembro",
    "member_zero": "Sin miembros",
    "member_other": "Miembros",
    "uploaded": "Subido",
    "failed": "Falló",
    "retries": "Reintentos",
    "preparingFilesForUpload": "Preparando archivos para subir",
    "uploadingFilesCounter": "Subiendo archivos {{amount}} de {{total}}",
    "uploadedFilesCounter": "Subidos {{amount}} de {{total}}",
    "copyLink": "Copiar enlace",
    "unhide": "Mostrar",
    "licenseLimitation": "Limitación de Licencia",
    "deletionDate": "Fecha de eliminación",
    "creationDate": "Fecha de creación",
    "newUser": "Nuevo usuario",
    "newGroup": "Nuevo grupo",
    "noActionsAvailable": "No hay acciones disponibles",
    "author": "Autor",
    "openProtectedFile": "Abrir archivo protegido",
    "showFilesSharedWith": "Mostrar archivos compartidos con",
    "showFilesSharedBy": "Mostrar archivos compartidos por",
    "upload": "Subir",
    "youCanRequestANewOtpIn": "Puedes solicitar un nuevo OTP en",
    "otpExpired": "OTP expirado",
    "otpValidFiveMinutesOnce": "Este código es válido durante 5 minutos y funciona una sola vez.",
    "generateNewOtp": "Generar nuevo OTP",
    "clickHereToGenerateNewOtp": "Haz clic aquí para generar un nuevo OTP",
    "preparingFileForDownload": "Preparando archivo para descarga",
    "preparingForDownload": "Preparando descarga",
    "uploadErrors": "Errores de subida",
    "uploadErrorsDescription": "Algunos archivos no pudieron ser subidos",
    "size": "Tamaño",
    "status": "Estado",
    "percentage": "Porcentaje",
    "viewer": "Visualizador",
    "editor": "Editor",
    "shareWith": "Compartir con",
    "retry": "Reintentar",
    "regenerate": "Regenerar",
    "permissions": "Permisos",
    "expiration": "Expiración",
    "message": "Mensaje",
    "uploadingFiles": "Subiendo archivos",
    "addFiles": "Añadir archivos",
    "addFolders": "Añadir carpetas",
    "max": "Máx",
    "preview": "Vista previa",
    "quickShare": "Compartición Rápida",
    "maxFilesAmountAndSizeEach": "Máx {{amount}} archivos, {{size}}MB cada uno",
    "startUploadAndShare": "Iniciar subida y compartir",
    "processing": "Procesando",
    "startNewUploadAndShare": "Iniciar nueva subida y compartir",
    "continue": "Continuar",
    "goToFileManager": "Ir al Gestor de Archivos",
    "goToQuickShare": "Ir a Compartición Rápida",
    "viewAll": "Ver todas",
    "emptyUsersList": "Aquí puedes encontrar los usuarios que añadiste",
    "emptyGroupsList": "Aquí puedes encontrar los grupos que añadiste",
    "confirmationMessage": "Mensaje de confirmación",
    "lastModified": "Última modificación",
    "opened": "Abierto",
    "lastAccess": "Último acceso",
    "accessExpiration": "Expiración de acceso",
    "description": "Descripción",
    "descriptionNotEditable": "La descripción no es editable",
    "sharedItems": "Elementos compartidos",
    "sharedItemsCount": "Compartido {{count}} elemento",
    "sharedItemsCount_other": "Compartidos {{count}} elementos",
    "itemsSharedWith": "Elementos compartidos con <strong>{{resource}}</strong>",
    "manageItems": "Gestionar elementos",
    "items": "Elementos",
    "visibleToAdminsOnly": "Visible solo para administradores",
    "loginAlias": "Alias de inicio de sesión / Número de empleado",
    "loginAliasManagedBy": "Gestionado por {{source}}",
    "loginAliasManagedWarning": "Editar este alias detiene las actualizaciones automáticas del directorio.",
    "loginAliasSourceEntraId": "Entra ID",
    "loginAliasSourceActiveDirectory": "Active Directory",
    "employeeId": "ID de empleado",
    "searchUsersIncludingAlias": "Buscar usuarios (nombre, correo o alias)...",
    "pleaseEnterName": "Introduce un nombre",
    "pleaseEnterFirstName": "Introduce un nombre",
    "pleaseEnterLastName": "Introduce un apellido",
    "pleaseEnterEmail": "Introduce un correo electrónico",
    "invalidEmail": "El correo electrónico no es válido",
    "nameCannotBeEmail": "El nombre no puede ser un correo electrónico",
    "publicLinkSearchHint": "La búsqueda filtra esta carpeta cuando terminan de cargarse todas las páginas",
    "companyTag": "Etiqueta de empresa",
    "replace": "Reemplazar",
    "fileName": "Nombre del archivo",
    "enterFileName": "Ingresa el nombre del archivo",
    "new": "Nuevo",
    "organize": "Organizar",
    "downloadFile": "Descargar archivo",
    "expiry": "Expiración",
    "downloadPdf": "Descargar PDF",
    "downloadEncryptedFile": "Descargar archivo encriptado",
    "save": "Guardar",
    "createShortcut": "Crear acceso directo",
    "create": "Crear",
    "createShortcutFor": "Crear acceso directo para {{resource}}",
    "selectFolderToCreateFileShortcut": "Selecciona una posición para mostrar la ruta de la carpeta donde se creará el archivo",
    "editUser": "Editar usuario",
    "unblockUser": "Desbloquear usuario",
    "blockUser": "Bloquear usuario",
    "deleteUser": "Eliminar usuario",
    "excludeFromSso": "Excluir del SSO",
    "includeInSso": "Reactivar SSO",
    "confirm": "Confirmar",
    "search": "Buscar",
    "noUsersFound": "No se encontraron usuarios",
    "noSettingsFound": "No se encontraron configuraciones",
    "block": "Bloquear",
    "unblock": "Desbloquear",
    "role": "Rol",
    "addedOn": "Añadido el",
    "memberOfNGroups": "Miembro de N° grupos",
    "noExpirationDate": "Sin fecha de expiración",
    "groupsMember": "Miembro de grupos",
    "onBehalfOf": "En nombre de",
    "exitFromBehalfOfMode": "Salir del modo en nombre de",
    "expiryDate": "Fecha de expiración",
    "select": "Seleccionar",
    "nothingHasBeenSharedYet": "Nada ha sido compartido aún",
    "manageGroups": "Gestionar grupos",
    "noGroupsYet": "No hay grupos aún",
    "addExpirationDate": "Añadir fecha de expiración",
    "editExpirationDate": "Editar fecha de expiración",
    "edited": "Editado",
    "removed": "Eliminado",
    "removeExpirationDate": "Eliminar fecha de expiración",
    "usersWithSharedFiles": "Usuarios con archivos compartidos",
    "usersWithoutSharedFiles": "Usuarios sin archivos compartidos",
    "changeRole": "Cambiar rol",
    "yes": "Sí",
    "no": "No",
    "selected": "Seleccionado",
    "editGroup": "Editar grupo",
    "viewGroup": "Ver grupo",
    "numberOfMembers": "N° de miembros",
    "groupMembers": "Miembros del grupo",
    "editGroups": "Editar grupos",
    "noUsers": "Sin usuarios",
    "deleteGroup": "Eliminar grupo",
    "documents": "Documentos",
    "images": "Imágenes",
    "audio": "Audio",
    "video": "Video",
    "other": "Otro",
    "fileExtensionType": {
      "Text": "Texto",
      "SourceCode": "Código fuente",
      "Markup": "Markup",
      "Data": "Datos",
      "Image": "Imagen",
      "Video": "Video",
      "Audio": "Audio",
      "Document": "Documento",
      "Spreadsheet": "Hoja de cálculo",
      "Presentation": "Presentación",
      "Archive": "Archivo",
      "Database": "Base de datos",
      "Font": "Fuente",
      "System": "Sistema",
      "Executable": "Ejecutable",
      "Configuration": "Configuración",
      "Log": "Log",
      "Backup": "Copia de seguridad",
      "Certificate": "Certificado",
      "Model3D": "Modelo 3D",
      "CAD": "CAD",
      "GIS": "SIG",
      "Scientific": "Científico",
      "EBook": "E-Book",
      "Vector": "Vectorial",
      "Raw": "Raw"
    },
    "fileTypes": "Tipos de archivo",
    "download": "Descargar",
    "share": "Compartir",
    "createCopy": "Crear copia",
    "markAsRead": "Marcar como leído",
    "markAsUnread": "Marcar como no leído",
    "move": "Mover",
    "convertToPdf": "Convertir a PDF",
    "convert": "Convertir",
    "wordDocument": "Documento de Word",
    "excelDocument": "Documento de Excel",
    "pptDocument": "Documento de PowerPoint",
    "hideFromList": "Ocultar de la lista",
    "showInList": "Mostrar en la lista",
    "editAccessAndProtections": "Editar acceso y protecciones",
    "tagColor": "Color de etiqueta",
    "tagName": "Nombre de etiqueta",
    "addToFavorites": "Añadir a favoritos",
    "removeFromFavorites": "Eliminar de favoritos",
    "deletePermanently": "Eliminar permanentemente",
    "delete": "Eliminar",
    "selectedItems": "Elementos seleccionados",
    "deselectAll": "Deseleccionar todo",
    "signOut": "Cerrar sesión",
    "tagTitle": "Título de Etiqueta",
    "noTagsYet": "No hay etiquetas aún",
    "untitledDocument": "Documento sin Título",
    "copyOf": "Copia de",
    "restoreFromTrash": "Restaurar de la papelera",
    "shared": "Compartido",
    "expiresOn": "Caduca el {{date}}",
    "shareExpiredOn": "Compartido caducado el {{date}}",
    "favourite": "Favorito",
    "favouriteAddedTo": "añadido a",
    "favouriteRemovedFrom": "eliminado de",
    "publicLinkLabel": "Enlace público",
    "classificationInProgress": "Clasificación en curso",
    "forSale": "En venta",
    "favorites": "Favoritos",
    "recent": "Recientes",
    "transferOwnership": "Transferir propiedad",
    "trash": "Papelera",
    "expirationDate": "Fecha de expiración",
    "details": "Detalles",
    "unlock": "Desbloquear",
    "activities": "Actividades",
    "copyToClipboard": "Copiar al portapapeles",
    "fileType": "Tipo de archivo",
    "noTagsApplied": "No se han aplicado etiquetas a este archivo",
    "notSharedYet": "No compartido aún",
    "manageAccess": "Gestionar acceso",
    "selectItemToViewDetails": "Selecciona un elemento para ver sus detalles",
    "unlockFolderToViewDetails": "Desbloquea la carpeta para ver los detalles",
    "unlockFolderToViewSize": "Desbloquea la carpeta para ver el tamaño",
    "folderContent": "Contenido de la carpeta",
    "calculateFolderSize": "Calcular tamaño",
    "recalculate": "Recalcular",
    "recalculateCooldown": "Espera un momento antes de recalcular",
    "subfolders": "Subcarpetas",
    "totalSize": "Tamaño total",
    "filters": "Filtros",
    "owner": "Propietario",
    "linkCopied": "¡Enlace copiado al portapapeles!",
    "account": "Cuenta",
    "customization": "Personalización",
    "adminRegisteredUserVisibility": "Visibilidad de Usuarios Registrados por Administrador",
    "adminRegisteredUserVisibilityDescription": "Hacer visibles a los usuarios registrados por administrador a menos que estén desactivados; visibilidad solo a través de compartición de archivos.",
    "autoFileDeletion": "Eliminación Automática de Archivos",
    "autoFileDeletionDescription": "Eliminar automáticamente archivos después de una fecha de creación especificada y período de retención.",
    "cannotOpenFileOnBehalf": "No puedes abrir archivos en Modo En Nombre De.",
    "certifiedTimestamping": "Sellado de Tiempo Certificado",
    "certifiedTimestampingDescription": "Permitir a los colaboradores aplicar una fecha certificada a los archivos usando un certificado digital.",
    "compressionCompleted": "Compresión completada",
    "compressionFailed": "Compresión fallida",
    "compressionOfFilesInProgress": "Compresión de archivos en progreso",
    "verifyingFileIntegrity": "Verificando integridad del archivo...",
    "fileIntegrityVerified": "Integridad del archivo verificada",
    "downloadCompletedWithExclusions": "Descarga completada, pero algunos archivos se excluyeron",
    "moveCompletedWithExclusions": "Movimiento completado, pero algunos archivos no se pudieron mover",
    "filesExcludedForMove": "Los siguientes archivos no se pudieron mover:",
    "excludedFilesTitle": "Archivos excluidos",
    "viewExcludedFiles": "Ver archivos excluidos",
    "filesExcludedForRestrictions": "Algunos archivos se excluyeron debido a restricciones:",
    "contributorStorageLimit": "Límite de Almacenamiento de Colaborador",
    "contributorStorageLimitDescription": "Establecer límites de espacio de almacenamiento para que los colaboradores suban nuevos archivos.",
    "contents": "Contenidos",
    "deviceAccessLimitation": "Limitación de Acceso de Dispositivo",
    "deviceAccessLimitationDescription": "Limitar el acceso a un número de dispositivos y desconectar los más antiguos.",
    "downloadPreparation": "Preparando descarga",
    "downloadReady": "Descarga lista",
    "editorFileManagement": "Gestión de Archivos del Editor",
    "editorFileManagementDescription": "Permitir a los colaboradores eliminar y renombrar archivos según los permisos.",
    "fileSizeLimit": "Límite de Tamaño de Archivo",
    "fileSizeLimitDescription": "Restringir el tamaño máximo de cada archivo que se puede subir.",
    "fileTypeRestriction": "Restricción de Tipo de Archivo",
    "fileTypeRestrictionDescription": "Permitir a los usuarios compartir todos los tipos de archivo o solo tipos seleccionados.",
    "folderCreationPermission": "Permiso de Creación de Carpetas",
    "folderCreationPermissionDescription": "Definir si los colaboradores tienen permiso para crear nuevas carpetas.",
    "groupCreationControl": "Control de Creación de Grupos",
    "groupCreationControlDescription": "Controlar qué colaboradores tienen permitido crear grupos.",
    "members": "Miembros",
    "msOfficeEditing": "Edición de Word, Excel, PowerPoint",
    "msOfficeEditingDescription": "Permitir a los miembros editar documentos directamente con el editor en línea de Microsoft Office.",
    "newButton": "Nuevo",
    "security": "Seguridad",
    "sessionControl": "Control de Sesión",
    "sessionControlDescription": "Limita el número de sesiones concurrentes por usuario.",
    "sessions": "Sesiones",
    "superAdmins": "Súper Administradores",
    "uploadWithTag": "Subir con Etiqueta",
    "uploadWithTagDescription": "Capturar y establecer automáticamente etiquetas detectadas en archivos fuente.",
    "watermarkProtection": "Protección con Marca de Agua",
    "watermarkProtectionDescription": "Permitir a los miembros proteger sus archivos con marcas de agua.",
    "withExpiration": "Con expiración",
    "withoutExpiration": "Sin expiración",
    "addTag": "Añadir etiqueta",
    "openFileLocation": "Abrir ubicación del archivo",
    "loadingTags": "Cargando etiquetas...",
    "unlimited": "Ilimitado",
    "dropHereYourFirstFile": "Suelta aquí tu primer archivo",
    "noFilesReceived": "No se recibieron archivos",
    "hereYouCanFindFavoritesFiles": "Aquí puedes encontrar tus archivos favoritos",
    "noRecentlyOpenedFiles": "No hay archivos abiertos recientemente",
    "hereYouCanFindSharedFiles": "Aquí puedes encontrar archivos compartidos",
    "hereYouCanFindDeletedFiles": "Aquí puedes encontrar archivos eliminados",
    "noFiles": "Sin archivos",
    "loadingFiles": "Cargando archivos...",
    "filesFetchFailed": "No se pudieron cargar los archivos. Comprueba la conexión e inténtalo de nuevo.",
    "shareDisabledNoRecipients": "Añade al menos un usuario o grupo para compartir",
    "shareDisabledNoChanges": "No hay cambios que guardar",
    "editorDisabledByPolicy": "El permiso Editor no está permitido para estos archivos",
    "editorDisabledCannotElevate": "No puedes elevar este recurso compartido a Editor",
    "hereYouCanFindHiddenFiles": "Aquí puedes encontrar archivos ocultos",
    "noFilesInThisFolder": "No hay archivos en esta carpeta",
    "noGroupsFound": "No se encontraron grupos",
    "sell": "Vender",
    "loadingPermissions": "Cargando permisos...",
    "me": "Yo",
    "applyTags": "Aplicar etiquetas",
    "emptyTrash": "Vaciar papelera",
    "classify": "Clasificación por IA",
    "active": "Activo",
    "activeDescription": "Activar o desactivar esta configuración",
    "add": "Añadir",
    "rule": "Regla",
    "selectTags": "Seleccionar etiquetas",
    "manageExceptions": "Gestionar excepciones",
    "selectFolders": "Seleccionar carpetas",
    "none": "Ninguno",
    "addRule": "Añadir regla",
    "addConfiguration": "Añadir configuración",
    "aiAgents": "Agentes de IA",
    "daysLeft": "días restantes",
    "disabled": "Deshabilitado",
    "enabled": "Habilitado",
    "months": "Meses",
    "years": "Años",
    "totpStatus": {
      "enabled": "2FA activa",
      "enabledExempt": "2FA activa (exenta)",
      "exempt": "Exento de 2FA",
      "exemptExpires": "Exento hasta el {{date}}"
    },
    "clientId": "ID de Cliente",
    "clientSecret": "Secreto de Cliente",
    "tenantId": "ID de Inquilino",
    "domains": "Dominios",
    "addDomain": "Añadir dominio",
    "addItem": "Añadir elemento",
    "artificialIntelligence": "Inteligencia Artificial",
    "artificialIntelligenceSummary": "Resumen de IA",
    "artificialIntelligenceDocumentChat": "Chat con documento",
    "generatingSummary": "Generando resumen",
    "startNewConversation": "Iniciar una nueva conversación",
    "groupMembership": "Membresía de grupo",
    "expired": "Expirado",
    "onlyExpired": "Caducidad",
    "expiredOnly": "Solo caducados",
    "expiringWithinDays": "Caduca en",
    "expiringWithinDaysOption": "{{count}} días",
    "expiringWithinDaysOption_one": "{{count}} día",
    "sharedBy": "Compartido por",
    "shareRequests": "Solicitudes de compartición",
    "fileShareRequests": "Solicitudes de compartición de archivos",
    "noShareRequests": "No hay solicitudes de compartir",
    "activityLog": "Registro de actividad",
    "targetType": "Tipo de objetivo",
    "operationType": "Tipo de operación",
    "fromDate": "Desde fecha",
    "toDate": "Hasta fecha",
    "classificationStatus": "Clasificación por IA",
    "invite": "Invitar",
    "send": "Enviar",
    "sendMessage": "Enviar mensaje",
    "target": "Objetivo",
    "operation": "Operación",
    "timestamp": "Marca de tiempo",
    "export": "Exportar",
    "exportActivityLogsDescription": "Exportar los registros de actividad visibles a un archivo CSV",
    "clickForDetailAiClassification": "Haz clic para detalles de la clasificación por IA",
    "aiClassificationStatus": "Estado de Clasificación por IA",
    "noActivityLogsFound": "No se encontraron registros de actividad",
    "activityLogQuickFilters": {
      "clearDatesAndOperation": "Borrar filtros de fecha y tipo",
      "downloads24h": "Descargas de archivos en las últimas 24 horas",
      "failedLogins7d": "Inicios de sesión fallidos en los últimos 7 días",
      "last24hAllActivity": "Toda la actividad en las últimas 24 horas",
      "last24hLogins": "Inicios de sesión en las últimas 24 horas",
      "last7DaysAllActivity": "Toda la actividad en los últimos 7 días",
      "sharing7d": "Compartir archivos en los últimos 7 días",
      "title": "Filtros rápidos"
    },
    "waitingForUpload": "Esperando subida",
    "waitingForNetwork": "Esperando red",
    "uploadsPausedWaitingForNetwork": "Subidas en pausa — esperando conexión de red",
    "offline": "Desconectado",
    "noPermissions": "Sin permisos",
    "additionalData": "Datos adicionales",
    "noActivities": "Sin actividades",
    "multipleOwners": "Múltiples propietarios",
    "mixed": "Mixto",
    "firstName": "Nombre",
    "lastName": "Apellido",
    "multipleExpiryDates": "Múltiples fechas de expiración",
    "copied": "¡Copiado!",
    "copy": "Copiar",
    "editFile": "Editar archivo",
    "untitled": "Sin título",
    "editModeEnabled": "Modo de edición habilitado",
    "exitEditMode": "Salir del modo de edición",
    "editModeDisabled": "Modo de edición deshabilitado",
    "reload": "Recargar",
    "forward10Seconds": "Avanzar 10 segundos",
    "backward10Seconds": "Retroceder 10 segundos",
    "goToStart": "Ir al inicio",
    "goToEnd": "Ir al final",
    "playbackSpeed": "Velocidad de reproducción",
    "error": "Error",
    "shareAgain": "Compartir de nuevo",
    "expiringSoon": "Expirando pronto",
    "filterByTargetOrOperation": "Filtrar por objetivo o operación",
    "searchByFileName": "Buscar por nombre de archivo",
    "showMoreVersions": "Mostrar más versiones",
    "showLessVersions": "Mostrar menos versiones",
    "currentVersion": "Versión actual",
    "bold": "Negrita",
    "italic": "Cursiva",
    "link": "Enlace",
    "unorderedList": "Lista desordenada",
    "orderedList": "Lista ordenada",
    "header1": "Encabezado 1",
    "header2": "Encabezado 2",
    "header3": "Encabezado 3",
    "paragraph": "Párrafo",
    "secondsAgo": "segundos atrás",
    "all": "Todos",
    "dataLossPrevention": "Prevención de Pérdida de Datos",
    "uploadSuccess": "Carga exitosa",
    "uploading": "Cargando",
    "readOnly": "Solo lectura",
    "aiScrapingProtectionOn": "Protección de scraping AI activo",
    "openFileLocally": "Abrir archivo localmente",
    "reloadPage": "Recargar página",
    "reloadingPageIn": "Recargando la página en <strong>{{count}}</strong>",
    "keepOffline": "Mantener sin conexión",
    "openFileOnline": "Abrir archivo en línea",
    "saveAndContinue": "Guardar y continuar",
    "cancelAndContinue": "Cancelar y continuar",
    "language": "Idioma",
    "colorScheme": {
      "title": "Apariencia",
      "light": "Claro",
      "dark": "Oscuro",
      "system": "Seguir sistema"
    },
    "accessibility": {
      "title": "Accesibilidad",
      "highContrast": "Alto contraste",
      "reduceMotion": "Reducir movimiento",
      "none": "Desactivado",
      "activeCount": "{{count}} activas"
    },
    "impersonateUser": "Suplantar usuario",
    "protect": "Proteger",
    "setPassword": "Establecer contraseña",
    "password": "Contraseña",
    "stopImpersonation": "Detener suplantación",
    "loggedInAs": "Conectado como",
    "enterReason": "Ingrese el motivo de la suplantación...",
    "timeRemaining": "Tiempo restante",
    "notifications": "Notificaciones",
    "clear": "Limpiar",
    "markAllRead": "Marcar todas como leídas",
    "clearAll": "Limpiar todo",
    "noNotifications": "Sin notificaciones",
    "batches": "Lotes",
    "noActiveBatches": "No hay lotes activos",
    "refresh": "Actualizar",
    "refreshCooldown": "Espera {{seconds}}s antes de actualizar de nuevo",
    "minutes": "minutos",
    "justNow": "Ahora",
    "minutesAgo": "hace {{count}} minuto",
    "minutesAgo_other": "hace {{count}} minutos",
    "hoursAgo": "hace {{count}} hora",
    "hoursAgo_other": "hace {{count}} horas",
    "daysAgo": "hace {{count}} día",
    "daysAgo_other": "hace {{count}} días",
    "monthsAgo": "hace {{count}} mes",
    "monthsAgo_other": "hace {{count}} meses",
    "yearsAgo": "hace {{count}} año",
    "yearsAgo_other": "hace {{count}} años",
    "inMinutes": "en {{count}} minuto",
    "inMinutes_other": "en {{count}} minutos",
    "inHours": "en {{count}} hora",
    "inHours_other": "en {{count}} horas",
    "inDays": "en {{count}} día",
    "inDays_other": "en {{count}} días",
    "inMonths": "en {{count}} mes",
    "inMonths_other": "en {{count}} meses",
    "inYears": "en {{count}} año",
    "inYears_other": "en {{count}} años",
    "fileNotFound": "Archivo no encontrado",
    "selectAll": "Seleccionar todos",
    "noFilesMatchingFilters": "No se encontraron archivos, intenta eliminar algunos filtros o cambiar los criterios de búsqueda",
    "noUsersMatchingFilters": "No se encontraron usuarios, intenta eliminar algunos filtros o cambiar los criterios de búsqueda",
    "noGroupsMatchingFilters": "No se encontraron grupos, intenta eliminar algunos filtros o cambiar los criterios de búsqueda",
    "selectUsers": "Seleccionar usuarios",
    "selectGroups": "Seleccionar grupos",
    "selectDate": "Seleccionar fecha",
    "clearSelection": "Limpiar selección",
    "import": "Importar",
    "AIGrant": "AIGrant",
    "manageUsersAndGroups": "Gestionar usuarios y grupos",
    "public": "Público",
    "private": "Privado",
    "searchTags": "Buscar etiquetas",
    "expand": "Expandir",
    "showMore": "Mostrar más",
    "collapse": "Contraer",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "pending": "Pendiente",
    "pendingApprovalTooltip": "En espera de aprobación, solicitado {{date}}",
    "approvedByTeamTooltip": "Compartir aprobado por el equipo {{date}}",
    "rejectedByTeamTooltip": "Compartir rechazado por el equipo {{date}}",
    "reject": "Rechazar",
    "rejectFileShareRequest": "Rechazar solicitud de compartir archivo",
    "rejectionReason": "Motivo del rechazo",
    "rejectionReasonPlaceholder": "Ingrese el motivo del rechazo",
    "moreOwners": "Más propietarios",
    "permissionLevel": "Nivel de permiso",
    "name": "Nombre",
    "approve": "Aprobar",
    "from": "De",
    "to": "a",
    "requester": "Solicitante",
    "shareTo": "Compartir Hacia",
    "limitation": "Limitación",
    "selectRequestToViewDetails": "Selecciona una solicitud para ver los detalles",
    "shareRequestApprovalTitle": "Solicitud de aprobación de compartir para {{fileName}}",
    "noFilesAvailable": "No hay archivos disponibles",
    "accessDenied": "Acceso Denegado",
    "fileShareRequestsList": "Lista de solicitudes de compartir archivos",
    "fileShareRequestsDescription": "Aprueba o rechaza las solicitudes de compartir archivos. Haz clic en una solicitud en el lado izquierdo para ver sus detalles.",
    "waiting": "En espera",
    "tagIsUsedForFileVisibility": "Los archivos con esta etiqueta se comparten con otros usuarios según se establece en la configuración de visibilidad de archivos etiquetados",
    "systemTagLocked": "Etiqueta de sistema gestionada por el servidor: no se puede eliminar.",
    "tagRemovalRestricted": "El administrador no permite eliminar esta etiqueta de los archivos.",
    "tagAdditionRestricted": "El administrador no permite añadir esta etiqueta a los archivos.",
    "completingLogin": "Completando inicio de sesión...",
    "redirectingToLogin": "Redirigiendo a la página de inicio de sesión...",
    "redirecting": "Redirigiendo...",
    "sessionExpiresIn": "Esta carpeta se bloqueará nuevamente en {{time}}",
    "protectedFolder": "Carpeta protegida",
    "sessionsTitle": "Sesiones de desbloqueo para {{fileName}}",
    "folderSessions": "Sesiones de carpetas",
    "publicLinks": "Enlaces públicos",
    "revoke": "Revocar",
    "revokeLink": "Revocar enlace público",
    "revokeLinkConfirmDescription": "¿Revocar el enlace público de {{fileName}}?",
    "protectedContentTitle": "Contenido protegido",
    "protectedContentMessage": "Este contenido está protegido con contraseña. Introduce la contraseña para acceder.",
    "accessCodeRequired": "La contraseña es obligatoria.",
    "accessCodeLabel": "Contraseña",
    "accessCodePlaceholder": "Introduce la contraseña",
    "access": "Acceder",
    "folderContents": "Contenido de la carpeta",
    "sharedAt": "Compartido el",
    "alerts": {
      "moreCount": "{{count}} avisos más",
      "manageTwoFactor": "Gestionar 2FA",
      "dismissMenu": "Posponer u ocultar",
      "snoozePreset": {
        "h24": "1 día",
        "h72": "3 días",
        "h168": "1 semana"
      },
      "snoozeHoursGeneric": "{{count}} horas"
    },
    "usersFetchFailed": "No se pudieron cargar los usuarios. Comprueba la conexión e inténtalo de nuevo.",
    "groupsFetchFailed": "No se pudieron cargar los grupos. Comprueba la conexión e inténtalo de nuevo.",
    "emailsFetchFailed": "No se pudieron cargar los correos. Comprueba la conexión e inténtalo de nuevo.",
    "pleaseSelectRole": "Selecciona un rol",
    "selectColor": "Seleccionar color",
    "color": "Color",
    "loadingActivities": "Cargando actividades...",
    "quickShareMessagePlaceholder": "Escribe un mensaje a los usuarios seleccionados...",
    "signFile": "Firmar archivo"
  },
  "totp": {
    "title": "Autenticación de dos factores",
    "menuItem": "Autenticación de dos factores",
    "statusActive": "Activo",
    "statusInactive": "Inactivo",
    "activatedOn": "Activado el {{date}}",
    "backupCodesRemaining": "{{count}} / {{total}} códigos de respaldo restantes",
    "requiredByPolicy": "Tu organización requiere autenticación de dos factores.",
    "gracePeriodEnds": "Tienes hasta el {{date}} para activarla.",
    "activate": "Activar 2FA",
    "setupTitle": "Configurar autenticación de dos factores",
    "scanQR": "Escanea este código QR con tu app de autenticación (Google Authenticator, Microsoft Authenticator, Authy, etc.).",
    "manualEntry": "¿No puedes escanear? Introducir manualmente",
    "hideManual": "Ocultar entrada manual",
    "enterSecretManually": "Introduce este código manualmente en tu app:",
    "copySecret": "Copiar",
    "copied": "Copiado al portapapeles",
    "verifyCodeLabel": "Introduce el código de 6 dígitos de tu app",
    "verifyAndActivate": "Verificar y activar",
    "backupCodesTitle": "¡Autenticación de dos factores activada!",
    "regenerateSuccess": "Códigos de respaldo regenerados",
    "backupCodesWarning": "Guarda estos códigos de respaldo en un lugar seguro. Pueden usarse para acceder a tu cuenta si pierdes el acceso a tu app de autenticación. Cada código solo puede usarse una vez.",
    "copyAll": "Copiar todos",
    "download": "Descargar",
    "print": "Imprimir",
    "savedConfirm": "He guardado estos códigos en un lugar seguro",
    "continue": "Continuar",
    "regenerateBackupCodes": "Regenerar códigos de respaldo",
    "disableTotp": "Desactivar 2FA",
    "disableConfirm": "¿Desactivar autenticación de dos factores?",
    "disableConfirmDescription": "Quitar la 2FA hará tu cuenta menos segura. Tendrás que reconfigurar tu app de autenticación si quieres volver a activar la 2FA.",
    "enterCodeToConfirm": "Introduce el código TOTP para confirmar",
    "cancel": "Cancelar",
    "disable": "Desactivar",
    "disabledSuccess": "La autenticación de dos factores se ha desactivado.",
    "invalidCode": "Código no válido. Inténtalo de nuevo.",
    "errorGeneric": "Algo ha ido mal. Inténtalo de nuevo.",
    "retry": "Reintentar",
    "admin": {
      "modalTitle": "2FA – {{userName}}",
      "statusTitle": "Estado 2FA",
      "totpEnabled": "TOTP activado",
      "enabledAt": "Activado el",
      "backupCodesRemaining": "Códigos de respaldo restantes",
      "requiredByPolicy": "Requerido por política",
      "lockoutStatus": "Estado de bloqueo",
      "failedAttempts": "Intentos fallidos",
      "exemptionTitle": "Exención TOTP",
      "grantExemption": "Conceder exención",
      "revokeExemption": "Revocar exención",
      "exemptionTypeTemporary": "Temporal",
      "exemptionTypePermanent": "Permanente",
      "exemptionTypeLabel": "Tipo",
      "exemptionExpires": "Caduca el",
      "exemptionReason": "Motivo",
      "grantedBy": "Concedido por",
      "grantedAt": "Fecha de concesión",
      "grantDialogTitle": "Conceder exención",
      "grantDialogTemporary": "Temporal",
      "grantDialogPermanent": "Permanente",
      "grantDialogDays": "Días",
      "grantDialogReason": "Motivo (mín. 5 caracteres)",
      "grantSubmit": "Conceder",
      "revokeConfirmTitle": "Revocar exención",
      "revokeConfirmDescription": "El usuario deberá volver a cumplir la política 2FA.",
      "disableConfirmTitle": "¿Desactivar 2FA para este usuario?",
      "disableConfirmDescription": "Se eliminará la autenticación de dos factores para el usuario. Deberá configurarla de nuevo si la política lo requiere.",
      "statusLoading": "Cargando…",
      "statusError": "Error al cargar el estado 2FA.",
      "grantSuccess": "Exención concedida.",
      "revokeSuccess": "Exención revocada.",
      "disableSuccess": "2FA desactivada."
    }
  },
  "roles": {
    "1000": "Super Admin",
    "1001": "Administrador",
    "2001": "Colaborador",
    "3002": "Lector",
    "4001": "Externo"
  },
  "accessMap": {
    "tagAccessTabLabel": "Acceso y protecciones",
    "entityAccessTabLabel": "Etiquetas y protecciones",
    "visibility": "Visibilidad",
    "appliedProtections": "Protecciones aplicadas",
    "appliedTo": "Aplicado a",
    "appliedToNobody": "Nadie recibe actualmente esta protección a través de esta etiqueta.",
    "configuration": "Configuración",
    "exceptions": "Excepciones",
    "exceptionsCount": "{{count}} excepción",
    "exceptionsCount_one": "{{count}} excepción",
    "exceptionsCount_other": "{{count}} excepciones",
    "hasExceptionsTooltip": "Algunos destinatarios están excluidos de esta protección.",
    "openInSettings": "Abrir en ajustes",
    "noProtectionsForTag": "Aún no hay protecciones aplicadas a esta etiqueta.",
    "noProtectionsForThisTag": "Ninguna protección heredada de esta etiqueta.",
    "configureProtection": "Configurar una protección",
    "publicTagShort": "Pública",
    "privateTagShort": "Privada",
    "allUsersInCompany": "Todos los usuarios de la empresa",
    "tagNotShared": "Esta etiqueta aún no se ha compartido con nadie.",
    "protectionsCount": "{{count}} protección",
    "protectionsCount_one": "{{count}} protección",
    "protectionsCount_other": "{{count}} protecciones",
    "inheritedFromGroups": "Visible a través de los grupos: {{groups}}",
    "tagsVisibleToGroup": "Etiquetas visibles para este grupo ({{count}})",
    "tagsVisibleToUser": "Etiquetas visibles para este usuario ({{count}})",
    "rulesAppliedToGroup": "Reglas de protección aplicadas a este grupo ({{count}})",
    "rulesAppliedToUser": "Reglas de protección aplicadas a este usuario ({{count}})",
    "userSeesNoTags": "Este usuario no ve ninguna etiqueta.",
    "groupSeesNoTags": "Este grupo no ve ninguna etiqueta.",
    "tagNoRulesLead": "Los archivos con esta etiqueta no activan ninguna regla específica para este grupo.",
    "tagRulesLead": "Los archivos con esta etiqueta activan la siguiente regla:",
    "tagRulesLead_one": "Los archivos con esta etiqueta activan la siguiente regla:",
    "tagRulesLead_other": "Los archivos con esta etiqueta activan las siguientes {{count}} reglas:",
    "summary": {
      "action": "Acción",
      "behaviour": "Comportamiento",
      "readOnlyRoles": "Roles de solo lectura",
      "showRecipients": "Mostrar destinatarios originales",
      "allowEdit": "Permitir edición",
      "readOnlyMode": "Modo solo lectura",
      "watermarkText": "Texto de la marca de agua",
      "placement": "Posición",
      "appliesToExternal": "Aplicación de Usuario Externo",
      "approvedDomains": "Dominios aprobados",
      "maxExpirationDays": "Duración máxima permitida",
      "excludedDomains": "Dominios excluidos",
      "excludedGroups": "Grupos excluidos",
      "requireApprovalOnShare": "Requisito general de aprobación",
      "requireApprovalOnReshare": "Aprobación solo para archivos vuelto a compartir",
      "reviewTeamSize": "Equipo de revisión",
      "hiddenFileTypes": "Invisible tras compartir",
      "allowedApplications": "Aplicaciones permitidas",
      "rolesAllowed": "Audiencia"
    }
  },
  "alerts": {
    "codes": {
      "TOTP_NOT_ENABLED": {
        "message": "Se requiere autenticación de dos factores. Actívala para proteger tu cuenta."
      },
      "LICENSE_EXPIRING": {
        "message": "Tu licencia caduca el {{expirationDate}} (quedan {{daysRemaining}} días)."
      },
      "LOW_BACKUP_CODES": {
        "message": "Te quedan pocos códigos de respaldo ({{remaining}}). Regenera en la configuración 2FA."
      },
      "_generic": {
        "message": "Tienes un aviso activo ({{code}}). Contacta al administrador si necesitas ayuda."
      }
    }
  },
  "errors": {
    "required": "Este campo es obligatorio",
    "minLength": "Debe tener al menos {{min}} caracteres",
    "authenticatorCodeInvalid": "El código del autenticador no es válido.",
    "authenticatorNotRemoved": "Ocurrió un error al eliminar el autenticador.",
    "authenticationUserBlocked": "El usuario está bloqueado. Por favor contacta al administrador.",
    "authenticationUserExpired": "El usuario ha expirado. Por favor contacta al administrador.",
    "codeIncorrect": "El código que ingresaste es incorrecto. Por favor intenta de nuevo.",
    "genericDeleteError": "Ocurrió un error al eliminar {{resource}}. Por favor intenta de nuevo o contacta soporte si el problema persiste.",
    "genericError": "Ocurrió un error. Por favor intenta de nuevo o contacta soporte si el problema persiste.",
    "genericFetchError": "Ocurrió un error al obtener {{resource}}. Por favor intenta de nuevo o contacta soporte si el problema persiste.",
    "userProfileUnavailable": "No pudimos cargar tu perfil. Sigues conectado con permisos limitados hasta que se resuelva.",
    "userProfileStale": "No pudimos actualizar tu perfil. Sigues conectado con tus últimos permisos conocidos.",
    "userProfileRetry": "Reintentar",
    "alerts": {
      "dismissFailed": "No se pudo actualizar el aviso. Inténtalo de nuevo.",
      "invalidSnooze": "Elige una duración de posposición válida.",
      "fetchFailed": "No se pudieron cargar los avisos. Se reintentará automáticamente."
    },
    "sessionsFetchError": "Error al obtener las sesiones.",
    "sessionsRevokeError": "Error al revocar la sesión.",
    "sessionsRevokeForbiddenError": "No tienes permisos para revocar las sesiones de este usuario.",
    "sessionsRevokeOthersError": "Error al revocar otras sesiones.",
    "sessionsRevokeAllError": "Error al revocar todas las sesiones.",
    "genericUpdateError": "Ocurrió un error al actualizar {{resource}}. Por favor intenta de nuevo o contacta soporte si el problema persiste.",
    "genericCreateError": "Ocurrió un error al crear {{resource}}. Por favor intenta de nuevo o contacta soporte si el problema persiste.",
    "invalidCredentials": "Correo electrónico o contraseña incorrectos. Por favor verifica tus credenciales e intenta de nuevo.",
    "invalidUsername": "El nombre de usuario que ingresaste no es válido.",
    "tokenInvalid": "El token proporcionado no es válido o ha expired.",
    "tokenExpired": "Token de acceso expirado",
    "unsavedChangesMessage": "Tienes cambios sin guardar. ¿Estás seguro de que quieres salir y perder estos cambios?",
    "unsavedChangesTitle": "Cambios sin Guardar Detectados.",
    "licenseExpired": "La licencia ha expirado. Por favor renueva tu licencia.",
    "licenseMaxUsersReached": "Se ha alcanzado el número máximo de usuarios permitido por esta licencia. No es posible añadir nuevos usuarios ni asignar roles no externos a usuarios existentes.",
    "mandatoryClassificationCannotRemove": "No se pueden eliminar todas las etiquetas de clasificación. Debe permanecer al menos una porque la clasificación obligatoria de archivos está activada en la configuración de la organización.",
    "tagRemovalDenied": "No tienes permiso para eliminar una o más de las etiquetas seleccionadas de este archivo.",
    "tagAdditionDenied": "No tienes permiso para añadir una o más de las etiquetas seleccionadas a este archivo.",
    "emailNotFound": "La dirección de correo electrónico {{email}} no está registrada. Por favor verifica tu dirección de correo electrónico e intenta de nuevo.",
    "invalidEmailOrUsername": "Introduce un correo o nombre de usuario válido",
    "loginAliasNotValid": "Este alias de inicio de sesión no es válido. Usa solo letras, dígitos y . _ - @ + ' (máx. 256 caracteres).",
    "loginAliasAlreadyUsed": "Este alias de inicio de sesión ya está en uso por otro usuario.",
    "loginAliasAlreadyUsedAsEmail": "Este correo ya se usa como alias de inicio de sesión de otro usuario.",
    "otpExpired": "El OTP ha expirado. Por favor solicita un nuevo OTP.",
    "totpWrong": "Código 2FA no válido. Inténtalo de nuevo.",
    "temporaryTotpExpired": "El tiempo para completar el inicio de sesión ha expirado.",
    "errorAdminTotpResetNotAllowed": "No se puede desactivar la 2FA: tu organización no permite que los administradores restablezcan el TOTP de los usuarios. Un súper administrador puede permitirlo en la configuración de autenticación en dos pasos (TOTP).",
    "transferOwnershipFailed": "No se pudo transferir la propiedad. Inténtalo de nuevo o contacta con soporte.",
    "otpRequestLimitExceeded": "Has excedido el límite para solicitar OTPs. Por favor intenta de nuevo más tarde.",
    "requestFilePermissions": "Intenta contactar al propietario del archivo para renovar tus permisos",
    "noUploadPermission": "No tienes permiso para subir archivos en esta ubicación.",
    "publicLinkClassificationRequired": "El archivo debe estar clasificado antes de crear un enlace público.",
    "publicLinkPasswordRequired": "Se requiere una contraseña para los enlaces públicos.",
    "publicLinkMaxAccessCountRequired": "Se requiere un número máximo de accesos.",
    "publicLinkExpirationRequired": "Se requiere una fecha de expiración.",
    "publicLinkExpirationExceeded": "La expiración supera el número máximo de días permitidos.",
    "publicLinkExpirationInPast": "La fecha de expiración debe ser una fecha futura.",
    "publicLinkFolderPasswordProtected": "No se puede crear un enlace público para carpetas protegidas con contraseña ni para archivos dentro de ellas. Para compartir por enlace público, elimina la protección con contraseña de la carpeta.",
    "publicLinkDownloadRestricted": "No se puede crear un enlace público porque la aplicación de cifrado en descarga está activa para este archivo o sus etiquetas. Para compartir por enlace público, elimina la restricción en la configuración de Aplicación de cifrado en descarga.",
    "publicLinkAnticaptureActive": "No se puede crear un enlace público porque el modo anti-captura está activo para este archivo o sus etiquetas. Para compartir por enlace público, elimina anti-captura del archivo o de la configuración de etiquetas aplicable.",
    "publicLinkExternalSharingRestricted": "No se puede crear un enlace público porque las restricciones de compartición externa están activas para este archivo o sus etiquetas. Para compartir por enlace público, elimina los límites aplicables en la configuración de Restricciones de compartición externa.",
    "publicLinkResharingDenied": "No se puede crear un enlace público porque el reenvío no está permitido para este archivo o sus etiquetas. Para compartir por enlace público, revisa y actualiza la configuración de Permisos de reenvío de archivos.",
    "publicLinkDownloadTagsRestricted": "No se puede crear un enlace público porque las restricciones de descarga están activas para este archivo o sus etiquetas. Para compartir por enlace público, revisa la configuración de Etiquetas permitidas para descarga.",
    "publicLinkApprovalRequired": "No se puede crear un enlace público porque se requiere aprobación para compartir este archivo o sus etiquetas. Para compartir por enlace público, revisa la configuración de Requisitos de aprobación para compartición.",
    "publicLinkMandatoryExpiration": "No se puede crear un enlace público porque la política de expiración obligatoria está activa para este archivo o sus etiquetas. Para compartir por enlace público, asegúrate de que la fecha de expiración esté dentro del límite definido en la configuración de Expiración obligatoria archivo compartido.",
    "tagsAmountLimitReached": "No puedes crear más de {{limit}} etiquetas.",
    "hitASnag": "¡Ups! Hubo un problema. Por favor intenta de nuevo...",
    "noPermission": "No tienes permiso para realizar esta acción.",
    "errorDownloadFile": "Hubo un problema descargando el archivo. Por favor intenta de nuevo.",
    "errorDuplicateFile": "Hubo un problema duplicando el archivo. Por favor intenta de nuevo.",
    "errorMoveFile": "Hubo un problema moviendo el archivo. Por favor intenta de nuevo.",
    "denyFileMove": "No se permite mover este archivo.",
    "errorDeleteFiles": "Hubo un problema eliminando los archivos. Por favor intenta de nuevo.",
    "errorHideFiles": "Hubo un problema al ocultar los archivos. Por favor intenta de nuevo.",
    "errorUploadFile": "Hubo un problema subiendo el archivo. Por favor intenta de nuevo.",
    "cannotAddArchivedFilesToFavorites": "Los archivos archivados no se pueden añadir a favoritos.",
    "cannotDeleteMultiplePasswordProtected": "No se pueden eliminar los elementos seleccionados porque hay varias carpetas protegidas con contraseña bloqueadas. Desbloquea cada carpeta individualmente e intenta de nuevo.",
    "cannotUnlockMultiplePasswordProtected": "No se pueden desbloquear varias carpetas protegidas con contraseña a la vez. Desbloquea cada carpeta individualmente.",
    "groupNameCannotBeEmail": "El nombre del grupo no puede ser una dirección de correo electrónico.",
    "invalidFolder": "Esta carpeta es inválida.",
    "invalidFolderUpload": "La carpeta que intentas subir no existe o no es compatible.",
    "zeroByteFileNotUploaded": "Los archivos de 0 bytes no se suben. Selecciona archivos con contenido.",
    "loginFailed": "Error de inicio de sesión",
    "unauthorized": "Autenticación fallida. Por favor intenta de nuevo.",
    "forbidden": "Acceso denegado",
    "serverError": "Error del servidor. Por favor intenta de nuevo más tarde.",
    "tooManyRequests": "Demasiadas solicitudes. Por favor intenta de nuevo más tarde.",
    "oauthAccessDenied": "Acceso denegado por el usuario",
    "oauthInvalidCallback": "Callback OAuth no válido",
    "oauthStateMismatch": "Verificación de seguridad fallida",
    "oauthContextMissing": "Contexto OAuth faltante",
    "oauthProviderNotEnabled": "Proveedor OAuth no habilitado",
    "oauthNotEnabled": "OAuth directo no habilitado para este tenant",
    "oauthDomainNotAllowed": "Dominio de correo no permitido",
    "oauthEmailMismatch": "Has iniciado sesión con una cuenta distinta del correo que introdujiste. Inicia sesión con la cuenta correcta.",
    "oauthCodeExchangeFailed": "Error al intercambiar el código de autorización",
    "oauthTokenValidationFailed": "Validación del token fallida",
    "oauthInvalidTenant": "Tenant no válido",
    "oauthSessionExpired": "Sesión expirada. Por favor intenta de nuevo.",
    "sessionExpired": "Tu sesión ha expirado. Por favor inicia sesión de nuevo.",
    "filePasswordLockout": "Esta carpeta está bloqueada por demasiados intentos fallidos. Inténtalo de nuevo en {{minutes}} minutos.",
    "getViewerData": "Hubo un problema obteniendo los datos del visualizador. Por favor intenta de nuevo.",
    "protectedLinkAlreadyUsed": "Enlace ya usado, genera un nuevo código",
    "protectedLinkAlreadyUsedOrExpired": "Enlace ya usado o caducado, genera un nuevo código",
    "fileAccessSessionExpired": "Sesión caducada, genera un nuevo código",
    "protectedFileDownloadOnlyForWindows": "La descarga de archivos protegidos está disponible solo para plataforma Windows.",
    "antiCaptureActivated": "Este elemento está protegido por configuraciones anti-captura.",
    "downloadRestrictionActivated": "Este elemento está protegido por configuraciones de restricción de descarga.",
    "watermarkProtectionDownloadDenied": "Este archivo está protegido y no se puede descargar. Aún puedes verlo.",
    "antivirusFileInfected": "Este archivo no se puede abrir ni compartir porque el antivirus detectó una amenaza.",
    "antivirusFileInfectedNamed": "El antivirus detectó {{threatName}} en {{fileName}}.",
    "antivirusRescanNotAllowed": "No tiene permiso para solicitar un nuevo análisis antivirus de este archivo.",
    "antivirusNotAvailable": "El análisis antivirus no está disponible en este momento. Inténtelo más tarde.",
    "fileSizeTooBigForDownload": "El archivo no se puede descargar en modo cifrado porque supera los 250 MB.",
    "fileNotAvailable": {
      "title": "El archivo ya no está disponible",
      "description": "El archivo al que intentas acceder ya no está disponible. Es posible que haya sido eliminado o movido."
    },
    "publicLinkNotFoundTitle": "Este enlace no está disponible",
    "publicLinkNotFoundMessage": "Este enlace no existe, fue eliminado o ya no es accesible.",
    "publicLinkItemNotAvailable": "Este elemento no está disponible",
    "publicLinkExpiredTitle": "Enlace caducado",
    "publicLinkExpiredMessage": "Este enlace ha caducado y ya no es válido.",
    "publicLinkMaxAccessTitle": "Límite de accesos alcanzado",
    "publicLinkMaxAccessMessage": "Se ha alcanzado el número máximo de accesos para este enlace.",
    "invalidAccessCode": "La contraseña introducida no es correcta. Inténtalo de nuevo.",
    "fileSizeUploadLimit": "El archivo size exceeds the upload limit of {{value}} mb",
    "fileSizeExceedsAdminLimit": "No se puede cargar el archivo: el tamaño supera el límite máximo establecido por el administrador.",
    "fileSizeExceedsLicenseLimit": "No se puede cargar el archivo: el tamaño supera el límite máximo establecido en la licencia.",
    "uploadingFileError": "Hubo un problema subiendo el archivo.",
    "uploadInterrupted": "Subida cancelada por el usuario.",
    "fileTypeRestrictionError": "Este tipo de archivo no se puede cargar debido a la configuración aplicada.",
    "quickShareError": "Hubo un problema compartiendo los archivos. Por favor intenta de nuevo.",
    "quickShareFilesNotUploaded": "{{ count }} archivo no se subió exitosamente. Haz clic en Continuar para compartir los archivos subidos exitosamente de todos modos.",
    "quickShareFilesNotUploaded_other": "{{ count }} archivos no se subieron exitosamente. Haz clic en Continuar para compartir los archivos subidos exitosamente de todos modos.",
    "quickShareFilesNotShared": "Los archivos no se compartieron exitosamente. Haz clic en Continuar para compartir los archivos subidos exitosamente de todos modos.",
    "filesNotShared": "Los archivos no se compartieron.",
    "enterOnBehalfOfUserFailed": "Error al entrar en nombre del usuario. Inténtalo de nuevo.",
    "exitOnBehalfOfUserFailed": "Error al salir del modo en nombre del usuario. Inténtalo de nuevo.",
    "reasonRequired": "Por favor ingrese un motivo para entrar en nombre del usuario",
    "reasonMinLength": "El motivo debe tener al menos 3 caracteres",
    "impersonatedUserNotNotified": "No se pudo notificar al usuario por correo (no hay dirección de correo en la cuenta)",
    "fileSizeExceedsLimit": "El tamaño del archivo excede el límite de {{value}}.",
    "otpWrong": "El código OTP es incorrecto. Por favor intenta de nuevo.",
    "groupNameAlreadyUsed": "El nombre del grupo ya está en uso.",
    "updateFileAccessError": "Hubo un problema actualizando el acceso al archivo. Por favor intenta de nuevo.",
    "deleteFileAccessError": "Hubo un problema eliminando el acceso al archivo. Por favor intenta de nuevo.",
    "errorCreateFileShortcut": "Hubo un problema creando el acceso directo del archivo. Por favor intenta de nuevo.",
    "openShortcutFileError": "Ups, parece que el archivo vinculado ya no está disponible. Podría haber sido eliminado o el acceso revocado.",
    "confirmationMessageMatch": "El mensaje de confirmación no coincide.",
    "emailExist": "El correo electrónico ya existe.",
    "shareFiles": "Hubo un problema compartiendo los archivos. Por favor intenta de nuevo.",
    "genericSellError": "Ocurrió un error al listar el archivo para venta.",
    "someItemsCannotBeSelected": "Algunos elementos no pueden ser seleccionados",
    "invalidMicrosoftEntraIdToken": "El token de Microsoft Entra ID no es válido o ha expirado.",
    "atLeastOneOption": "Debes seleccionar al menos una opción",
    "groupNameAlreadyExists": "El nombre del grupo ya está en uso.",
    "cannotAddSuperAdminToGroup": "No puedes añadir un Super Admin a un grupo.",
    "editSharingDenied": "No tienes permiso para editar los derechos de acceso para documentos que ya han sido compartidos. Si un usuario no aparece en la lista, significa que ya tiene una compartición activa.",
    "errorRemoveShareFiles": "Hubo un problema eliminando los archivos compartidos. Por favor intenta de nuevo.",
    "noFileClassificationAvailable": "No hay clasificación de archivo disponible en este momento",
    "errorPermanentlyDeleteFiles": "Hubo un problema eliminando los archivos permanentemente. Por favor intenta de nuevo.",
    "aiDocumentChatError": "Ocurrió un error al conversar con el documento. Por favor intenta de nuevo.",
    "filesAlreadyClassified": "Los archivos ya están clasificados",
    "filesBeingClassified": "Los archivos están siendo clasificados actualmente",
    "filesBeingClassifiedDescription": "Por favor espera hasta que el proceso de clasificación actual se complete antes de iniciar uno nuevo.",
    "filesTooBig": "Los archivos exceden el límite de tamaño para clasificación",
    "filesTooBigDescription": "El tamaño máximo permitido para la clasificación con IA es de 250 MB. Por favor selecciona archivos más pequeños.",
    "tooManyFiles": "Demasiados archivos seleccionados",
    "tooManyFilesDescription": "{{files}} archivos seleccionados; el máximo es {{limit}}. Reduce la selección e inténtalo de nuevo.",
    "rejectionReasonRequired": "El motivo del rechazo es obligatorio",
    "rejectionReasonMinLength": "El motivo del rechazo debe tener al menos 3 caracteres",
    "fileAlreadyInUseError": "El archivo ya está en uso por otro usuario.",
    "contentHashMismatchError": "Archivo corrupto durante la carga (hash no coincide)",
    "fileIntegrityCheckFailed": "Verificación de integridad del archivo fallida",
    "fileIntegrityCheckFailedDescription": "El archivo descargado puede estar corrupto. Por favor, intente descargarlo nuevamente.",
    "fileIntegrityCheckError": "Error en la verificación de integridad del archivo",
    "fileIntegrityCheckErrorDescription": "No se pudo verificar la integridad del archivo, pero la descarga continuará.",
    "storageUrlFetchFailed": "Inquilino no encontrado o temporalmente no disponible",
    "storageUrlFetchFailedDescription": "Comprueba la dirección e inténtalo de nuevo: <strong>{{tenantAddress}}</strong>.",
    "folderPasswordRequired": "Esta carpeta requiere verificación de contraseña",
    "folderPassword": {
      "passwordRequired": "La contraseña es obligatoria.",
      "tooShort": "La contraseña debe tener al menos 4 caracteres.",
      "ownerOnly": "Solo el propietario de la carpeta puede realizar esta acción.",
      "alreadyExists": "Esta carpeta ya tiene protección por contraseña.",
      "ancestorProtected": "No se puede realizar esta acción porque una carpeta superior está protegida por contraseña.",
      "descendantProtected": "No se puede realizar esta acción porque una subcarpeta está protegida por contraseña.",
      "notSet": "Esta carpeta no tiene configurada la protección por contraseña.",
      "notProtected": "Esta carpeta no está protegida por contraseña.",
      "currentRequired": "La contraseña actual es obligatoria.",
      "expired": "La protección por contraseña de la carpeta ha expirado. Contacte al propietario de la carpeta.",
      "incorrect": "La contraseña actual de la carpeta es incorrecta. Inténtalo de nuevo.",
      "sessionNotFound": "Sesión no encontrada o ya revocada.",
      "sessionForbidden": "No tiene permiso para gestionar esta sesión.",
      "otpNotRequested": "No se ha solicitado el OTP. Solicite un nuevo código."
    },
    "notAFolder": "El elemento seleccionado no es una carpeta",
    "ipRegionBlocked": {
      "message": "Acceso denegado desde tu ubicación.",
      "loginTitle": "Acceso denegado",
      "loginMessage": "Acceso denegado desde tu ubicación.",
      "loginGeneric": "Acceso denegado desde tu ubicación.",
      "fileOperationTitle": "Operación no permitida",
      "fileOperationMessage": "Acceso denegado desde tu ubicación."
    },
    "ipRegionAdminLockout": {
      "title": "No se puede activar la restricción de IP de administración",
      "message": "Tu dirección IP actual debe estar incluida en las direcciones IP de administración permitidas, de lo contrario perderías el acceso a la configuración de administración."
    },
    "dateMustBeFuture": "La fecha debe ser en el futuro",
    "externalSharingNotAllowed": "Los siguientes destinatarios no están autorizados para recibir el uso compartido externo: {{recipients}}",
    "sharingNotAllowedMandatoryTag": "Los archivos adjuntos deben tener una etiqueta de clasificación antes del envío",
    "fileSharingDenied": "No se permite compartir archivos en esta operación.",
    "cannotAccessFiles": "No tienes acceso a uno o más archivos solicitados.",
    "partialSharingDenied": "Algunos archivos no se pueden compartir con los destinatarios seleccionados.",
    "partialSharingDeniedDisabledRecipients": "Algunos usuarios o grupos seleccionados ya tienen una compartición para estos archivos, pero está deshabilitada. Puedes volver a habilitarla con el botón {{shareAgainLabel}} junto a cada destinatario.",
    "passKeyDataRequired": "Faltan datos de passkey o no son válidos. Inténtalo de nuevo.",
    "passKeyForbidden": "No tienes permiso para realizar esta acción.",
    "passKeyLimitReached": "Has alcanzado el número máximo de passkeys. Elimina una antes de añadir otra.",
    "passKeyLockedOut": "Demasiados intentos fallidos con la passkey. Vuelve a intentarlo más tarde o usa otro método de acceso.",
    "passKeyNotAllowed": "Esta acción con passkey no está permitida.",
    "passKeyNotEnabled": "Las passkeys no están habilitadas para tu cuenta u organización.",
    "passKeyNotFound": "Passkey no encontrada. Puede haberse eliminado o ya no es válida.",
    "passKeySessionExpired": "La sesión de la passkey ha caducado. Vuelve a intentarlo desde el principio.",
    "passKeyVerificationFailed": "Credencial no encontrada o no habilitada para el inicio de sesión sin contraseña.",
    "batchNotFound": "Lote no encontrado o sin acceso.",
    "batchNotCancellable": "Este lote no se puede cancelar (no es de clasificación).",
    "batchAlreadyFinished": "Esta operación ya ha finalizado.",
    "batchRetryNotSupported": "El reintento solo está disponible para lotes de clasificación.",
    "noFileJobsFound": "Ninguno de los archivos seleccionados se puede cancelar o reintentar en su estado actual.",
    "queueUnavailable": "La cola de procesamiento no está disponible temporalmente. Inténtalo más tarde.",
    "ldap": {
      "ACTIVE_DIRECTORY_NOT_AVAILABLE": "La sincronización de Active Directory no está disponible para esta instalación o licencia.",
      "LDAP_NOT_CONFIGURED": "Active Directory aún no está configurado. Abra primero la página de ajustes LDAP.",
      "LDAP_CONFIGURATION_INVALID": "La configuración LDAP no es válida. Corrija los campos marcados y guarde de nuevo.",
      "LDAP_CREDENTIAL_REQUIRED": "Se requiere la contraseña de enlace. Introduzca la contraseña de la cuenta de servicio.",
      "LDAP_UNREACHABLE": "Controlador de dominio inaccesible: compruebe host, puerto y firewall.",
      "LDAP_TLS_FAILED": "Certificado no confiable: cargue la CA interna en los ajustes, o revise el emparejamiento seguridad/puerto.",
      "LDAP_BIND_FAILED": "Cuenta de servicio rechazada: compruebe el DN de enlace y la contraseña.",
      "LDAP_BASE_DN_NOT_FOUND": "El enlace funcionó pero no se encontró el DN base: compruebe el DN base.",
      "LDAP_SEARCH_FAILED": "El directorio rechazó la búsqueda — compruebe los filtros.",
      "LDAP_CREDENTIAL_ENCRYPTION_FAILED": "Error del servidor, contacte con soporte.",
      "rateLimited": "Demasiadas solicitudes, reintente en un minuto."
    },
    "pdfConversionUnsupportedFormat": "Este formato de archivo no es compatible con la conversión a PDF.",
    "pdfConversionFileTooLarge": "Archivo demasiado grande para conversión. Tamaño máximo {{maxSizeMb}} MB.",
    "pdfConversionFailed": "Conversión a PDF fallida. Inténtelo de nuevo.",
    "pdfConversionAntivirusBlocked": "Conversión a PDF bloqueada: el archivo contiene una amenaza.",
    "fileNotFound": "Archivo no encontrado.",
    "outboundEmail": {
      "OUTBOUND_EMAIL_NOT_AVAILABLE": "El dominio de correo personalizado no está disponible para esta cuenta o licencia.",
      "OUTBOUND_EMAIL_CONFIG_INVALID": "La configuración de correo saliente no es válida. Corrige los campos marcados y guarda de nuevo.",
      "OUTBOUND_EMAIL_NOT_CONFIGURED": "Guarda una configuración de dominio antes de verificar.",
      "OUTBOUND_EMAIL_NOT_READY": "El remitente personalizado aún no está listo (desactivado, no verificado o Mailgun no activo).",
      "OUTBOUND_EMAIL_CONCURRENT_CHANGE": "La configuración cambió durante la comprobación. Actualiza el estado e inténtalo de nuevo.",
      "OUTBOUND_EMAIL_DNS_LOOKUP_FAILED": "Comprobación DNS no disponible, inténtalo más tarde.",
      "OUTBOUND_EMAIL_MAILGUN_FAILED": "Falló la petición a Mailgun. La propiedad puede haberse guardado — actualiza el estado.",
      "OUTBOUND_EMAIL_TEST_FAILED": "No se pudo enviar el correo de prueba, inténtalo más tarde.",
      "rateLimited": "Demasiadas solicitudes, inténtalo en breve."
    },
    "DIRECTORY_SYNC_ALREADY_RUNNING": "Ya hay otra sincronización de directorio en curso para esta empresa. Reintente cuando termine."
  },
  "notifications": {
    "genericUpdateSuccess": "{{resource}} actualizado exitosamente.",
    "genericCreateSuccess": "{{resource}} creado exitosamente.",
    "linkCopiedToClipboard": "¡Enlace copiado al portapapeles!",
    "codeCopiedToClipboard": "¡Código copiado al portapapeles!",
    "fileProtectedWithAntiCapture": "Este archivo está protegido con anti-captura. Para ver el contenido del archivo, ingresa este código cuando se solicite en el Visor de Filegrant, ¡y listo!",
    "otpCopiedToClipboard": "¡OTP copiado al portapapeles!",
    "fileProtectedDownloadInProgress": "Descarga en progreso, al final de la descarga ejecuta la aplicación descargada, ingresa lo indicado arriba para ver el archivo.",
    "quickShareSuccess": "Archivos compartidos exitosamente.",
    "fileLocatedInThisLocation": "Este archivo ya está ubicado en esta ubicación.",
    "fileAccessRevoked": "Derechos de acceso revocados exitosamente.",
    "fileAccessUpdated": "Derechos de acceso actualizados exitosamente.",
    "fileVersionRestored": "Versión del archivo restaurada exitosamente.",
    "folderCreated": "Carpeta {{resource}} creada exitosamente.",
    "fileCreated": "Archivo {{resource}} creado exitosamente.",
    "fileRenamed": "Archivo {{resource}} renombrado a {{newName}} exitosamente.",
    "fileDuplicated": "Archivo {{resource}} duplicado exitosamente.",
    "fileDuplicated_other": "Archivos duplicados exitosamente.",
    "fileFavouriteChanged": "Archivo {{resource}} {{isFavourite}} favoritos exitosamente.",
    "fileFavouriteChanged_other": "Archivos {{isFavourite}} favoritos exitosamente.",
    "fileShortcutCreated": "Acceso directo del archivo {{resource}} creado exitosamente.",
    "fileMoved": "Archivo {{resource}} movido exitosamente.",
    "fileMoved_other": "Archivos movidos exitosamente.",
    "emptyTrash": "Papelera vaciada exitosamente.",
    "operationMayTakeTime": "Esta operación puede tomar algún tiempo en completarse.",
    "fileRestored": "Archivo {{resource}} restaurado exitosamente.",
    "fileRestored_other": "Archivos restaurados exitosamente.",
    "fileHidden": "Archivo {{resource}} ocultado exitosamente.",
    "fileHidden_other": "Archivos ocultados exitosamente.",
    "fileUnhidden": "Archivo {{resource}} mostrado exitosamente.",
    "fileUnhidden_other": "Archivos mostrados exitosamente.",
    "filesMarkedAsRead_one": "Marcado como leído.",
    "filesMarkedAsRead_other": "{{count}} archivos marcados como leídos.",
    "filesMarkedAsUnread_one": "Marcado como no leído.",
    "filesMarkedAsUnread_other": "{{count}} archivos marcados como no leídos.",
    "folderLocked": "{{count}} carpeta bloqueada.",
    "folderLocked_other": "{{count}} carpetas bloqueadas.",
    "fileClassifying": "El archivo está siendo clasificado",
    "filesClassifying": "{{count}} archivo está siendo clasificado",
    "filesClassifying_other": "{{count}} archivos están siendo clasificados",
    "filesClassifyingBatch": "{{count}} archivos están siendo clasificados como lote",
    "filesClassifyingBatchWithSkipped": "{{count}} archivos en cola para clasificación. {{skipped}} omitidos.",
    "folderClassifyingBatch": "El contenido de la carpeta está siendo clasificado como lote",
    "foldersClassifyingBatch": "{{count}} carpetas están siendo clasificadas como lote",
    "fileTagsUpdated": "Etiquetas del archivo {{resource}} actualizadas exitosamente.",
    "fileDeleted": "Archivo {{resource}} eliminado exitosamente.",
    "fileDeleted_other": "Archivos eliminados exitosamente.",
    "checkingFilesExistsCounter": "Verificando archivos: {{done}} / {{total}}",
    "checkingFoldersExistsCounter": "Verificando carpetas: {{done}} / {{total}}",
    "checkingFilesInFolderCounter": "{{folder}} · Verificando archivos: {{done}} / {{total}}",
    "checkingSubfoldersInFolderCounter": "{{folder}} · Verificando subcarpetas: {{done}} / {{total}}",
    "tags": {
      "title": "Archivo Etiquetado",
      "description": "El archivo {{fileId}} ha sido etiquetado",
      "error": "La clasificación por IA falló.",
      "batchSuccessTitle": "Lote de clasificación completado",
      "batchSuccessDescription": "Clasificados {{processed}} de {{total}} archivos.",
      "batchFailedTitle": "Lote de clasificación fallido",
      "batchFailedDescription": "Lote terminado con errores ({{processed}}/{{total}})."
    },
    "summary": {
      "title": "Resumen de Archivo",
      "description": "Resumen generado para el archivo {{fileId}}",
      "ready": "El resumen del archivo está listo.",
      "open": "Abrir resumen"
    },
    "fileUnavailable": "Archivo no disponible",
    "suggestGridMode": {
      "title": "Solo imágenes en esta carpeta",
      "description": "Cambia a la vista de cuadrícula para una mejor vista previa.",
      "action": "Cambiar a cuadrícula"
    },
    "documentClassification": {
      "title": "Documento Clasificado",
      "description": "Clasificación de documento completada para el archivo {{fileId}}"
    },
    "default": {
      "title": "Notificación",
      "description": "Nueva notificación recibida"
    },
    "sharing": {
      "title": "Archivo compartido",
      "sharing_operation_download": "{{actorName}} descargó {{fileName}}",
      "sharing_operation_open": "{{actorName}} abrió {{fileName}}",
      "sharing_operation_edit": "{{actorName}} editó {{fileName}}",
      "sharing_operation_delete": "{{actorName}} eliminó {{fileName}}",
      "sharing_operation_rename": "{{actorName}} renombró {{fileName}}",
      "sharing_operation_add": "{{actorName}} añadió {{fileName}}",
      "sharing_operation_move": "{{actorName}} movió {{fileName}}",
      "sharing_operation_copy": "{{actorName}} copió {{fileName}}",
      "sharing_operation_unknown": "{{actorName}} realizó una operación en {{fileName}}"
    },
    "folderPasswordSet": "Protección por contraseña habilitada",
    "folderPasswordUpdated": "Protección por contraseña actualizada",
    "folderPasswordRemoved": "Protección por contraseña eliminada",
    "unlockingFolder": "Desbloqueando carpeta…",
    "folderUnlocked": "Carpeta desbloqueada correctamente",
    "pdfConversionStarted": "Conversión de {{resource}} a PDF iniciada.",
    "pdfConversionSuccess": "Conversión a PDF completada correctamente.",
    "pdfConversionFailed": "Conversión a PDF fallida.",
    "pdfConversionStillRunning": "La conversión a PDF sigue en curso. Se le notificará cuando finalice."
  },
  "files": {
    "downloadPreparation": "Preparando descarga",
    "downloadReady": "Descarga lista",
    "compressionOfFilesInProgress": "Compresión de archivos en progreso",
    "compressionCompleted": "Compresión completada",
    "compressionFailed": "Compresión fallida"
  },
  "fileAccessNotification": {
    "enableActivityNotifications": "Activar notificaciones de actividad",
    "includeSubfolders": "Incluir subcarpetas",
    "notifyOwner": "Notificar propietario",
    "notifyRecipients": "Notificar a los destinatarios",
    "whoCanTrigger": "¿Quién puede activar las notificaciones?",
    "trigger": {
      "ownerOnly": "Solo el propietario",
      "anyone": "Cualquiera"
    },
    "operation": {
      "download": "Descarga",
      "open": "Apertura",
      "edit": "Edición",
      "delete": "Eliminación",
      "rename": "Renombrar",
      "add": "Añadir",
      "move": "Mover",
      "copy": "Copiar"
    },
    "configureNotifications": "Configurar notificaciones",
    "customizeFor": "Personalizar para",
    "discardChangesTitle": "¿Descartar cambios?",
    "discardChangesDescription": "Hay cambios sin guardar. ¿Descartarlos y cerrar?",
    "discardConfirm": "Descartar",
    "notificationsDisabled": "Notificaciones desactivadas",
    "notificationsEnabled": "Notificaciones activadas",
    "modalTitle": "Notificaciones de actividad"
  },
  "modal": {
    "saveTagsConfirm": {
      "title": "¿Guardar los cambios de etiquetas?",
      "description": "Tienes cambios de etiquetas sin guardar. ¿Guardar antes de cerrar?"
    },
    "userGroupSelectorForm": {
      "title": "Gestionar Equipo de Revisión",
      "description": "Selecciona usuarios y grupos para el equipo de revisión",
      "currentMembers": "Miembros Actuales",
      "unsavedReviewTeam": "Equipo de Revisión no Guardado"
    },
    "tagUserGroupMultiSelectForm": {
      "title": "Gestionar Usuarios y Grupos",
      "description": "Selecciona usuarios y grupos que pueden acceder a esta etiqueta",
      "usersAndGroups": "Usuarios y grupos",
      "unsavedUsersAndGroups": "Usuarios y Grupos no Guardados"
    },
    "changeUserRole": {
      "title": "Cambiar rol de usuario",
      "description": "¿Estás seguro de que quieres cambiar el rol de {{name}} de {{initialRole}} a {{newRole}}?"
    },
    "deleteUsersForm": {
      "title": "Eliminar usuario",
      "title_other": "Eliminar usuarios",
      "roleAdminOrContributor": "El usuario que estás a punto de eliminar es un Colaborador o Administrador y puede haber subido archivos al sistema. Eliminar este usuario también eliminará todos sus archivos subidos y cualquier compartición asociada, y ya no podrá acceder a la plataforma. ¿Estás seguro de que quieres proceder? <i>(Escribe \"{{keyword}}\" para confirmar.)</i>",
      "roleReader": "El usuario que estás a punto de eliminar es un Lector y puede tener archivos que fueron compartidos con él por otros usuarios. Eliminar este usuario le impedirá acceder al sistema y a cualquier archivo que fue compartido con él. ¿Estás seguro de que quieres proceder? <i>(Escribe \"{{keyword}}\" para confirmar.)</i>",
      "roleExternal": "El usuario que estás a punto de eliminar también está referenciado por otros usuarios en la plataforma, que han compartido archivos o carpetas directamente con él. Eliminar este usuario revocará su acceso a cualquier contenido compartido, y otros usuarios que compartieron con él ya no verán este usuario en sus propias listas de usuarios. ¿Estás seguro de que quieres proceder? <i>(Escribe \"{{keyword}}\" para confirmar.)</i>",
      "multiple": "Estás a punto de eliminar múltiples usuarios. Algunos de estos usuarios pueden haber subido archivos al sistema. Eliminarlos removerá todos sus archivos subidos y cualquier compartición asociada, y ya no podrán acceder a la plataforma. ¿Estás seguro de que quieres proceder? <i>(Escribe \"{{keyword}}\" para confirmar.)</i>",
      "transferDestinationLabel": "Transferir archivos personales a otro usuario (opcional)",
      "transferDestinationPlaceholder": "Buscar un usuario…",
      "transferOptionalHint": "Si eliges un destinatario, los archivos personales de las cuentas que vas a eliminar se transferirán allí antes de borrarlas. Déjalo vacío para eliminar los archivos según la política descrita arriba.",
      "userReferencedInSettings": {
        "title": "No se puede eliminar el usuario",
        "title_other": "No se pueden eliminar los usuarios",
        "description": "El usuario seleccionado no se puede eliminar. Está referenciado en los siguientes ajustes: <settingsList/>. Elimínalo de estos ajustes antes de intentar de nuevo.",
        "description_other": "Los usuarios seleccionados no se pueden eliminar. Están referenciados en los siguientes ajustes: <settingsList/>. Elimínalos de estos ajustes antes de intentar de nuevo.",
        "unknownSettings": "Uno o más ajustes"
      }
    },
    "changeUsersStatus": {
      "title": "Cambiar estado del usuario",
      "description": "¿Estás seguro de que quieres {{status}} <strong>{{resource}}</strong>?",
      "description_other": "¿Estás seguro de que quieres {{status}} <strong>estos usuarios</strong>?"
    },
    "excludeFromSso": {
      "titleExclude": "Excluir al usuario del SSO",
      "titleInclude": "Reactivar SSO para el usuario",
      "descriptionExclude": "¿Estás seguro de que quieres excluir a <strong>{{resource}}</strong> del SSO? No podrá iniciar sesión a través del proveedor de identidad configurado y deberá autenticarse mediante OTP.",
      "descriptionInclude": "¿Estás seguro de que quieres reactivar el SSO para <strong>{{resource}}</strong>? Podrá volver a iniciar sesión a través del proveedor de identidad configurado."
    },
    "enterOnBehalfOf": {
      "title": "Entrar al modo En Nombre De",
      "description": "Estás iniciando una sesión donde verás datos y realizarás operaciones en nombre de <strong>{{resource}}</strong>.<br /><br />¿Confirmas?"
    },
    "impersonateUser": {
      "title": "Suplantar usuario",
      "description": "¿Estás seguro de que quieres iniciar sesión como {{userName}}? Podrás ver y realizar operaciones como este usuario.",
      "emailNotice": "El usuario recibirá un correo notificándole de esta suplantación, con tu nombre, la fecha y hora, y el motivo que indiques a continuación.",
      "reasonLabel": "Motivo — visible para el usuario en el correo de notificación",
      "reasonTruncateHint": "Los motivos de más de 500 caracteres se truncan con \"…\" en el correo (el texto completo se sigue guardando).",
      "reasonEmptyHint": "Si se deja vacío, el correo muestra \"Not specified\"."
    },
    "userForm": {
      "editTitle": "Editar usuario",
      "newTitle": "Nuevo usuario",
      "editDescription": "Editar detalles del usuario",
      "newDescription": "Añadir un nuevo usuario"
    },
    "userGroups": {
      "title": "Membresía de grupo",
      "description": "Lista de grupos de los cuales <strong>{{resource}}</strong> es miembro"
    },
    "userFiles": {
      "title": "Elementos Compartidos",
      "description": "Elementos compartidos con <strong>{{resource}}</strong>"
    },
    "groupFiles": {
      "title": "Elementos Compartidos",
      "description": "Elementos compartidos con <strong>{{resource}}</strong>"
    },
    "fileSizeTooBigForOpen": {
      "title": "Tamaño de archivo demasiado grande",
      "description": "El tamaño del archivo excede el límite de {{value}}. Si quieres abrir el archivo, puedes descargarlo y abrirlo localmente."
    },
    "deleteGroups": {
      "title": "Eliminar grupo",
      "title_other": "Eliminar grupos",
      "description": "¿Estás seguro de que quieres eliminar <strong>{{resource}}</strong>? ¿Estás seguro de que quieres proceder? <i>(Escribe \"{{keyword}}\" para confirmar.)</i>",
      "description_other": "¿Estás seguro de que quieres eliminar <strong>estos grupos</strong>? ¿Estás seguro de que quieres proceder? <i>(Escribe \"{{keyword}}\" para confirmar.)</i>"
    },
    "groupForm": {
      "editTitle": "Editar grupo",
      "newTitle": "Nuevo grupo",
      "viewTitle": "Ver grupo",
      "editDescription": "Editar detalles del grupo",
      "viewDescription": "Ver detalles del grupo",
      "newDescription": "Añadir un nuevo grupo",
      "allUsers": "Todos los usuarios",
      "selectedUsersOrGroups": "Usuarios o grupos seleccionados"
    },
    "entraIdGroupsImportForm": {
      "importFromEntraId": "Importar desde Entra ID",
      "title": "Importar Grupos desde Microsoft Entra ID",
      "searchGroups": "Buscar grupos...",
      "selectNew": "Seleccionar solo nuevos",
      "existing": "Existente",
      "new": "Nuevo",
      "importMembers": "También importar miembros del grupo",
      "importSelected": "Importar ({{count}})",
      "importSuccess": "Importación completada: {{created}} creados, {{updated}} actualizados",
      "importError": "Error durante la importación",
      "errorLoadingGroups": "Error al cargar grupos desde Entra ID",
      "noGroupsFound": "No se encontraron grupos",
      "resultSummary": "Creados: {{created}}, Actualizados: {{updated}}, Omitidos: {{skipped}}, Fallidos: {{failed}}",
      "usersImported": "{{count}} miembro(s) también importados",
      "permissionDeniedFallback": "Permiso denegado",
      "permissionErrorTitle": "Permisos de Azure AD Insuficientes",
      "permissionErrorDescription": "La aplicación de Azure AD no tiene permisos suficientes para acceder a Microsoft Graph API.",
      "permissionErrorSteps": "Para resolver este problema:",
      "permissionErrorStep1": "Ir a Azure Portal > Registros de aplicaciones > Tu aplicación",
      "permissionErrorStep2": "Navegar a Permisos de API",
      "permissionErrorStep3": "Agregar los permisos de Aplicación requeridos (no Delegados)",
      "permissionErrorStep4": "Hacer clic en \"Conceder consentimiento de administrador\" para autorizar los permisos",
      "requiredPermissions": "Permisos requeridos",
      "defaultRole": "Rol por defecto",
      "linked": "Vinculado"
    },
    "csvUsersImportForm": {
      "importFromCsv": "Import from CSV",
      "title": "Import users from CSV",
      "description": "Create new users only. Rows whose email already exists are skipped (not treated as failures). Roles: SuperAdmin, Admin, Contributor, Reader (or numeric codes).",
      "browserStayOpenWarning": "Do not close or refresh this browser tab until the import finishes. Progress exists only in this session.",
      "confirmSkipErrors": "Hay {{count}} elementos con errores y no se importarán.",
      "downloadTemplate": "Download CSV template",
      "sendInvites": "Send invitation emails to newly created users",
      "dropzone": "Drop a CSV file here or click to browse",
      "fileSelected": "Selected: {{name}}",
      "invalidFileType": "Please select a .csv file",
      "readError": "Could not read the CSV file",
      "noValidRows": "No valid rows found in this file",
      "colLine": "Line",
      "confirmImport": "Import {{count}} users",
      "emptyFile": "The CSV file is empty",
      "invalidHeader": "Invalid header. Expected: {{expected}}",
      "tooManyColumns": "Too many columns on this row",
      "missingFirstName": "First name is required",
      "missingLastName": "Last name is required",
      "missingEmail": "Email is required",
      "invalidEmail": "Invalid email address",
      "missingRole": "Role is required",
      "invalidRole": "Invalid role: {{value}}",
      "superAdminRoleNotAllowed": "Only a SuperAdmin can assign the SuperAdmin role",
      "invalidExpirationDate": "Invalid expiration date: {{value}}",
      "invalidBoolean": "Invalid boolean for {{field}}: {{value}}",
      "duplicateInFile": "Duplicate email in file (first seen on line {{firstLine}})",
      "genericCreateError": "Could not create user",
      "drawerAria": "User import progress",
      "drawerRunning": "Importing users…",
      "drawerCompleted": "User import complete",
      "drawerCancelled": "User import cancelled",
      "importingUsersCounter": "Importing users {{amount}} of {{total}}",
      "importedUsersCounter": "Imported {{amount}} of {{total}}",
      "waitingForImport": "Waiting",
      "importingRow": "Importing…",
      "alreadyExists": "Already exist",
      "summary": "Created: {{created}} · Already exist: {{skipped}} · Failed: {{failed}}",
      "progressCount": "{{done}} / {{total}}",
      "failedList": "Failed",
      "alreadyExistList": "Already exist ({{count}})",
      "cancelImport": "Cancel import",
      "cancelConfirmTitle": "Cancel import?",
      "cancelConfirmContent": "In-flight creates will finish; remaining rows will not start.",
      "continueImport": "Keep importing",
      "minimizeDrawer": "Minimize",
      "expandDrawer": "Expand",
      "previewHeading": "{{total}} usuarios · {{errors}} errores",
      "searchPlaceholder": "Buscar usuarios…",
      "colStatus": "Estado",
      "filterWithErrors": "Con errores",
      "filterValid": "Válidos",
      "statusError": "Error",
      "statusOk": "OK"
    },
    "entraIdUsersImportForm": {
      "importFromEntraId": "Importar desde Entra ID",
      "title": "Importar Usuarios desde Microsoft Entra ID",
      "searchUsers": "Buscar usuarios...",
      "selectNew": "Seleccionar solo nuevos",
      "existing": "Existente",
      "new": "Nuevo",
      "importSelected": "Importar ({{count}})",
      "importSuccess": "Importación completada: {{created}} creados, {{updated}} actualizados",
      "importError": "Error durante la importación",
      "errorLoadingUsers": "Error al cargar usuarios desde Entra ID",
      "noUsersFound": "No se encontraron usuarios",
      "resultSummary": "Creados: {{created}}, Actualizados: {{updated}}, Omitidos: {{skipped}}, Fallidos: {{failed}}",
      "permissionDeniedFallback": "Permiso denegado",
      "permissionErrorTitle": "Permisos de Azure AD Insuficientes",
      "permissionErrorDescription": "La aplicación de Azure AD no tiene permisos suficientes para acceder a Microsoft Graph API.",
      "permissionErrorSteps": "Para resolver este problema:",
      "permissionErrorStep1": "Ir a Azure Portal > Registros de aplicaciones > Tu aplicación",
      "permissionErrorStep2": "Navegar a Permisos de API",
      "permissionErrorStep3": "Agregar los permisos de Aplicación requeridos (no Delegados)",
      "permissionErrorStep4": "Hacer clic en \"Conceder consentimiento de administrador\" para autorizar los permisos",
      "requiredPermissions": "Permisos requeridos",
      "defaultRole": "Rol por defecto"
    },
    "batchDetailForm": {
      "title": "Detalle del lote",
      "noFailedFiles": "No hay archivos fallidos",
      "noFiles": "No hay archivos en este estado",
      "fileCancelled": "Cancelación solicitada para este archivo.",
      "fileCancelError": "Error al solicitar la cancelación del archivo.",
      "fileRetried": "Archivo puesto en cola para reintento",
      "fileRetryError": "Error al reintentar el archivo",
      "truncatedHint": "La vista previa de archivos fallidos se truncó. Usa la pestaña Fallidos para la lista completa.",
      "attempt": "Intento {{count}}",
      "tabs": {
        "pending": "En cola",
        "processing": "En proceso",
        "success": "Completados",
        "failed": "Fallidos",
        "canceled": "Cancelados"
      },
      "status": {
        "pending": "En cola",
        "processing": "En proceso",
        "success": "Completado",
        "failed": "Fallido",
        "canceled": "Cancelado"
      }
    },
    "batchesList": {
      "panelTitle": "Lotes",
      "noActiveBatches": "No hay lotes activos",
      "cancelAllFailed": "Cancelar todos los lotes fallidos (no en proceso)",
      "cancelAllFailedConfirmTitle": "¿Cancelar todos los lotes fallidos?",
      "cancelAllFailedConfirmContent": "Se borrarán solo los lotes con estado Fallido. Los lotes en proceso o en cola siguen ejecutándose y no se ven afectados. Esta operación no se puede deshacer.",
      "cancelBatch": "Cancelar lote",
      "cancelBatchConfirmTitle": "¿Cancelar este lote?",
      "cancelBatchConfirmContent": "Esto cancelará la solicitud. El procesamiento puede detenerse en el siguiente punto de control. Esta operación no se puede deshacer.",
      "failedFiles": "{{count}} archivo fallido",
      "failedFiles_other": "{{count}} archivos fallidos",
      "progress": "{{processed}} / {{total}}",
      "status": {
        "all": "Todos",
        "queued": "En cola",
        "processing": "Procesando",
        "completed": "Completado",
        "failed": "Fallido",
        "partiallycompleted": "Parcialmente completado",
        "cancelled": "Cancelado"
      },
      "operation": {
        "all": "Todas las operaciones",
        "classification": "Clasificación IA",
        "folderexpansion": "Expansión de carpeta",
        "delete": "Eliminación",
        "zip": "Error al crear el archivo ZIP"
      },
      "pendingFiles": "{{count}} en cola",
      "pendingFiles_other": "{{count}} en cola",
      "processingFiles": "{{count}} en proceso",
      "processingFiles_other": "{{count}} en proceso",
      "processedFiles": "{{count}} completado",
      "processedFiles_other": "{{count}} completados",
      "canceledFiles": "{{count}} cancelado",
      "canceledFiles_other": "{{count}} cancelados",
      "viewDetail": "Ver detalles"
    },
    "tagForm": {
      "editTitle": "Editar etiqueta",
      "newTitle": "Nueva etiqueta",
      "editDescription": "Editar detalles de la etiqueta",
      "newDescription": "Añadir una nueva etiqueta",
      "visibility": "Visibilidad",
      "visibilityDescription": "Haz visible esta etiqueta a los siguientes roles y especifica si la etiqueta será visible para todos o solo para grupos o usuarios específicos.",
      "usedInSettings": "Utilizado en:",
      "usedInSettingsNone": "Esta etiqueta no se utiliza en ninguna configuración.",
      "selectUserRoles": "Seleccionar roles de usuario"
    },
    "deleteTag": {
      "title": "Eliminar etiqueta",
      "description": "¿Estás seguro de que quieres eliminar <strong>{{resource}}</strong>? ¿Estás seguro de que quieres proceder?",
      "descriptionWithPublicTag": "¿Estás seguro de que quieres eliminar <strong>{{resource}}</strong>? Eliminar esta etiqueta eliminará todas las comparticiones asociadas a ella en la configuración de visibilidad de archivos etiquetados.",
      "errorInUse": "No se puede eliminar la etiqueta",
      "errorInUseDescription": "Esta etiqueta está actualmente en uso en las siguientes áreas:",
      "errorInUseAction": "Elimina la etiqueta de estas secciones antes de proceder con la eliminación.",
      "usedInSettings": "Configuración",
      "usedInClassificationAgent": "Classification Agent"
    },
    "fileTitleForm": {
      "newFolderTitle": "Nueva carpeta",
      "editFolderTitle": "Renombrar carpeta",
      "editFileTitle": "Renombrar archivo"
    },
    "fileFromTemplateForm": {
      "newWordDocumentTitle": "Nuevo Documento de Word",
      "newExcelDocumentTitle": "Nuevo Documento de Excel",
      "newPowerpointDocumentTitle": "Nuevo Documento de PowerPoint",
      "newGenericDocumentTitle": "Nuevo Documento"
    },
    "enterFolderPasswordForm": {
      "passwordPlaceholder": "Contraseña",
      "required": "La contraseña es obligatoria",
      "cancel": "Cancelar",
      "confirm": "Desbloquear",
      "error": "Contraseña incorrecta",
      "lockout": "Demasiados intentos fallidos. Vuelve a intentarlo en {{minutes}} minutos.",
      "genericError": "Se ha producido un error",
      "resetPassword": "Restablecer contraseña",
      "forgotPassword": "¿Contraseña olvidada?",
      "title": "Carpeta Protegida",
      "description": "La carpeta \"{{folderName}}\" requiere una contraseña."
    },
    "filePasswordForm": {
      "title": "Protección por Contraseña de Carpeta",
      "createTitle": "Establecer Protección por Contraseña",
      "editTitle": "Editar Protección por Contraseña",
      "password": "Contraseña",
      "currentPassword": "Contraseña actual",
      "newPassword": "Nueva Contraseña",
      "newPasswordHelp": "Deja vacío para mantener la contraseña actual",
      "ownerBypass": "Bypass del Propietario",
      "ownerBypassDescription": "El propietario puede acceder a la carpeta sin contraseña",
      "adminBypass": "Bypass del Admin",
      "adminBypassDescription": "El admin puede acceder a la carpeta sin contraseña",
      "maxFailedAttempts": "Intentos Fallidos Máximos",
      "lockoutDuration": "Duración del Bloqueo (minutos)",
      "sessionDuration": "Duración de la Sesión (minutos)",
      "expirationDate": "Fecha de Expiración",
      "expirationDatePlaceholder": "Selecciona fecha (opcional)",
      "remove": "Eliminar Contraseña",
      "removeConfirm": "¿Estás seguro de que quieres eliminar la contraseña?",
      "validation": {
        "required": "Este campo es obligatorio",
        "minLength": "Debe tener al menos {{min}} caracteres",
        "expirationDateExpired": "La fecha de expiración no puede estar en el pasado"
      }
    },
    "fileSessionsForm": {
      "title": "Sesiones de carpetas",
      "revokeAllSessionsDescription": "Todas las sesiones de desbloqueo de \"{{fileName}}\" serán revocadas. Los usuarios tendrán que introducir la contraseña de nuevo para acceder a esta carpeta.",
      "revokeAllFolderSessionsDescription": "Todas las sesiones de desbloqueo de carpetas serán revocadas. Los usuarios tendrán que introducir la contraseña de nuevo para acceder a cualquier carpeta protegida.",
      "noSessions": "No hay sesiones activas",
      "unknownDevice": "Dispositivo desconocido",
      "createdAt": "Creada el",
      "expiresAt": "Caduca el",
      "revokeSession": "Revocar",
      "sessionRevoked": "Sesión revocada con éxito",
      "sessionRevoked_other": "{{count}} sesiones revocadas con éxito",
      "allSessionsRevoked": "Todas las sesiones han sido revocadas",
      "fetchError": "Error al obtener las sesiones",
      "revokeError": "Error al revocar la sesión",
      "revokeAllError": "Error al revocar todas las sesiones",
      "revokeSessionConfirmTitle": "¿Revocar esta sesión?",
      "revokeSessionConfirmDescription": "La sesión de desbloqueo de esta carpeta se revocará inmediatamente. El usuario tendrá que introducir la contraseña de nuevo para acceder a esta carpeta.",
      "revokeAllConfirmTitle": "¿Revocar todas las sesiones de carpetas?",
      "revokeAllConfirmDescription": "Todas las sesiones de desbloqueo de carpetas serán revocadas. Los usuarios tendrán que introducir la contraseña de nuevo para acceder a las carpetas protegidas.",
      "logoutAll": "Revocar todas"
    },
    "userSessionsForm": {
      "activeSessions": "Sesiones activas",
      "manageSessions": "Gestionar sesiones",
      "manageUserSessions": "Sesiones de {{userName}}",
      "noSessions": "No hay sesiones activas",
      "unknownBrowser": "Navegador desconocido",
      "unknownDevice": "Dispositivo desconocido",
      "lastActivity": "Última actividad",
      "expiresAt": "Caduca el",
      "currentSession": "Sesión actual",
      "revokeSession": "Revocar",
      "sessionRevoked": "Sesión revocada con éxito",
      "sessionRevoked_other": "{{count}} sesiones revocadas con éxito",
      "otherSessionsRevoked": "{{count}} sesión revocada con éxito",
      "otherSessionsRevoked_other": "{{count}} sesiones revocadas con éxito",
      "allSessionsRevoked": "Todas las sesiones han sido revocadas",
      "revokeSessionConfirmTitle": "¿Revocar esta sesión?",
      "revokeSessionConfirmDescription": "El dispositivo será desconectado inmediatamente.",
      "revokeGroupedSessionConfirmDescription": "Se revocarán {{count}} sesiones de este dispositivo.",
      "revokeOthersConfirmTitle": "¿Cerrar sesión en todos los demás dispositivos?",
      "revokeOthersConfirmDescription": "Todos los dispositivos excepto el actual serán desconectados.",
      "revokeAllConfirmTitle": "¿Cerrar sesión en todos los dispositivos?",
      "revokeAllConfirmDescription": "Todos los dispositivos serán desconectados, incluido el actual. Deberás iniciar sesión de nuevo.",
      "adminRevokeAllConfirmTitle": "¿Cerrar todas las sesiones del usuario?",
      "adminRevokeAllConfirmDescription": "Todas las sesiones de {{userName}} serán revocadas. El usuario deberá iniciar sesión de nuevo.",
      "logoutOthers": "Cerrar sesión en otros dispositivos",
      "logoutAll": "Cerrar todas las sesiones",
      "revokeAllUserSessions": "Revocar todas"
    },
    "resetFilePasswordForm": {
      "forgotPassword": "¿Contraseña olvidada?",
      "otpSentToEmail": "OTP enviado a tu dirección de correo.",
      "resetPassword": "Restablecer contraseña",
      "otpCodeLabel": "Código OTP",
      "newPasswordLabel": "Nueva contraseña",
      "wrongOtpCode": "Código OTP incorrecto.",
      "tooManyAttemptsRequestNewOtp": "Demasiados intentos. Solicita un nuevo OTP.",
      "codeExpiredRequestNewOtp": "Código caducado. Solicita un nuevo OTP.",
      "otpRequired": "El código OTP es obligatorio",
      "otpMustBe6": "El código OTP debe tener 6 dígitos",
      "newPasswordRequired": "La nueva contraseña es obligatoria",
      "newPasswordMin": "La contraseña debe tener al menos 4 caracteres",
      "passwordResetSuccess": "Contraseña restablecida correctamente.",
      "tooManyOtpRequests": "Demasiadas solicitudes de OTP. Inténtalo más tarde."
    },
    "fileMoveForm": {
      "title": "Mover {{resource}}",
      "title_other": "Mover {{count}} archivos",
      "currentPosition": "Posición actual",
      "folderIsEmpty": "La carpeta está vacía",
      "selectFolderToMoveInto": "Selecciona una posición para mostrar la ruta de la carpeta donde quieres mover el archivo"
    },
    "fileShortcutForm": {
      "title": "Crear un acceso directo para {{resource}}",
      "currentPosition": "Posición actual",
      "folderIsEmpty": "La carpeta está vacía",
      "selectFolderToCreateShortcutInto": "Selecciona una posición para mostrar la ruta de la carpeta donde quieres crear el acceso directo",
      "goBack": "Volver"
    },
    "fileChooseDestinationForm": {
      "currentPosition": "Posición actual",
      "folderIsEmpty": "La carpeta está vacía",
      "selectFolderHint": "Selecciona la carpeta donde quieres guardar el archivo",
      "goBack": "Volver"
    },
    "fileShareForm": {
      "title": "Compartir {{resource}}",
      "title_other": "Compartir {{count}} archivos",
      "message": "Compartir este archivo con uno o más usuarios o grupos.",
      "message_other": "Compartir {{count}} archivos con uno o más usuarios o grupos.",
      "currentPosition": "Posición actual",
      "folderIsEmpty": "La carpeta está vacía",
      "selectFolderToShareInto": "Selecciona una posición para mostrar la ruta de la carpeta donde quieres compartir el archivo",
      "peopleWithAccess": "Personas con acceso",
      "sendMessage": "Notificar a los destinatarios por correo electrónico",
      "sendMessagePlaceholder": "Añadir un mensaje personalizado (opcional)",
      "existingAccessesChanged": "Los accesos existentes han cambiado",
      "existingAccessesChangedDescription": "Guardar aplica tus cambios a los accesos existentes y luego añade los nuevos usuarios o grupos. Cancelar deja el formulario como está y no los añade.",
      "existingAccessesExpirationRequired": "Para actualizar estos accesos existentes debe establecer una fecha de caducidad permitida por las políticas de la empresa.",
      "applyAllExpirationDates": "Aplicar a todos",
      "ariaLabel": "Formulario de compartir archivo",
      "selectUsersOrGroups": "Seleccionar usuarios o grupos",
      "userMultiSelectAria": "Selección de usuarios y grupos",
      "actions": "Acciones"
    },
    "filePublicLinkForm": {
      "title": "Enlace público",
      "createTitle": "Crear enlace público",
      "expirationLabel": "Caducidad (opcional)",
      "expirationLabelRequired": "Caducidad",
      "expirationPlaceholder": "Nunca",
      "maxAccessCountLabel": "Número máximo de accesos (opcional)",
      "maxAccessCountLabelRequired": "Número máximo de accesos",
      "maxAccessCountPlaceholder": "Ilimitado",
      "allowDownload": "Permitir descarga",
      "protectWithPassword": "Proteger con contraseña",
      "passwordLabel": "Contraseña",
      "passwordPlaceholder": "Introduce la contraseña",
      "passwordRequired": "La contraseña es obligatoria cuando la protección está activada.",
      "createLink": "Crear enlace",
      "linkCreatedTitle": "¡Enlace creado!",
      "linkCreatedMessage": "El enlace público ha sido creado.",
      "copyLink": "Copiar enlace",
      "warning": "Crear un enlace público omite las protecciones estándar del archivo. Cualquiera con el enlace puede acceder al contenido del documento; usar con precaución.",
      "expiresAt": "Caduca",
      "remainingAccesses": "Accesos restantes",
      "password": "Contraseña",
      "revoke": "Revocar enlace",
      "revoked": "Enlace público revocado correctamente.",
      "publicUrl": "URL público",
      "status": "Estado",
      "statusActive": "Activo",
      "statusExpired": "Caducado",
      "statusExhausted": "Límite alcanzado",
      "accessCount": "Accesos",
      "hasPassword": "Protegido con contraseña",
      "createdAt": "Creado",
      "errors": {
        "linkAlreadyExists": "Ya existe un enlace público para este archivo. Revócalo primero para crear uno nuevo.",
        "linkNotFound": "No se encontró ningún enlace activo para este archivo.",
        "featureDisabled": "Los enlaces públicos están deshabilitados para tu organización.",
        "notOwner": "Debes ser el propietario para crear o revocar enlaces públicos."
      }
    },
    "filePublicLinksForm": {
      "statusExpired": "Caducado",
      "statusExhausted": "Límite alcanzado",
      "statusActive": "Activo",
      "expiresAt": "Caduca",
      "accessCount": "Accesos",
      "hasPassword": "Contraseña",
      "empty": "Aún no hay enlaces públicos."
    },
    "userTransferOwnershipForm": {
      "title": "Transferir propiedad – {{sourceName}}",
      "destinationLabel": "Usuario de destino",
      "destinationPlaceholder": "Busca y selecciona un usuario",
      "destinationRequired": "Selecciona un usuario de destino.",
      "infoMessage": "Los archivos se moverán a una carpeta \"Transferred from {{email}}\" en la raíz del destinatario. Los archivos en venta en el marketplace no se transferirán.",
      "submit": "Transferir propiedad",
      "cancel": "Cancelar",
      "close": "Cerrar",
      "successTitle": "Transferencia completada",
      "resultFilesTransferred": "Archivos transferidos",
      "resultFoldersTransferred": "Carpetas transferidas",
      "resultSharesUpdated": "Recursos compartidos actualizados",
      "resultSelfSharesRemoved": "Recursos propios eliminados",
      "resultTagAssignmentsRemoved": "Asignaciones de etiquetas eliminadas",
      "resultTagAssignmentsTransferred": "Asignaciones de etiquetas transferidas",
      "resultFilesForSaleExcluded": "Archivos en venta excluidos",
      "resultWrapperFolderName": "Nombre de la carpeta contenedora"
    },
    "userTotpForm": {
      "title": "2FA – {{userName}}",
      "statusTitle": "Estado 2FA",
      "totpEnabled": "TOTP activado",
      "enabledAt": "Activado el",
      "backupCodesRemaining": "Códigos de respaldo restantes",
      "requiredByPolicy": "Requerido por política",
      "lockoutStatus": "Estado de bloqueo",
      "failedAttempts": "Intentos fallidos",
      "exemptionTitle": "Exención TOTP",
      "grantExemption": "Conceder exención",
      "revokeExemption": "Revocar exención",
      "revoke": "Revocar",
      "exemptionTypeTemporary": "Temporal",
      "exemptionTypePermanent": "Permanente",
      "exemptionTypeLabel": "Tipo",
      "exemptionExpires": "Caduca el",
      "exemptionReason": "Motivo",
      "grantedBy": "Concedido por",
      "grantedAt": "Fecha de concesión",
      "grantDialogTitle": "Conceder exención",
      "grantDialogTemporary": "Temporal",
      "grantDialogPermanent": "Permanente",
      "grantDialogDays": "Días",
      "grantDialogReason": "Motivo (mín. 5 caracteres)",
      "grantSubmit": "Conceder",
      "revokeConfirmTitle": "Revocar exención",
      "revokeConfirmDescription": "El usuario deberá volver a cumplir la política 2FA.",
      "disableConfirmTitle": "¿Desactivar 2FA para este usuario?",
      "disableConfirmDescription": "Se eliminará la autenticación de dos factores para el usuario. Deberá configurarla de nuevo si la política lo requiere.",
      "statusLoading": "Cargando…",
      "statusError": "Error al cargar el estado 2FA.",
      "grantSuccess": "Exención concedida.",
      "revokeSuccess": "Exención revocada.",
      "disableSuccess": "2FA desactivada.",
      "cancel": "Cancelar",
      "disableTotp": "Desactivar 2FA",
      "retry": "Reintentar",
      "errorGeneric": "Algo ha ido mal. Inténtalo de nuevo."
    },
    "userPasskeyForm": {
      "cancel": "Cancelar",
      "retry": "Reintentar",
      "errorGeneric": "Algo ha ido mal. Inténtalo de nuevo.",
      "passkeyRemove": "Eliminar",
      "passkeyRemoveAll": "Eliminar todos los passkeys",
      "passkeyRemoveAllConfirm": "Se eliminarán los {{count}} passkeys de este usuario. Deberá registrar otros nuevos.",
      "passkeyRemoveAllSuccess": "Se eliminaron todos los passkeys.",
      "passkeyRemoveAllTitle": "¿Eliminar todos los passkeys?",
      "passkeyRemoveConfirm": "¿Eliminar el passkey \"{{name}}\"? El usuario ya no podrá usarlo para iniciar sesión.",
      "passkeyRemoveSuccess": "Passkey eliminado.",
      "passkeyRemoveTitle": "¿Eliminar passkey?",
      "passkeysBlocked": "Bloqueo por passkey",
      "passkeysCount": "Passkeys registrados",
      "passkeysEnabled": "Passkeys activados",
      "passkeysFailedAttempts": "Intentos fallidos (passkey)",
      "passkeysLoadError": "No se pudo cargar el estado de administración de passkeys.",
      "passkeysTitle": "Passkeys"
    },
    "loginTokensForm": {
      "title": "Tokens de acceso – {{userName}}",
      "manageTokens": "Gestionar tokens de acceso",
      "noTokens": "No hay tokens de acceso configurados para este usuario.",
      "createToken": "Crear nuevo token",
      "label": "Etiqueta",
      "labelRequired": "La etiqueta es obligatoria",
      "labelPlaceholder": "ej. Integración CRM, Pipeline CI/CD",
      "expirationDays": "Expiración (días)",
      "create": "Crear",
      "cancel": "Cancelar",
      "close": "Cerrar",
      "delete": "Eliminar",
      "retry": "Reintentar",
      "enabled": "Habilitado",
      "disabled": "Deshabilitado",
      "expired": "Expirado",
      "enable": "Habilitar",
      "disable": "Deshabilitar",
      "createdAt": "Creado",
      "expiresAt": "Expira",
      "lastUsed": "Último uso",
      "lastUsedIp": "Última IP",
      "neverUsed": "Nunca utilizado",
      "maxTokensReached": "Número máximo de tokens alcanzado (2). Elimina un token existente para crear uno nuevo.",
      "tokenCreatedTitle": "Token creado con éxito",
      "tokenCreatedWarning": "Copia este token ahora. No se mostrará de nuevo.",
      "copyToken": "Copiar token",
      "copied": "¡Copiado!",
      "deleteConfirmTitle": "¿Eliminar token de acceso?",
      "deleteConfirmDescription": "El token \"{{label}}\" se eliminará permanentemente y ya no podrá utilizarse para la autenticación.",
      "deleteSuccess": "Token eliminado con éxito.",
      "errorCannotCreateTokenForSuperAdmin": "No se pueden crear tokens de acceso para superadministradores.",
      "errorGeneric": "Algo ha ido mal. Inténtalo de nuevo.",
      "errorLoad": "Error al cargar los tokens de acceso.",
      "errorMaxReached": "Este usuario ya tiene el número máximo de tokens.",
      "errorTokenAlreadyUsed": "Este token ya ha sido utilizado y no se puede volver a habilitar."
    },
    "alertDismiss": {
      "title": "Posponer u ocultar aviso",
      "chooseAction": "¿Cómo quieres continuar?",
      "permanent": "No volver a mostrar",
      "snooze": "Recordármelo más tarde",
      "snoozeDuration": "Recordármelo en",
      "confirm": "Aplicar",
      "success": "Preferencia guardada."
    },
    "alertsList": {
      "title": "Todos los avisos activos",
      "dismiss": "Posponer u ocultar"
    },
    "totpForm": {
      "title": "Autenticación de dos factores",
      "statusActive": "Activo",
      "statusInactive": "Inactivo",
      "activatedOn": "Activado el {{date}}",
      "backupCodesRemaining": "{{count}} / {{total}} códigos de respaldo restantes",
      "requiredByPolicy": "Tu organización requiere autenticación de dos factores.",
      "gracePeriodEnds": "Tienes hasta el {{date}} para activarla.",
      "activate": "Activar 2FA",
      "setupTitle": "Configurar autenticación de dos factores",
      "scanQR": "Escanea este código QR con tu app de autenticación (Google Authenticator, Microsoft Authenticator, Authy, etc.).",
      "manualEntry": "¿No puedes escanear? Introducir manualmente",
      "hideManual": "Ocultar entrada manual",
      "enterSecretManually": "Introduce este código manualmente en tu app:",
      "copySecret": "Copiar",
      "copied": "Copiado al portapapeles",
      "verifyCodeLabel": "Introduce el código de 6 dígitos de tu app",
      "verifyAndActivate": "Verificar y activar",
      "backupCodesTitle": "¡Autenticación de dos factores activada!",
      "regenerateSuccess": "Códigos de respaldo regenerados",
      "backupCodesWarning": "Guarda estos códigos de respaldo en un lugar seguro. Pueden usarse para acceder a tu cuenta si pierdes el acceso a tu app de autenticación. Cada código solo puede usarse una vez.",
      "copyAll": "Copiar todos",
      "download": "Descargar",
      "print": "Imprimir",
      "savedConfirm": "He guardado estos códigos en un lugar seguro",
      "continue": "Continuar",
      "regenerateBackupCodes": "Regenerar códigos de respaldo",
      "disableTotp": "Desactivar 2FA",
      "disableConfirm": "¿Desactivar autenticación de dos factores?",
      "disableConfirmDescription": "Quitar la 2FA hará tu cuenta menos segura. Tendrás que reconfigurar tu app de autenticación si quieres volver a activar la 2FA.",
      "enterCodeToConfirm": "Introduce el código TOTP para confirmar",
      "cancel": "Cancelar",
      "disable": "Desactivar",
      "disabledSuccess": "La autenticación de dos factores se ha desactivado.",
      "invalidCode": "Código no válido. Inténtalo de nuevo.",
      "errorGeneric": "Algo ha ido mal. Inténtalo de nuevo.",
      "retry": "Reintentar"
    },
    "passkeyCreateForm": {
      "addDescription": "Al continuar, el navegador te pedirá verificar con Touch ID, Face ID, Windows Hello o tu llave de seguridad.",
      "continueAuthenticator": "Continuar",
      "deviceNameInvalid": "Introduce un nombre de dispositivo entre 1 y 100 caracteres.",
      "deviceNameLabel": "Nombre del dispositivo",
      "deviceNamePlaceholder": "p. ej. MacBook Touch ID",
      "passkeyCancelled": "El inicio de sesión con passkey se canceló.",
      "registerErrorDeviceAlreadyRegistered": "Ya hay una passkey registrada para este dispositivo. Usa otro autenticador o elimina primero la passkey existente.",
      "registerErrorGeneric": "No se pudo completar el registro de la passkey. Inténtalo de nuevo.",
      "registerErrorNotSupported": "Tu navegador o dispositivo no admite este tipo de registro de passkey.",
      "registerSuccess": "Passkey guardado.",
      "title": "Añadir un passkey"
    },
    "passkeyEditForm": {
      "deviceNameInvalid": "Introduce un nombre de dispositivo entre 1 y 100 caracteres.",
      "deviceNameLabel": "Nombre del dispositivo",
      "renameError": "No se pudo renombrar el passkey.",
      "renameSuccess": "Passkey renombrado.",
      "saveLabel": "Guardar",
      "title": "Renombrar passkey"
    },
    "passkeysForm": {
      "addPasskey": "Añadir passkey",
      "browserUnsupported": "Tu navegador no admite passkeys. Usa una versión reciente de Chrome, Safari, Edge o Firefox.",
      "empty": "Aún no hay passkeys. Añade uno para iniciar sesión más rápido y usarlo como segundo factor.",
      "lastUsed": "Último uso",
      "loadError": "No se pudo cargar el estado de passkeys.",
      "maxReached": "Puedes registrar hasta {{max}} passkeys.",
      "never": "Nunca",
      "passwordless": "Sin contraseña",
      "passwordlessDisabled": "Inicio sin contraseña desactivado.",
      "passwordlessEnabled": "Inicio sin contraseña activado.",
      "passwordlessUnavailable": "No disponible en este dispositivo",
      "policyDisabled": "Tu organización ha desactivado los passkeys.",
      "registered": "Registrado",
      "remove": "Eliminar",
      "removeConfirm": "¿Eliminar el passkey \"{{name}}\"? Ya no podrás usarlo para iniciar sesión.",
      "removeError": "No se pudo eliminar el passkey.",
      "removeLastWarning": "Es tu único passkey. Eliminarlo desactivará el inicio con passkey hasta que añadas uno nuevo.",
      "removeSuccess": "Passkey eliminado.",
      "removeTitle": "¿Eliminar passkey?",
      "rename": "Renombrar",
      "title": "Passkeys",
      "toggleError": "No se pudo actualizar el inicio sin contraseña.",
      "transport": "Tipo de dispositivo",
      "transportBle": "Llave de seguridad Bluetooth",
      "transportHybrid": "Teléfono",
      "transportHybridInternal": "Passkey sincronizado (teléfono)",
      "transportInternal": "Este dispositivo (Touch ID, Face ID, Windows Hello)",
      "transportNfc": "Llave de seguridad (NFC)",
      "transportUsb": "Llave de seguridad (USB)",
      "transportUsbNfc": "Llave de seguridad (USB + NFC)",
      "transportUnknown": "No indicado"
    },
    "filesSelectForm": {
      "confirmDeselectParent": "¿Deseleccionar la carpeta padre?",
      "confirmDeselectParentDescription": "Al seleccionar esta carpeta, se deseleccionarán la carpeta padre y todas las carpetas del mismo nivel. ¿Deseas continuar?",
      "ariaLabel": "Formulario de compartir archivos",
      "selectUsersOrGroups": "Seleccionar usuarios o grupos",
      "userMultiSelectAria": "Selección de usuarios y grupos",
      "actions": "Acciones"
    },
    "fileTagsForm": {
      "title": "Editar Etiquetas - {{resource}}",
      "availableTags": "Etiquetas disponibles",
      "assignedTags": "Etiquetas asignadas",
      "searchAvailableTags": "Buscar etiquetas disponibles",
      "searchAssignedTags": "Buscar etiquetas asignadas",
      "noAssignedTags": "Ninguna etiqueta asignada",
      "clickHintAdd": "Haz clic en una etiqueta para añadirla.",
      "clickHintRemove": "Haz clic en una etiqueta para quitarla. Arrastra el icono para reordenar.",
      "clickToAdd": "Añadir etiqueta {{title}}",
      "clickToRemove": "Quitar etiqueta {{title}}",
      "dragToReorder": "Arrastrar para reordenar {{title}}",
      "aiScrapingOnlyPdfOffice": "El scraping AI está activo solo en archivos PDF y Office.",
      "watermarkOnlyPdfOffice": "La protección con marca de agua está activa solo en archivos PDF y Office."
    },
    "openFileFromTrash": {
      "title": "Este archivo está en tu papelera",
      "description": "Para ver <strong>{{resource}}</strong>, necesitas restaurarlo desde la papelera."
    },
    "fileUploadOptionsForm": {
      "title": "Opciones de subida",
      "description": "<strong>{{resource}}</strong> ya existe en esta ubicación. ¿Quieres reemplazar el archivo existente con una nueva versión o mantener ambos archivos? Reemplazar archivos no cambiará las opciones de compartición",
      "description_other": "Uno o más elementos ya existen en esta ubicación. ¿Quieres reemplazar los archivos existentes con una nueva versión o mantener ambos archivos? Reemplazar archivos no cambiará las opciones de compartición",
      "replaceExistingFile": "Reemplazar archivo existente",
      "replaceExistingFile_other": "Reemplazar archivos existentes",
      "keepBothFiles": "Mantener ambos archivos",
      "keepBothFiles_other": "Mantener ambos archivos",
      "newOnly": "Solo nuevos"
    },
    "filePermanentlyDeleteForm": {
      "title": "Eliminar permanentemente {{resource}}",
      "title_other": "Eliminar permanentemente {{count}} archivos",
      "description": "¿Estás seguro de que quieres eliminar permanentemente <strong>{{resource}}</strong>? Esta acción no se puede deshacer.",
      "description_other": "¿Estás seguro de que quieres eliminar permanentemente <strong>estos archivos</strong>? Esta acción no se puede deshacer."
    },
    "fileSellForm": {
      "title": "Vender archivo",
      "message": "Vender el archivo con FileGrant",
      "uploadPreview": "Haz clic o arrastra para subir la vista previa",
      "uploadPreviewHint": "Imagen cuadrada - Máx. 5MB",
      "removeImage": "Eliminar imagen",
      "pleaseEnterPrice": "Introduce un precio",
      "invalidNumber": "Número no válido",
      "priceMin": "El precio debe ser al menos €{{amount}}",
      "allowDownload": "Permitir descarga del archivo",
      "removeFromStore": "Quitar de la tienda",
      "listedSuccess": "¡Archivo puesto a la venta correctamente!",
      "purchaseLink": "Enlace de compra",
      "previewUploadError": "Error al subir la vista previa",
      "imageTooLarge": "La imagen debe ser menor de 5MB",
      "unableToReadImage": "No se puede leer la imagen",
      "previewAlt": "Vista previa",
      "mustBeImage": "El archivo debe ser una imagen",
      "previewImage": "Imagen de vista previa"
    },
    "emptyFilesTrash": {
      "title": "Vaciar papelera",
      "description": "¿Estás seguro de que quieres vaciar la papelera? Escribe <strong>{{keyword}}</strong> para confirmar, esta acción no se puede deshacer."
    },
    "settingExceptionsForm": {
      "title": "Editar excepciones",
      "description": "Editar las excepciones para la configuración.",
      "currentExceptions": "Excepciones actuales",
      "unsavedExceptions": "Excepciones no guardadas"
    },
    "aiSummary": {
      "title": "Resumen de IA"
    },
    "aiDocumentChat": {
      "title": "Chat con Documento"
    },
    "sendInvitationToGroupUsers": {
      "title": "Enviar invitación",
      "description": "Puedes enviar un mensaje personalizado a los nuevos usuarios del grupo o puedes cerrar este diálogo sin ninguna acción adicional.",
      "success": "Invitación enviada exitosamente",
      "error": "Error enviando invitación",
      "customMessagePlaceholder": "Opcional: mensaje personalizado"
    },
    "sendInvitationToUsers": {
      "title": "Enviar invitación",
      "description": "Puedes enviar un mensaje personalizado a {{resource}} o puedes cerrar este diálogo sin ninguna acción adicional.",
      "description_other": "Puedes enviar un mensaje personalizado a {{count}} usuarios o puedes cerrar este diálogo sin ninguna acción adicional.",
      "success": "Invitación enviada exitosamente",
      "error": "Error enviando invitación",
      "customMessagePlaceholder": "Opcional: mensaje personalizado"
    },
    "restoreFileVersion": {
      "title": "Restaurar versión de archivo",
      "description": "¿Estás seguro de que quieres restaurar <strong>{{resource}}</strong> a la versión <strong>{{version}}</strong>?"
    },
    "fileShareFormUnauthorizedUsers": {
      "title": "Usuarios no autorizados",
      "descriptionForAllUsers": "No puedes compartir archivos con estos usuarios debido a la configuración actual",
      "descriptionForSomeUsers": "No puedes compartir archivos con estos usuarios: <strong> {{users}} </strong> a causa de la configuración actual, ¿deseas compartir con otros usuarios que no estén bloqueados por la configuración?"
    },
    "sessionExpired": {
      "title": "Sesión expirada",
      "description": "Tu sesión ha expirado. Por favor inicia sesión de nuevo para continuar.",
      "redirectMessage": "Serás redirigido a la página de inicio de sesión en <strong>{{seconds}}</strong> segundos…",
      "goToLoginNow": "Ir a iniciar sesión ahora"
    },
    "appUpdated": {
      "title": "Nueva versión disponible",
      "description": "Hay una nueva versión de la aplicación. Recarga la página para continuar.",
      "reloadButton": "Recargar"
    },
    "tooManyRequestsOverlay": {
      "title": "Demasiadas solicitudes",
      "description": "Has realizado demasiadas solicitudes en poco tiempo. Espera un momento antes de volver a intentarlo.",
      "redirectMessage": "Podrás reintentar en <strong>{{seconds}}</strong> segundos…"
    },
    "activateTotpOverlay": {
      "badge": "Protección de la cuenta",
      "title": "Tus archivos merecen una defensa adicional",
      "description1": "En CyberGrant sabemos que los datos confidenciales no tienen precio — o mejor dicho, sí lo tienen, y es muy alto para quien quiera quitártelos.",
      "description2": "La autenticación en dos pasos (2FA) añade una segunda capa de verificación que bloquea accesos no autorizados incluso si las credenciales se ven comprometidas.",
      "stat1Value": "99,9%",
      "stat1Label": "de los ataques automatizados bloqueados con 2FA",
      "stat2Value": "< 30s",
      "stat2Label": "para completar la configuración inicial",
      "featuresTitle": "Con 2FA activo",
      "feature1": "Sin acceso posible sin tu teléfono",
      "feature2": "Notificación inmediata ante cada intento sospechoso",
      "feature3": "Mayor alineación con NIS2 y el RGPD",
      "actionActivate": "Activar 2FA ahora",
      "actionRemind": "Recordármelo en {{count}} día",
      "actionRemind_other": "Recordármelo en {{count}} días",
      "actionSkipForever": "Acepto el riesgo y no quiero activar el 2FA",
      "skipForever": "Omitir para siempre",
      "skipForeverConfirmTitle": "Confirma tu elección",
      "skipForeverConfirmBody1": "Estás eligiendo no activar la autenticación en dos pasos (2FA). La 2FA es la medida de seguridad más sencilla y eficaz que puedes adoptar. No activarla es un riesgo innecesario y fácilmente evitable.",
      "skipForeverConfirmBody2": "¿Seguro que quieres continuar sin activar la autenticación en dos pasos (2FA)?",
      "skipForeverConfirmEnableNow": "Activarla ahora",
      "skipForeverConfirmDecline": "No quiero activarla",
      "footer": "Podrás gestionar el 2FA en cualquier momento desde la configuración de seguridad de tu cuenta.",
      "badgeMandatory": "Acción requerida",
      "titleMandatory": "La autenticación de dos factores ahora es obligatoria",
      "description1Mandatory": "Tu organización requiere autenticación de dos factores (2FA) para tu cuenta y el período de gracia para configurarla ha terminado. Debes activarla ahora para seguir usando Filegrant.",
      "footerMandatory": "Este paso es requerido por la política de seguridad de tu organización y no se puede posponer."
    },
    "openFileLocallyError": {
      "title": "Cliente no encontrado",
      "description": "Para abrir documentos localmente, necesitas tener Remotegrant instalado. Contacta al administrador para instalarlo."
    },
    "offline": {
      "title": "Desconectado",
      "description": "Estás desconectado. Por favor verifica tu conexión a internet y vuelve a intentarlo.",
      "message": "Esperando conexión a internet..."
    },
    "webAppUpdateAvailable": {
      "title": "Actualización de la aplicación web disponible",
      "description": "Una nueva versión de la aplicación web está disponible. Por favor actualiza la página para aplicar las últimas modificaciones.",
      "okText": "Actualizar",
      "cancelText": "Más tarde"
    },
    "keepFilesOfflineError": {
      "title": "Cliente no encontrado",
      "description": "Para mantener archivos en tu PC, necesitas tener el agente RemoteGrant instalado. Contacta a tu administrador para instalarlo."
    },
    "sharingApprovalRequirementReviewTeamForm": {
      "title": "Gestionar Equipo de Revisión",
      "description": "Gestiona el equipo de revisión para la solicitud de compartición."
    },
    "tagsRequiredForShare": {
      "title": "Etiquetas requeridas para la compartición",
      "description": "El archivo <strong>{{resource}}</strong> requiere etiquetas para ser compartido. Por favor agrega etiquetas al archivo y vuelve a intentarlo.",
      "description_other": "Algunos de estos archivos requieren etiquetas para ser compartidos. Por favor agrega etiquetas a los archivos y vuelve a intentarlo."
    },
    "tagsRequiredForDownload": {
      "title": "Etiquetas requeridas para la descarga",
      "description": "El archivo <strong>{{resource}}</strong> requiere etiquetas para ser descargado. Por favor agrega etiquetas al archivo y vuelve a intentarlo.",
      "description_other": "Algunos de estos archivos requieren etiquetas para ser descargados. Por favor agrega etiquetas a los archivos y vuelve a intentarlo."
    },
    "filesWithShortcutsDeleteConfirmation": {
      "title": "¿Eliminar archivos?",
      "description": "¿Estás seguro de que quieres eliminar <strong>{{resource}}</strong>? Se encontraron accesos directos de los archivos seleccionados. Si eliminas este archivo, esos accesos directos ya no funcionarán <br /><br />¿Quieres continuar?",
      "description_other": "¿Estás seguro de que quieres eliminar <strong>estos archivos</strong>? Se encontraron accesos directos de los archivos seleccionados. Si eliminas estos archivos, esos accesos directos ya no funcionarán <br /><br />¿Quieres continuar?"
    },
    "officeTokenExpired": {
      "title": "La sesión ha expirado",
      "description": "Actualiza la página para continuar"
    },
    "officeEditorBeta": {
      "title": "¿Probar el nuevo FileGrant Office?",
      "description": "FileGrant Office está disponible en beta. Puedes seguir con el editor clásico o probar la nueva experiencia en esta sesión.",
      "tryNew": "Probar el nuevo",
      "useClassic": "Usar clásico"
    },
    "officeEditorDelete": {
      "title": "¿Mover a la papelera y cerrar el editor?",
      "description": "El archivo se moverá a la papelera y se cerrará el editor. Los cambios no guardados los gestiona el autoguardado."
    },
    "applyIsUsedForFileVisibilityTags": {
      "title": "Aplicar etiquetas a archivos",
      "description": "Aplicar las etiquetas seleccionadas compartirá automáticamente estos archivos con otros usuarios, según la configuración de visibilidad de archivos etiquetados.<br /><br />Etiquetas afectadas:<br /><strong>{{resource}}</strong><br /><br />¿Quieres continuar?",
      "description_other": "Aplicar algunas de las etiquetas seleccionadas compartirá automáticamente estos archivos con otros usuarios, según la configuración de visibilidad de archivos etiquetados.<br /><br />Etiquetas afectadas:<br /><strong>{{resource}}</strong><br /><br />¿Quieres continuar?"
    },
    "activeDirectoryUsersImportForm": {
      "importFromActiveDirectory": "Importar desde Active Directory",
      "title": "Importar usuarios desde Active Directory",
      "searchUsers": "Buscar usuarios...",
      "selectNew": "Seleccionar solo nuevos",
      "existing": "Existente",
      "new": "Nuevo",
      "importSelected": "Importar ({{count}})",
      "importSuccess": "Importación completada: {{created}} creados, {{updated}} actualizados",
      "importError": "Error durante la importación",
      "errorLoadingUsers": "Error al cargar usuarios de Active Directory",
      "noUsersFound": "No se encontraron usuarios",
      "resultSummary": "Creados: {{created}}, Actualizados: {{updated}}, Omitidos: {{skipped}}, Fallidos: {{failed}}",
      "defaultRole": "Rol predeterminado",
      "openSettings": "Abrir ajustes LDAP"
    },
    "activeDirectoryGroupsImportForm": {
      "importFromActiveDirectory": "Importar desde Active Directory",
      "title": "Importar grupos desde Active Directory",
      "searchGroups": "Buscar grupos...",
      "selectNew": "Seleccionar solo nuevos",
      "existing": "Existente",
      "new": "Nuevo",
      "importSelected": "Importar ({{count}})",
      "importSuccess": "Importación completada: {{created}} creados, {{updated}} actualizados",
      "importError": "Error durante la importación",
      "errorLoadingGroups": "Error al cargar grupos de Active Directory",
      "noGroupsFound": "No se encontraron grupos",
      "resultSummary": "Creados: {{created}}, Actualizados: {{updated}}, Omitidos: {{skipped}}, Fallidos: {{failed}}",
      "defaultRole": "Rol predeterminado",
      "openSettings": "Abrir ajustes LDAP",
      "importMembers": "Importar miembros",
      "usersImported": "{{count}} miembro(s) también importados",
      "linked": "Vinculado"
    },
    "entraIdFullSync": {
      "menuLabel": "Sincronización completa (Entra ID)",
      "title": "Sincronización completa de Entra ID",
      "syncUsers": "Sincronizar usuarios",
      "syncGroups": "Sincronizar grupos",
      "createMissingUsers": "Crear usuarios faltantes",
      "createMissingGroups": "Crear grupos faltantes",
      "updateExisting": "Actualizar existentes",
      "disableMissingUsers": "Desactivar usuarios que ya no están en el directorio",
      "disableMissingUsersTitle": "¿Desactivar usuarios faltantes?",
      "disableMissingUsersConfirm": "Los usuarios importados de este directorio que ya no estén presentes se deshabilitarán en Filegrant. Los usuarios deshabilitados por un administrador no se volverán a habilitar con la sincronización. ¿Continuar?",
      "confirmSync": "Sincronizar y desactivar",
      "groupFilter": "Filtro de nombre de grupo (opcional)",
      "defaultRole": "Rol predeterminado para usuarios nuevos",
      "runSync": "Ejecutar sincronización completa",
      "syncSuccess": "Sincronización completa finalizada",
      "syncError": "Error en la sincronización completa",
      "resultSummary": "Creados: {{created}}, Actualizados: {{updated}}, Omitidos: {{skipped}}, Fallidos: {{failed}}"
    },
    "activeDirectoryFullSync": {
      "menuLabel": "Sincronización completa (Active Directory)",
      "title": "Sincronización completa de Active Directory",
      "syncUsers": "Sincronizar usuarios",
      "syncGroups": "Sincronizar grupos",
      "createMissingUsers": "Crear usuarios faltantes",
      "createMissingGroups": "Crear grupos faltantes",
      "updateExisting": "Actualizar existentes",
      "disableMissingUsers": "Desactivar usuarios que ya no están en el directorio",
      "disableMissingUsersTitle": "¿Desactivar usuarios faltantes?",
      "disableMissingUsersConfirm": "Los usuarios importados de este directorio que ya no estén presentes se deshabilitarán en Filegrant. Los usuarios deshabilitados por un administrador no se volverán a habilitar con la sincronización. ¿Continuar?",
      "confirmSync": "Sincronizar y desactivar",
      "groupFilter": "Filtro de nombre de grupo (opcional)",
      "defaultRole": "Rol predeterminado para usuarios nuevos",
      "runSync": "Ejecutar sincronización completa",
      "syncSuccess": "Sincronización completa finalizada",
      "syncError": "Error en la sincronización completa",
      "resultSummary": "Creados: {{created}}, Actualizados: {{updated}}, Omitidos: {{skipped}}, Fallidos: {{failed}}"
    },
    "directorySync": {
      "usersDisabled": "{{count}} usuario(s) desactivados",
      "disableThemAnyway": "Deshabilitarlos de todos modos",
      "suggestFullSync": "Consejo: una sincronización completa puede volver a vincular un grupo recreado en el directorio.",
      "massDisableConfirmTitle": "¿Confirmar deshabilitación masiva?",
      "massDisableConfirmFallback": "Se deshabilitaría una gran parte de los usuarios. Confirme para continuar."
    },
    "convertToPdf": {
      "title": "Convertir a PDF",
      "selectDestination": "Seleccionar carpeta de destino"
    }
  },
  "specialFolders": {
    "FTA27E720F2F2BD4718893095FE4354A4F6": "Compartición Rápida"
  },
  "viewer": {
    "eml": {
      "attachments": "Adjuntos",
      "cc": "Cc",
      "date": "Fecha",
      "downloadAttachment": "Descargar {{name}}",
      "emptyBody": "Este mensaje no tiene contenido en el cuerpo.",
      "from": "De",
      "parseError": "No se pudo analizar este archivo de correo.",
      "showRawSource": "Mostrar fuente sin procesar",
      "subject": "Asunto",
      "to": "Para"
    },
    "ics": {
      "description": "Descripción",
      "empty": "No se encontraron eventos de calendario en este archivo.",
      "end": "Fin",
      "location": "Ubicación",
      "organizer": "Organizador",
      "parseError": "No se pudo analizar este archivo de calendario.",
      "showRaw": "Mostrar fuente sin procesar",
      "start": "Inicio",
      "untitled": "Evento sin título"
    },
    "msg": {
      "attachments": "Adjuntos",
      "cc": "Cc",
      "date": "Fecha",
      "downloadAttachment": "Descargar {{name}}",
      "emptyBody": "Este mensaje no tiene contenido en el cuerpo.",
      "from": "De",
      "parseError": "No se pudo analizar este mensaje de Outlook.",
      "showRawSource": "Mostrar fuente sin procesar",
      "subject": "Asunto",
      "to": "Para"
    },
    "vcf": {
      "email": "Correo",
      "empty": "No se encontraron contactos en este archivo.",
      "note": "Nota",
      "organization": "Organización",
      "parseError": "No se pudo analizar este archivo de contacto.",
      "phone": "Teléfono",
      "showRaw": "Mostrar fuente sin procesar",
      "title": "Cargo",
      "unnamed": "Contacto sin nombre"
    },
    "htmlPreview": {
      "title": "Abrir vista previa HTML",
      "description": "Este archivo HTML puede contener código JavaScript que podría ser potencialmente peligroso. La vista previa se mostrará en un entorno sandbox por seguridad. ¿Deseas continuar?",
      "button": "Vista previa HTML",
      "hideButton": "Ocultar vista previa"
    },
    "error": {
      "decryptFailed": {
        "title": "Desencriptación fallida",
        "description": "El archivo no puede ser desencriptado. Por favor intenta de nuevo."
      },
      "officeNoPreview": {
        "title": "No hay vista previa disponible",
        "description": "Atención: Verifica la confiabilidad de la fuente antes de descargar este archivo original."
      },
      "blobFetchFailed": {
        "title": "Archivo no encontrado",
        "description": "El archivo no fue encontrado. Por favor intenta de nuevo."
      },
      "videoPlayback": {
        "title": "Error de reproducción de video",
        "description": "No se pudo reproducir el video. Intenta recargar la página."
      },
      "videoUnsupported": {
        "title": "Formato de video no compatible",
        "description": "El navegador no puede decodificar este video (por ejemplo HEVC/H.265 o video de 10 bits). Solicita una versión codificada en H.264 (MP4) para reproducirlo aquí."
      },
      "fetchFilePermissionsFailed": {
        "title": "Error al obtener permisos del archivo",
        "description": "Los permisos del archivo no pudieron ser obtenidos. Por favor intenta de nuevo."
      },
      "isFolder": {
        "title": "El archivo es una carpeta",
        "description": "El archivo es una carpeta. No puede ser abierto en el visualizador."
      },
      "fetchFileFailed": {
        "title": "Error al obtener archivo",
        "description": "El archivo no pudo ser obtenido. Por favor intenta de nuevo."
      },
      "noPreviewAvailable": {
        "title": "No hay vista previa disponible",
        "description": "Atención: Verifica la confiabilidad de la fuente antes de descargar este archivo original."
      },
      "noPermissions": {
        "title": "Sin permisos",
        "description": "No tienes permiso para abrir este archivo."
      }
    },
    "sign": {
      "title": "Añadir firma",
      "add": "Añadir firma",
      "delete": "Eliminar firma",
      "pickFolder": "Elegir carpeta de destino",
      "saveSignature": "Guardar también esta firma en Archivos",
      "selectFolderHint": "Selecciona una posición para mostrar la ruta de la carpeta donde quieres guardar la firma",
      "unavailable": "La firma PDF no está disponible con la licencia actual del visor.",
      "success": "PDF firmado guardado",
      "error": "No se pudo guardar el PDF firmado",
      "flattenWarning": "La firma no se podrá quitar después de guardar. Asegúrate antes de guardar.",
      "modeEnabled": "Modo firma activado",
      "modeDisabled": "Modo firma desactivado",
      "tab": {
        "draw": "Dibujar",
        "upload": "Subir",
        "drive": "Desde Archivos"
      },
      "draw": {
        "hint": "Dibuja tu firma en el recuadro",
        "clear": "Borrar"
      },
      "upload": {
        "dropHint": "Suelta una imagen aquí o haz clic para explorar"
      },
      "replaceOrCopy": {
        "title": "Guardar PDF firmado",
        "replace": "Reemplazar original",
        "replaceHint": "Sobrescribe el PDF actual con la versión firmada",
        "copy": "Guardar como copia",
        "copyHint": "Conserva el original y guarda el PDF firmado en una carpeta que elijas"
      }
    }
  },
  "store": {
    "fileSalesOverview": "Resumen de Ventas de Archivos",
    "totalSales": "Unidades Vendidas",
    "fileRevenue": "Ingresos por Archivo",
    "unitRevenue": "Precio por Unidad",
    "stock": "Stock",
    "openStoreLink": "Abrir enlace de la tienda",
    "salesDashboard": "Panel de ventas",
    "confirmEmail": "Confirmar email",
    "confirmEmailPlaceholder": "Confirma tu email",
    "emailPlaceholder": "tu@ejemplo.com",
    "pleaseEnterEmail": "Introduce tu email",
    "pleaseConfirmEmail": "Confirma tu email",
    "emailsDoNotMatch": "¡Los dos emails no coinciden!",
    "invalidEmail": "¡El email no es válido!",
    "payNow": "Pagar ahora",
    "paymentSuccessful": "¡Pago correcto!",
    "fileAlreadySold": "Archivo ya vendido a este email",
    "emailsMismatch": "El email y la confirmación no coinciden.",
    "invalidEmailFormat": "Formato de email no válido",
    "fileNotFound": "Archivo no encontrado",
    "filePreview": "Vista previa del archivo",
    "filePreviewAlt": "Vista previa del archivo",
    "fileFullPreviewAlt": "Vista previa completa del archivo",
    "byOwner": "Por {{name}}",
    "purchase": "Comprar"
  },
  "dashboard": {
    "title": "Informe ejecutivo",
    "tabs": {
      "overview": "Resumen"
    },
    "riskIndicators": {
      "title": "Indicadores de Riesgo",
      "untaggedFiles": {
        "label": "Archivos sin Etiquetas",
        "description": "Porcentaje de archivos no clasificados con etiquetas. Un valor alto indica riesgo de incumplimiento de las políticas de clasificación de datos."
      },
      "sharingWithoutExpiration": {
        "label": "Compartir sin Vencimiento",
        "description": "Porcentaje de compartidos sin fecha de vencimiento. Los compartidos perpetuos aumentan el riesgo de acceso no autorizado con el tiempo."
      },
      "editorSharing": {
        "label": "Compartir con Permisos de Editor",
        "description": "Porcentaje de compartidos con permisos de edición. Los valores altos aumentan el riesgo de alteración no autorizada de datos."
      },
      "externalSharing": {
        "label": "Compartir Externo",
        "description": "Porcentaje de compartidos hacia dominios externos. Los valores altos pueden indicar riesgo de fuga de datos sensibles."
      },
      "excessiveExpiration": {
        "label": "Vencimientos Excesivos",
        "description": "Porcentaje de compartidos activos con vencimiento superior a 90 días. Los accesos prolongados aumentan el riesgo de compromiso."
      },
      "userConcentration": {
        "label": "Concentración de Usuario",
        "description": "Porcentaje máximo de compartidos realizados por un solo usuario. Alta concentración indica riesgo de amenaza interna o cuenta comprometida."
      },
      "thresholds": "Umbrales"
    },
    "ssoCoverage": {
      "label": "Usuarios internos sin SSO",
      "asOfNow": "Actualizado ahora",
      "excluded": "Excluidos del SSO",
      "outsideDomains": "Dominio de correo no cubierto por SSO",
      "description": "Instantánea actual de usuarios internos habilitados (todos los roles excepto External, no caducados) que inician sesión con OTP por correo en lugar de SSO. La exclusión del SSO tiene prioridad sobre el dominio no cubierto. No sigue el intervalo de fechas del informe."
    },
    "riskDetail": {
      "viewDetails": "Detalles",
      "user": "Usuario",
      "domain": "Dominio",
      "domains": "Dominios",
      "shares": "Compartidos",
      "noData": "No hay datos disponibles para este indicador",
      "totalUsers": "{{count}} usuarios afectados",
      "countLabel": {
        "editorSharing": "Compartidos con Editor",
        "untaggedFiles": "Archivos sin Etiquetas",
        "sharingWithoutExpiration": "Sin Vencimiento",
        "externalSharing": "Compartidos Externos",
        "excessiveExpiration": "Vencimientos Excesivos",
        "userConcentration": "Total Compartidos"
      }
    },
    "volumeData": {
      "volume": "Volumen",
      "files": "Archivos",
      "folders": "Carpetas",
      "total": "Total de Elementos"
    },
    "classification": {
      "title": "Clasificación de TAG",
      "withTag": "Con TAG",
      "withoutTag": "Sin TAG"
    },
    "sharing": {
      "title": "Compartir",
      "internal": "Interno",
      "external": "Externo",
      "readOnly": "Solo Lectura",
      "editor": "Editor",
      "warning": "Advertencia"
    },
    "expiration": {
      "title": "Vencimiento de Compartir",
      "withExpiration": "con vencimiento",
      "withoutExpiration": "sin vencimiento"
    },
    "expirationAnalysis": {
      "title": "Análisis Detallado de Vencimientos",
      "count": "Cantidad",
      "average": "Duración Media",
      "active": "Activo",
      "expired": "Vencido",
      "min": "Duración Mín",
      "max": "Duración Máx",
      "days": "días",
      "distribution": {
        "expired": "Vencidos",
        "expiringSoon": "0-7 días",
        "shortTerm": "7-30 días",
        "mediumTerm": "30-90 días",
        "longTerm": "90-365 días",
        "excessive": ">365 días"
      }
    },
    "domains": {
      "title": "Dominios Destinatarios",
      "domain": "Dominio",
      "type": "Tipo",
      "count": "Cantidad",
      "distribution": "Distribución",
      "internal": "Interno",
      "external": "Externo",
      "openRecipients": "Abrir los destinatarios de los compartidos de {{domain}}"
    },
    "users": {
      "title": "Estadísticas de Usuarios",
      "user": "Usuario",
      "files": "Archivos",
      "folders": "Carpetas",
      "total": "Total",
      "sharing": "Compartir",
      "withSharing": "Con Compartir",
      "withoutSharing": "Sin Compartir"
    },
    "refresh": "Actualizar Informe",
    "retry": "Reintentar",
    "period": "Período",
    "apply": "Aplicar",
    "lastMonth": "Último Mes",
    "last3Months": "Últimos 3 Meses",
    "year": "Año",
    "all": "Todos",
    "cachedData": "Datos actualizados el: {{date}}",
    "internalDomains": "Dominios Internos",
    "critical": "crítico",
    "warnings": "advertencias",
    "criticalAlert": "Indicadores de riesgo críticos detectados. Se requiere acción inmediata.",
    "warningAlert": "Indicadores de riesgo de advertencia detectados. Se recomienda revisar.",
    "securityIncidents": {
      "title": "Incidentes y alertas de seguridad",
      "noData": "No hay incidentes ni alertas de seguridad en este periodo",
      "dateTime": "Fecha y hora",
      "severityColumn": "Gravedad",
      "category": "Tipo",
      "description": "Descripción",
      "user": "Usuario",
      "ipAddress": "Dirección IP",
      "country": "País",
      "viewInActivityLog": "Ver en Activity Log",
      "severityLevels": {
        "critical": "Crítico",
        "error": "Error",
        "warning": "Advertencia",
        "info": "Info"
      },
      "categories": {
        "loginFailed": "Inicio de sesión fallido",
        "suspiciousAccess": "Acceso sospechoso",
        "policyViolation": "Violación de política",
        "permissionDenied": "Permiso denegado",
        "rateLimitExceeded": "Límite de solicitudes superado",
        "configurationAlert": "Cambio de configuración",
        "sharingViolation": "Violación de uso compartido",
        "dataExportAlert": "Exportación de datos"
      }
    },
    "securityAnomalies": {
      "title": "Anomalías de seguridad",
      "noData": "No hay anomalías de seguridad abiertas en este periodo",
      "criticalAlert": "{{count}} anomalía de seguridad crítica requiere atención",
      "criticalAlert_other": "{{count}} anomalías de seguridad críticas requieren atención",
      "byDetectorTitle": "Anomalías por tipo",
      "summary": {
        "totalOpen": "Anomalías abiertas",
        "critical": "Críticas",
        "warning": "Advertencias",
        "info": "Info"
      },
      "severityColumn": "Gravedad",
      "type": "Tipo",
      "anomaly": "Anomalía",
      "events": "Eventos",
      "lastSeen": "Último avistamiento",
      "actionsColumn": "Acciones",
      "handledAt": "Gestionada el",
      "tabs": {
        "open": "Abiertas",
        "managed": "Gestionadas"
      },
      "actions": {
        "hide": "Marcar como gestionada",
        "restore": "Restaurar"
      },
      "hideConfirmTitle": "¿Marcar esta anomalía como gestionada?",
      "hideNotePlaceholder": "Nota opcional (motivo)…",
      "restoreConfirmTitle": "¿Restaurar esta anomalía?",
      "hideSuccess": "Anomalía marcada como gestionada",
      "hideError": "No se pudo marcar la anomalía como gestionada",
      "restoreSuccess": "Anomalía restaurada",
      "restoreError": "No se pudo restaurar la anomalía",
      "managedLoadError": "No se pudieron cargar las anomalías gestionadas",
      "managedNoData": "No hay anomalías gestionadas",
      "severityLevels": {
        "critical": "Crítica",
        "warning": "Advertencia",
        "info": "Info"
      },
      "detectors": {
        "admin_ip_blocked": "Acceso de admin desde IP bloqueada",
        "unauthorized_country": "Acceso desde país no autorizado",
        "brute_force_login": "Fuerza bruta de inicio de sesión",
        "password_spray": "Password spray",
        "folder_password_brute_force": "Fuerza bruta de contraseña de carpeta",
        "public_link_brute_force": "Fuerza bruta de enlace público",
        "security_signal": "Señal de seguridad"
      }
    },
    "activityMap": {
      "title": "Actividad por país",
      "noData": "No hay datos de ubicación de actividad en este periodo",
      "activities": "{{count}} actividades",
      "failedLogins": "{{count}} inicios de sesión fallidos",
      "legendLow": "Bajo",
      "legendHigh": "Alto",
      "selectedCountry": "{{country}}",
      "hint": "Haz clic en un país del mapa para ver los detalles.",
      "viewDetails": "Ver detalle de accesos",
      "periodNote": "Los datos del mapa corresponden a los últimos 90 días.",
      "periodRange": "Los datos del mapa van del {{from}} al {{to}}."
    },
    "geoDetail": {
      "title": "Detalle de accesos — {{country}}",
      "totalUsers": "{{count}} usuarios",
      "user": "Usuario",
      "activities": "Actividades",
      "failedLogins": "Inicios de sesión fallidos",
      "distinctIps": "IPs",
      "lastAccess": "Último acceso",
      "anonymous": "Anónimo",
      "noData": "No hay datos de acceso para este país en el periodo seleccionado",
      "geoUnavailable": "Geolocalización no disponible"
    },
    "recipients": {
      "title": "Destinatarios de los compartidos",
      "domainSubtitle": "Dominio: {{domain}}",
      "refreshHint": "Recalcular los datos (como máximo una vez cada 30 segundos)",
      "topTitle": "Top 10 destinatarios por elementos compartidos",
      "noData": "No hay destinatarios en el período seleccionado",
      "countingRulesTitle": "Cómo se cuentan los destinatarios",
      "countingRules": {
        "active": "Solo cuentan los compartidos activos: se excluyen los caducados, pendientes, rechazados, revocados o agotados y los archivos en la papelera.",
        "direct": "Solo cuentan los compartidos directos: una carpeta compartida es un elemento, su contenido no se expande.",
        "group": "Un grupo es un destinatario (los miembros se muestran a título informativo); todos los enlaces públicos son una fila.",
        "domainCount": "Estos totales pueden ser inferiores a los de Dominios destinatarios, que incluyen todos los compartidos del período."
      },
      "summary": {
        "internalUsers": "Usuarios internos",
        "externalUsers": "Usuarios externos",
        "groups": "Grupos",
        "publicLinks": "Enlaces públicos",
        "totalShares": "Compartidos totales"
      },
      "types": {
        "all": "Todos los tipos",
        "internal": "Interno",
        "external": "Externo",
        "group": "Grupo",
        "public": "Público"
      },
      "type": "Tipo",
      "domain": "Dominio",
      "domainPlaceholder": "Filtrar por dominio",
      "searchPlaceholder": "Buscar nombre o email",
      "editorOnly": "Solo compartidos de editor",
      "withoutExpirationOnly": "Solo sin caducidad",
      "sortBy": "Ordenar por",
      "sortByValue": "Ordenar por: {{field}}",
      "sort": {
        "items": "Elementos",
        "editor": "Compartidos de editor",
        "withoutExpiration": "Sin caducidad",
        "lastShared": "Último compartido",
        "owners": "Propietarios",
        "name": "Nombre"
      },
      "totalRecipients": "{{count}} destinatarios",
      "name": "Nombre",
      "email": "Email",
      "members": "Miembros",
      "items": "Elementos",
      "filesFolders": "{{files}} archivos / {{folders}} carpetas",
      "editorShares": "Editor",
      "withoutExpiration": "Sin caducidad",
      "withoutPassword": "Sin contraseña",
      "owners": "Propietarios",
      "lastShared": "Último compartido",
      "highestRisk": "Riesgo máximo",
      "publicLinks": "Enlaces públicos",
      "unknown": "Desconocido",
      "itemsTitle": "Compartido con {{name}}",
      "totalItems": "{{count}} elementos compartidos",
      "noItems": "No hay compartidos activos en el período seleccionado",
      "itemName": "Nombre",
      "file": "Archivo",
      "folder": "Carpeta",
      "size": "Tamaño",
      "owner": "Propietario",
      "permission": "Permiso",
      "editor": "Editor",
      "viewer": "Lector",
      "expiration": "Caducidad",
      "never": "Nunca",
      "createdAt": "Compartido el",
      "canDownload": "Descarga",
      "passwordProtected": "Contraseña",
      "accesses": "Accesos",
      "accessCountValue": "{{count}} / {{max}}",
      "unlimited": "Ilimitados",
      "yes": "Sí",
      "no": "No"
    },
    "errors": {
      "accessDenied": "Acceso Denegado",
      "accessDeniedDescription": "No tiene permiso para ver el Informe Ejecutivo. Solo los Administradores pueden acceder a esta sección.",
      "serverError": "Error del Sistema",
      "serverErrorDescription": "No se puede generar el informe. Por favor, inténtelo de nuevo más tarde.",
      "noData": "No Hay Datos Disponibles",
      "pdfExportFailed": "Error al exportar el panel como PDF. Inténtelo de nuevo o contacte con soporte.",
      "noDataDescription": "No hay archivos o compartidos para el período seleccionado. Intente modificar el filtro de fecha.",
      "folderPasswordForm": {
        "title": "Protección con Contraseña de Carpeta"
      },
      "invalidFilter": "Filtro no válido: se ha restablecido.",
      "recipientNotFound": "Destinatario no encontrado. La lista se ha actualizado."
    }
  },
  "aiClassificationStatus": {
    "none": "Ninguno",
    "queued": "En cola...",
    "classifying": "Clasificando...",
    "done": "Completado",
    "error": "Error",
    "unknown": "Desconocido"
  },
  "webSocketStatus": {
    "idle": "Inactivo",
    "connecting": "Conectando",
    "open": "Abierto",
    "closing": "Cerrando",
    "closed": "Cerrado",
    "error": "Error"
  },
  "fileOfflineStatus": {
    "Pending": "En cola para sincronización de dispositivo",
    "Downloading": "Descargando al dispositivo",
    "Downloaded": "Sincronizado en el dispositivo"
  },
  "file": {
    "antivirus": {
      "pending": "Análisis antivirus en curso",
      "rescanPending": "Reanálisis en cola — el archivo sigue bloqueado ({{threatName}})",
      "infected": "Amenaza detectada: {{threatName}}",
      "error": "El antivirus no pudo verificar este archivo",
      "errors": {
        "STREAM_TOO_LARGE": "No verificado por el antivirus — archivo demasiado grande para analizar",
        "ENGINE_UNREACHABLE": "Motor antivirus no alcanzable",
        "SCAN_TIMEOUT": "Análisis antivirus agotó el tiempo de espera",
        "MAX_RETRIES": "Análisis antivirus falló tras varios intentos"
      },
      "rescanFailed": "Reanálisis fallido — el archivo sigue bloqueado ({{threatName}})",
      "retry": "Reintentar análisis",
      "contactAdmin": "Contacte a su administrador si cree que es un falso positivo.",
      "stickyNote": "Volver a subir, restaurar una versión o editar en Office no eliminará esta amenaza.",
      "tooLarge": "No verificado por el antivirus — archivo demasiado grande para analizar"
    }
  },
  "batch": {
    "status": {
      "all": "Todos",
      "queued": "En cola",
      "processing": "Procesando",
      "completed": "Completado",
      "failed": "Fallido",
      "partiallycompleted": "Parcialmente completado",
      "cancelled": "Cancelado"
    },
    "operation": {
      "all": "Todas las operaciones",
      "classification": "Clasificación IA",
      "folderexpansion": "Expansión de carpeta",
      "delete": "Eliminación"
    },
    "failedFiles": "{{count}} archivo fallido",
    "failedFiles_other": "{{count}} archivos fallidos",
    "eta": "Tiempo estimado",
    "failedFilesDetail": "Detalle de archivos fallidos",
    "noFailedFiles": "No hay archivos fallidos",
    "fileCancelled": "Cancelación solicitada para este archivo.",
    "fileCancelError": "Error al solicitar la cancelación del archivo.",
    "fileRetried": "Archivo en cola para reintentar",
    "fileRetryError": "Error al reintentar el archivo",
    "cancelAllFailed": "Cancelar todos los lotes fallidos (no en proceso)",
    "cancelAllFailedConfirmTitle": "¿Cancelar todos los lotes fallidos?",
    "cancelAllFailedConfirmContent": "Se borrarán solo los lotes con estado Fallido. Los lotes en proceso o en cola siguen ejecutándose y no se ven afectados. Esta operación no se puede deshacer."
  },
  "entraId": {
    "importFromEntraId": "Importar desde Entra ID",
    "importGroupsTitle": "Importar Grupos desde Microsoft Entra ID",
    "importUsersTitle": "Importar Usuarios desde Microsoft Entra ID",
    "searchGroups": "Buscar grupos...",
    "selectNew": "Seleccionar solo nuevos",
    "existing": "Existente",
    "new": "Nuevo",
    "importMembers": "También importar miembros del grupo",
    "importSelected": "Importar ({{count}})",
    "importSuccess": "Importación completada: {{created}} creados, {{updated}} actualizados",
    "importError": "Error durante la importación",
    "errorLoadingGroups": "Error al cargar grupos desde Entra ID",
    "errorLoadingUsers": "Error al cargar usuarios desde Entra ID",
    "noGroupsFound": "No se encontraron grupos",
    "noUsersFound": "No se encontraron usuarios",
    "resultSummary": "Creados: {{created}}, Actualizados: {{updated}}, Omitidos: {{skipped}}, Fallidos: {{failed}}",
    "usersImported": "{{count}} miembro(s) también importados",
    "permissionErrorTitle": "Permisos de Azure AD Insuficientes",
    "permissionErrorDescription": "La aplicación de Azure AD no tiene permisos suficientes para acceder a Microsoft Graph API.",
    "permissionErrorSteps": "Para resolver este problema:",
    "permissionErrorStep1": "Ir a Azure Portal > Registros de aplicaciones > Tu aplicación",
    "permissionErrorStep2": "Navegar a Permisos de API",
    "permissionErrorStep3": "Agregar los permisos de Aplicación requeridos (no Delegados)",
    "permissionErrorStep4": "Hacer clic en \"Conceder consentimiento de administrador\" para autorizar los permisos",
    "requiredPermissions": "Permisos requeridos",
    "filterBySync": "Filtrar por sincronización",
    "syncedWithEntraId": "Sincronizado con Entra ID",
    "syncedTooltip": "Sincronizado con Microsoft Entra ID",
    "searchUsers": "Buscar usuarios...",
    "importUsersSuccess": "Importación completada: {{created}} creados, {{updated}} actualizados",
    "usersResultSummary": "Creados: {{created}}, Actualizados: {{updated}}, Omitidos: {{skipped}}, Fallidos: {{failed}}",
    "defaultRole": "Rol por defecto"
  },
  "continents": {
    "europe": "Europa",
    "asia": "Asia",
    "africa": "África",
    "northAmerica": "América del Norte",
    "southAmerica": "América del Sur",
    "oceania": "Oceanía",
    "antarctica": "Antártida"
  },
  "components": {
    "countrySelect": {
      "placeholder": "Seleccionar países...",
      "euOption": "Unión Europea (27 países)",
      "searchPlaceholder": "Buscar países..."
    },
    "regionSelect": {
      "placeholder": "Seleccionar regiones o ingresar códigos ISO...",
      "euOption": "Unión Europea",
      "searchPlaceholder": "Buscar regiones..."
    },
    "ipCidrInput": {
      "placeholder": "Ingresar direcciones IP o rangos CIDR, separados por comas",
      "helperText": "Ejemplos: 192.168.1.100, 10.0.0.0/8, 2001:db8::/32",
      "invalidEntry": "Introduce una dirección IP o un rango CIDR válido",
      "invalidEntries": "Entradas no válidas: {{entries}}"
    },
    "ipRegionExceptionForm": {
      "title": "Gestionar Excepciones de IP/Región",
      "description": "Otorgar criterios de acceso adicionales a usuarios o grupos específicos",
      "typeLabel": "Tipo de Excepción",
      "additionalIpsTitle": "IPs Adicionales Permitidas",
      "addAllowedIp": "Añadir IP o CIDR",
      "additionalCountriesTitle": "Países Adicionales Permitidos",
      "additionalRegionsTitle": "Regiones Adicionales Permitidas",
      "expirationTitle": "Fecha de Expiración",
      "expirationNone": "Sin Expiración",
      "expirationCustom": "Expira el:",
      "reasonTitle": "Motivo (para auditoría)",
      "reasonPlaceholder": "ej., Viaje de negocios a Londres - Feb 2026",
      "addException": "Añadir excepción",
      "existingExceptions": "Excepciones existentes",
      "fetchError": "Se produjo un error al obtener las excepciones. Inténtalo de nuevo.",
      "selectAtLeastOne": "Selecciona al menos un usuario o grupo",
      "atLeastOneCriterion": "Añade al menos una dirección IP, país o región: una excepción sin criterios no concede nada",
      "alreadyPresent": "Los usuarios o grupos seleccionados ya tienen una excepción en esta restricción"
    }
  },
  "email": {
    "inbox": "Recibidos",
    "sent": "Enviados",
    "favorites": "Favoritos",
    "trash": "Papelera",
    "drafts": "Borradores",
    "noEmails": "No hay correos en esta carpeta",
    "noEmailsFound": "No se encontraron correos",
    "noSubject": "(Sin asunto)",
    "searchPlaceholder": "Buscar correos",
    "newMessage": "Nuevo Mensaje",
    "newEmail": "Correo",
    "folders": "Carpetas",
    "to": "Para",
    "from": "De",
    "cc": "Cc",
    "bcc": "Cco",
    "subject": "Asunto",
    "date": "Fecha",
    "body": "Cuerpo",
    "send": "Enviar",
    "sending": "Enviando...",
    "cancel": "Cancelar",
    "draftIdle": "Esperando cambios",
    "draftSaveError": "Error al guardar",
    "draftSaved": "Borrador guardado",
    "draftSaving": "Guardando...",
    "editDraft": "Editar borrador",
    "saveDraft": "Guardar borrador",
    "sendError": "Error al enviar el correo",
    "errorExternalSharingNotAllowed": "Los siguientes destinatarios no están autorizados",
    "errorSharingDenied": "No tienes permiso para compartir estos archivos",
    "errorPartialSharingDenied": "Algunos archivos adjuntos no se pueden compartir con los destinatarios seleccionados",
    "errorCannotAccessFiles": "No tienes acceso a los archivos adjuntos",
    "attachmentReadOnly": "Solo vista",
    "attachmentEditor": "Puede editar",
    "attachmentExpirationWarning": "La compartición caducará en {{days}} días",
    "attachmentPermission": "Permiso",
    "writeMessage": "Escribe tu mensaje...",
    "attachFiles": "Adjuntar archivos",
    "attachments": "Adjuntos",
    "hasAttachments": "Con adjuntos",
    "addFavorite": "Añadir a favoritos",
    "removeFavorite": "Quitar de favoritos",
    "moveToTrash": "Mover a papelera",
    "archive": "Archivo",
    "archiveAction": "Archivar",
    "unarchiveAction": "Mover a Inbox",
    "restore": "Restaurar",
    "deleteDraft": "Eliminar borrador",
    "deleteDraftConfirm": "¿Mover este borrador a la papelera? Podrás restaurarlo desde la papelera después.",
    "deletePermanently": "Eliminar permanentemente",
    "bold": "Negrita",
    "italic": "Cursiva",
    "underline": "Subrayado",
    "bulletList": "Lista con viñetas",
    "fontSmall": "Pequeño",
    "fontNormal": "Normal",
    "fontLarge": "Grande",
    "fontHuge": "Enorme",
    "sendingInProgress": "Envío en Progreso",
    "stepPreparing": "Preparando el mensaje para la entrega",
    "stepValidating": "Validando los destinatarios",
    "stepArchiving": "Archivando en almacenamiento seguro",
    "stepDelivering": "Entregando a los destinatarios...",
    "secureDelivery": "Entrega Segura - Protección Empresarial",
    "protect": "Proteger con contraseña",
    "protectionTitle": "Protección con contraseña",
    "protectionPassword": "Contraseña",
    "protectionConfirm": "Confirmar contraseña",
    "protectionHint": "Pista (opcional)",
    "protectionMismatch": "Las contraseñas no coinciden",
    "protectionWarning": "El contenido del correo se cifrará localmente. Si pierdes esta contraseña, el mensaje no podrá ser recuperado.",
    "protectedMessage": "Este mensaje está protegido por una contraseña.",
    "protectedSnippet": "Mensaje protegido",
    "protectedHintLabel": "Pista",
    "enterPassword": "Introduce la contraseña para leer el mensaje",
    "unlock": "Desbloquear",
    "wrongPassword": "Contraseña incorrecta. Inténtalo de nuevo.",
    "reply": "Responder",
    "forward": "Reenviar",
    "forwardedMessage": "Mensaje reenviado",
    "forwardExpired": "El mensaje original ha expirado, el reenvío ha sido cancelado.",
    "forwardAttachmentsTitle": "Reenviar adjuntos",
    "forwardAttachmentsMessage": "Este mensaje contiene adjuntos. ¿Desea incluirlos en el mensaje reenviado?",
    "forwardWithAttachments": "Con adjuntos",
    "forwardWithoutAttachments": "Sin adjuntos",
    "selectFromFileGrant": "Seleccionar de FileGrant",
    "uploadFromDevice": "Subir desde dispositivo",
    "selectFiles": "Seleccionar archivos",
    "selectFolderForUpload": "Seleccionar carpeta de carga",
    "filesSelected": "{{count}} archivo(s) seleccionados",
    "confirm": "Confirmar",
    "expiration": "Caducidad",
    "expirationTitle": "Fecha de caducidad",
    "expirationDescription": "El correo ya no será accesible después de la fecha seleccionada.",
    "expirationPlaceholder": "Seleccionar fecha y hora de caducidad",
    "expiresOn": "Caduca el {{date}}",
    "expired": "Caducado el {{date}}",
    "selected": "{{count}} seleccionados",
    "markAsRead": "Marcar como leído",
    "markAsUnread": "Marcar como no leído",
    "deletePermanentlyConfirm": "¿Estás seguro de que quieres eliminar permanentemente {{count}} correos? Esta acción no se puede deshacer.",
    "selectAll": "Seleccionar todo",
    "deselectAll": "Deseleccionar todo",
    "removeAttachment": "Eliminar adjunto",
    "removeAttachmentConfirm": "¿Desea eliminar este adjunto? Se revocará el acceso para todos los destinatarios.",
    "attachmentNotFound": "Adjunto no encontrado",
    "featureNotAvailable": "Función no disponible",
    "removeRecipient": "Eliminar destinatario",
    "removeRecipientsConfirm": "¿Desea eliminar {{count}} destinatario(s)? Ya no podrán ver este correo y se revocará el acceso a los adjuntos.",
    "emailNotFound": "Correo no encontrado",
    "recipientNotFound": "Destinatario no encontrado",
    "mustKeepOneRecipient": "Debe quedar al menos un destinatario",
    "replyAll": "Responder a todos",
    "activity": "Actividad",
    "cannotCreateEmail": "No tienes permiso para crear nuevos correos",
    "blockForward": "Bloquear reenvío",
    "blockForwardDescription": "Los destinatarios no podrán reenviar este correo",
    "advancedProtection": "Protección avanzada",
    "protectDescription": "Los destinatarios necesitarán una contraseña para leer este correo"
  },
  "note": {
    "createNote": "Nota",
    "createTitle": "Crear nota",
    "newNote": "Nueva nota",
    "fileName": "Nombre del archivo",
    "fileNameRequired": "El nombre del archivo es obligatorio",
    "placeholder": "Escribe tu nota...",
    "loadError": "No se pudo cargar la nota",
    "sidebarTitle": "Notas",
    "editing": "Edición",
    "reading": "Lectura",
    "codeBlock": "Bloque de código",
    "rename": "Renombrar",
    "renamed": "Archivo renombrado",
    "renameError": "No se pudo renombrar el archivo",
    "saved": "Nota guardada",
    "saveError": "No se pudo guardar la nota",
    "checklist": "Lista de tareas",
    "linkUrl": "URL del enlace",
    "linkText": "Texto del enlace",
    "insertLink": "Insertar enlace",
    "saving": "Guardando…",
    "savedShort": "Guardado",
    "delete": "Eliminar nota",
    "deleteTitle": "Eliminar nota",
    "deleteConfirm": "¿Eliminar la nota \"{{name}}\"? Se moverá a la papelera.",
    "deleted": "Nota eliminada",
    "deleteError": "No se ha podido eliminar la nota",
    "expandSidebar": "Expandir barra lateral",
    "collapseSidebar": "Contraer barra lateral"
  },
  "aiSummary": {
    "generationInProgress": "La generación del resumen puede tardar un poco: puedes cerrar esta ventana, te avisaremos cuando esté listo.",
    "closeAndNotify": "Cerrar, te avisaremos"
  },
  "imagePreview": {
    "loadFullQuality": "Cargar calidad completa",
    "loadFullQualityTooltip": "Cargar la imagen original en resolución completa (archivo grande)",
    "loadingFullQuality": "Cargando calidad completa…",
    "openInViewer": "Abrir en el visor"
  },
  "shortcuts": {
    "title": "Atajos de teclado",
    "then": "luego",
    "searchLabel": "Buscar atajos de teclado",
    "searchPlaceholder": "Buscar atajos…",
    "listLabel": "Lista de atajos de teclado",
    "noResults": "Ningún atajo coincide con la búsqueda.",
    "categories": {
      "app": "Aplicación",
      "create": "Crear",
      "file": "Archivos",
      "navigation": "Navegación",
      "selection": "Selección",
      "view": "Vista"
    },
    "app": {
      "focusSearch": "Enfocar búsqueda",
      "openShortcutsHelp": "Abrir atajos de teclado"
    },
    "create": {
      "openMenu": "Abrir menú Crear",
      "folder": "Nueva carpeta",
      "uploadFile": "Subir archivo",
      "uploadFolder": "Subir carpeta",
      "word": "Nuevo documento Word",
      "excel": "Nueva hoja Excel",
      "powerpoint": "Nueva presentación PowerPoint",
      "note": "Nueva nota",
      "secret": "Nuevas credenciales de acceso",
      "secretCard": "Nueva tarjeta de pago",
      "secretIdentity": "Nueva identidad",
      "secretSshKey": "Nueva clave SSH",
      "secretCustom": "Nuevo secreto personalizado"
    },
    "file": {
      "open": "Abrir",
      "openNewTab": "Abrir en nueva pestaña",
      "rename": "Renombrar",
      "share": "Compartir",
      "move": "Mover",
      "favorite": "Añadir a favoritos",
      "delete": "Eliminar",
      "copyLink": "Copiar enlace",
      "createShortcut": "Crear acceso directo",
      "details": "Detalles",
      "download": "Descargar",
      "publicLink": "Enlace público",
      "setPassword": "Establecer contraseña",
      "aiSummary": "Resumen IA",
      "tags": "Editar etiquetas"
    },
    "view": {
      "toggleGridList": "Alternar vista cuadrícula o lista"
    },
    "nav": {
      "focusSidebar": "Enfocar navegación",
      "focusMain": "Enfocar lista de archivos",
      "focusDetails": "Enfocar panel de detalles",
      "focusUploadDrawer": "Enfocar progreso de subida"
    },
    "selection": {
      "selectAll": "Seleccionar todo",
      "clear": "Borrar selección",
      "toggle": "Alternar selección",
      "moveFocusUp": "Mover foco arriba",
      "moveFocusDown": "Mover foco abajo",
      "moveFocusLeft": "Mover foco izquierda",
      "moveFocusRight": "Mover foco derecha",
      "extendUp": "Ampliar selección arriba",
      "extendDown": "Ampliar selección abajo",
      "extendLeft": "Ampliar selección izquierda",
      "extendRight": "Ampliar selección derecha"
    }
  },
  "chat": {
    "thinking": {
      "working": "Procesando tu solicitud. Puede tardar unos segundos."
    },
    "stream": {
      "tools": {
        "routing": "Clasificando solicitud",
        "rag_search": "Buscando documentos",
        "filename_search": "Buscando por nombre de archivo",
        "metadata_search": "Buscando metadatos",
        "open_file": "Abriendo archivo",
        "relevance_assessment": "Evaluando relevancia",
        "search_refinement": "Refinando búsqueda",
        "activity_log_search": "Buscando en el registro de actividad",
        "calculator": "Calculando",
        "chart_generation": "Generando gráfico",
        "aggregation": "Agregando resultados",
        "answer_generation": "Redactando respuesta",
        "paused": "En cola",
        "unknown": "Trabajando"
      },
      "descriptions": {
        "routing": {
          "start": "Entendiendo qué necesitas…",
          "done": "Solicitud clasificada{{intentDetail}}."
        },
        "rag_search": {
          "start": "Buscando en tus documentos{{queryDetail}}…",
          "done": "Encontrados pasajes coincidentes en tu biblioteca{{countDetail}}."
        },
        "filename_search": {
          "start": "Revisando tus archivos por nombre{{patternDetail}}…",
          "done": "Archivos coincidentes por nombre{{countDetail}}."
        },
        "metadata_search": {
          "start": "Revisando etiquetas, fechas y otras propiedades…",
          "done": "Propiedades del documento comprobadas{{countDetail}}."
        },
        "open_file": {
          "start": "Leyendo el documento elegido{{filenameDetail}}…",
          "done": "Contenido del documento listo{{filenameDetail}}."
        },
        "relevance_assessment": {
          "start": "Valorando qué resultados encajan mejor{{candidateCountDetail}}…",
          "done": "Se conservaron las mejores coincidencias{{countDetail}}."
        },
        "search_refinement": {
          "start": "Afinando la consulta para mejores resultados{{queryDetail}}…",
          "done": "Criterios de búsqueda actualizados."
        },
        "activity_log_search": {
          "start": "Comprobando quién hizo qué y cuándo{{queryDetail}}…",
          "done": "Entradas de actividad coincidentes obtenidas{{countDetail}}."
        },
        "calculator": {
          "start": "Calculando las cifras{{expressionDetail}}…",
          "done": "Cifras listas{{expressionDetail}}."
        },
        "chart_generation": {
          "start": "Convirtiendo datos en un gráfico…",
          "done": "Gráfico listo para mostrar."
        },
        "aggregation": {
          "start": "Combinando coincidencias en un solo conjunto…",
          "done": "Resultados combinados listos{{countDetail}}."
        },
        "answer_generation": {
          "start": "Preparando tu respuesta…",
          "done": "Respuesta lista."
        },
        "paused": {
          "start": "GPU ocupada — turno en cola{{reasonDetail}}…",
          "done": "Reanudado — continúo con tu solicitud."
        },
        "unknown": {
          "start": "Trabajando en este paso…",
          "done": "Este paso está completo."
        }
      },
      "param": {
        "query": " de «{{query}}»",
        "pattern": " de «{{pattern}}»",
        "filename": " «{{filename}}»",
        "expression": " ({{expression}})",
        "count": " ({{count}})",
        "candidateCount": " ({{count}} candidatos)",
        "reason": " — {{reason}}",
        "intent": " como «{{intent}}»"
      },
      "reasons": {
        "gpu_overload": "Sobrecarga de GPU"
      },
      "toolsUsed": "Herramientas usadas ({{count}})"
    },
    "disclaimer": "AIGrant puede cometer errores. Verifica la información importante.",
    "offlineHint": "Sin conexión en tiempo real. Puedes ver los chats; envía cuando vuelva.",
    "offlineDisclaimer": "Sin conexión: podrás enviar mensajes cuando se restablezca la conexión.",
    "connectingHint": "Estableciendo conexión en tiempo real. Podrás enviar cuando esté lista.",
    "connectingDisclaimer": "Conectando: podrás enviar mensajes cuando la conexión esté lista.",
    "placeholder": "Escribe tu mensaje... (Intro para enviar, Mayús+Intro para nueva línea)",
    "dictate": "Dictar",
    "stopDictation": "Detener dictado",
    "speechUnsupported": "El reconocimiento de voz no es compatible con este navegador",
    "dictationFailed": "No se pudo iniciar el dictado",
    "regenerate": "Regenerar",
    "readAloud": "Leer en voz alta",
    "stopReading": "Dejar de leer",
    "speechUnavailable": "Síntesis de voz no disponible",
    "requestCancelled": "Solicitud cancelada",
    "genericError": "Se produjo un error al procesar tu solicitud.",
    "gpuBusyBody": "El sistema está temporalmente sobrecargado. Inténtalo de nuevo en unos momentos.",
    "gpuBusyRetrying": "Sistema ocupado — reintentando una vez…",
    "responseTimeout": "No se pudo completar la solicitud dentro del tiempo máximo (10 minutos). Inténtalo de nuevo más tarde o contacta con soporte si el problema persiste.",
    "jumpToLatest": "Ir al último mensaje"
  },
  "sharePointStatus": {
    "menuLabel": "SharePoint",
    "title": "Estado de SharePoint",
    "openConfiguration": "Configurar",
    "refreshHint": "Lee el estado en directo de tu tenant. Úsalo con moderación.",
    "never": "Nunca",
    "notAvailableTitle": "No incluido en tu licencia",
    "notAvailable": "La integración con SharePoint no está incluida en tu licencia. Contacta con soporte para activarla.",
    "loadFailedTitle": "No se ha podido cargar el estado",
    "loadFailed": "Se ha producido un error al leer el estado de la integración.",
    "verdict": {
      "encrypting": "Los archivos del perímetro se están cifrando",
      "notEncrypting": "No se está cifrando nada"
    },
    "unmatched": {
      "title": "Algunos sitios del perímetro no existen en tu tenant",
      "body": "La coincidencia es exacta, por lo que un sitio renombrado o eliminado deja de coincidir. Los archivos de estos sitios no se inspeccionan ni se cifran:",
      "allMissingTitle": "Ningún sitio del perímetro existe en tu tenant",
      "allMissingBody": "No se supervisa nada. No se ha encontrado ninguno de estos sitios:",
      "repickAction": "Volver a seleccionar estos sitios"
    },
    "blocking": {
      "notConfiguredTitle": "La integración no está configurada",
      "notConfigured": "No hay credenciales guardadas, por lo que no está ocurriendo nada.",
      "configInvalid": "La configuración guardada ha sido rechazada por la misma validación que ejecuta el análisis, por lo que no está ocurriendo nada.",
      "workerDisabledTitle": "El análisis no está activo en esta instalación",
      "workerDisabled": "El servicio de análisis no está registrado en este despliegue, por lo que no se inspeccionará nada. Esto no lo puedes cambiar tú: contacta con soporte.",
      "noCertificateTitle": "No hay ningún certificado de cifrado seleccionado",
      "noCertificate": "No hay ningún certificado de RemoteGrant seleccionado, por lo que no hay clave y no se cifrará nada.",
      "certificateUnusableTitle": "El certificado de cifrado ya no se puede usar",
      "certificateUnusable": "Vuelve a seleccionar el certificado y guarda para reanudar el cifrado. Puede que se haya eliminado en RemoteGrant, que su clave se haya sustituido o que RemoteGrant no esté accesible.",
      "noKeyWhileArmed": "El modo discovery está desactivado, por lo que esta configuración parece activa mientras no se cifra nada.",
      "emptyPerimeterTitle": "El perímetro está vacío",
      "emptyPerimeter": "Ningún sitio del perímetro se resuelve contra tu tenant, por lo que no se supervisa nada."
    },
    "certificate": {
      "label": "Certificado de cifrado",
      "none": "Ninguno seleccionado",
      "unnamed": "Certificado n.º {{id}}",
      "repickAction": "Volver a seleccionar el certificado"
    },
    "perimeterUnresolvedTitle": "No se ha podido comprobar el perímetro contra tu tenant",
    "perimeterUnresolvedBody": "Los contadores de abajo siguen siendo válidos, pero los sitios y carpetas supervisados no se han podido leer en este momento. Esto no significa que el perímetro esté vacío.",
    "perimeterError": {
      "unauthorized": "Microsoft Graph ha rechazado las credenciales: puede que el secreto de cliente haya caducado o que a los permisos de aplicación les falte el consentimiento del administrador.",
      "unavailable": "Microsoft Graph no está disponible temporalmente.",
      "siteNotFound": "Un sitio del perímetro ya no es visible con estas credenciales.",
      "generic": "No se ha podido contactar con el tenant."
    },
    "countersTitle": "Actividad del análisis",
    "pendingInQueue": "Archivos pendientes de procesar",
    "totalFilesEncrypted": "Archivos cifrados hasta ahora",
    "scanInterval": "Perímetro comprobado",
    "everyNMinutes": "Cada {{minutes}} minutos",
    "lastEncryptedAt": "Último archivo cifrado",
    "lastDeltaAdvancedAt": "Último ciclo de análisis",
    "lastVerifiedAt": "Última verificación de las credenciales",
    "verifyOk": "Correcta",
    "verifyKo": "Rechazada",
    "perimeterTitle": "Perímetro supervisado",
    "perimeterUnknown": "En este momento no se ha podido leer el perímetro de tu tenant.",
    "perimeterEmpty": "No se supervisa ningún sitio.",
    "crossLibraryCaveat": "Cada carpeta de abajo se compara con la raíz de todas las bibliotecas de documentos de su sitio, no solo con la biblioteca desde la que se seleccionó.",
    "wholeSiteTag": "Todo el sitio",
    "wholeSiteBody": "Sin filtro de carpetas: todos los archivos de este sitio están incluidos.",
    "allFileTypes": "Todos los tipos de archivo",
    "filteredFileTypes": "Solo: {{extensions}}",
    "notAllowedTitle": "No tienes permiso para ver esta página",
    "notAllowed": "No tienes permiso para gestionar la integración con SharePoint. Pide a un SuperAdmin que te dé acceso a este ajuste.",
    "box": {
      "active": "Activo",
      "dryRunDiscovery": "Discovery",
      "dryRunEncryption": "Cifrado",
      "dryRunLabel": "Modo",
      "dryRunOffCaption": "Los archivos coincidentes se cifran in situ, sin vuelta atrás.",
      "dryRunOnCaption": "El perímetro solo se inspecciona: no se reescribe nada.",
      "inactive": "Inactivo",
      "off": "Desactivada",
      "on": "Activada",
      "scanLabel": "Análisis"
    },
    "issuesTitle": "Condiciones que requieren tu atención"
  },
  "sharePoint": {
    "editor": {
      "error": {
        "disabled": {
          "description": "La integración con SharePoint no está habilitada en esta instalación.",
          "title": "Integración no disponible"
        },
        "forbidden": {
          "description": "No tienes permiso para abrir este archivo en SharePoint.",
          "title": "Acceso denegado"
        },
        "generic": {
          "description": "No se ha podido abrir el archivo en el editor. Inténtalo de nuevo o ábrelo en el visor.",
          "title": "No se puede abrir el editor"
        },
        "notProtected": {
          "description": "Este archivo no está cifrado por FileGrant, así que se abre directamente en SharePoint con Office.",
          "title": "Nada que abrir aquí"
        },
        "tooLarge": {
          "description": "El archivo supera el límite de tamaño para la edición. Aún puedes abrirlo en el visor.",
          "title": "Archivo demasiado grande para editar"
        },
        "unsupported": {
          "description": "Este formato no se puede editar en línea. Aún puedes abrirlo en el visor.",
          "title": "Formato no editable"
        }
      },
      "loading": "Abriendo el archivo en el editor…",
      "readOnly": {
        "description": "SharePoint no te ha concedido permiso para modificar este archivo, o no hay ningún certificado disponible para cifrar el guardado. Puedes leerlo, pero no guardarlo.",
        "title": "Documento de solo lectura"
      },
      "signIn": {
        "button": "Inicia sesión para editar el archivo",
        "description": "Inicia sesión con tu cuenta de Microsoft para editar este archivo. La edición requiere permiso para modificar archivos en SharePoint, que quizá deba autorizar un administrador.",
        "failed": "El inicio de sesión no se ha completado. Comprueba que el navegador no esté bloqueando las ventanas emergentes e inténtalo de nuevo.",
        "title": "Inicio de sesión requerido"
      }
    },
    "signIn": {
      "failed": {
        "description": "No se pudo cargar la configuración de inicio de sesión de Microsoft. Vuelve a cargar la página o inténtalo de nuevo en unos momentos.",
        "title": "Inicio de sesión no disponible"
      },
      "loading": "Preparando el inicio de sesión de Microsoft…",
      "notConfigured": {
        "description": "No se puede abrir el archivo: un administrador no ha configurado el registro de aplicación de Microsoft que usa el navegador para iniciar sesión. Pídele que complete la configuración de la integración de SharePoint.",
        "title": "Inicio de sesión no configurado"
      }
    },
    "viewer": {
      "edit": "Editar",
      "error": {
        "authFailed": {
          "description": "No se ha podido obtener permiso para leer tus archivos de SharePoint. Vuelve a iniciar sesión o pide a un administrador que autorice FileGrant.",
          "title": "Se requiere iniciar sesión"
        },
        "disabled": {
          "description": "La integración con SharePoint no está habilitada en esta instalación.",
          "title": "Integración no disponible"
        },
        "forbidden": {
          "description": "No tienes permiso para abrir este archivo en SharePoint.",
          "title": "Acceso denegado"
        },
        "generic": {
          "description": "No se ha podido abrir el archivo desde SharePoint. Inténtalo de nuevo.",
          "title": "No se puede abrir el archivo"
        },
        "invalidLink": {
          "description": "Este enlace de SharePoint no es válido. Vuelve a abrir el archivo desde SharePoint.",
          "title": "Enlace no válido"
        },
        "notFound": {
          "description": "No se ha encontrado el archivo: puede haberse movido o eliminado.",
          "title": "Archivo no encontrado"
        },
        "reopen": {
          "description": "El permiso para abrir este archivo ha caducado, o el archivo ha cambiado entre tanto. Vuelve a abrirlo desde SharePoint.",
          "title": "Vuelve a abrir el archivo"
        },
        "tooLarge": {
          "description": "Este archivo supera el límite de tamaño del visor de SharePoint.",
          "title": "Archivo demasiado grande"
        }
      },
      "loading": "Leyendo el archivo desde SharePoint…",
      "signIn": {
        "button": "Inicia sesión para abrir el archivo",
        "description": "Inicia sesión con tu cuenta de Microsoft para abrir este archivo. Solo se descifra si tienes permiso para leerlo.",
        "failed": "El inicio de sesión no se completó. Comprueba que el navegador no esté bloqueando las ventanas emergentes e inténtalo de nuevo.",
        "title": "Inicio de sesión necesario"
      },
      "source": "Desde SharePoint"
    }
  },
  "activeDirectory": {
    "syncedWithActiveDirectory": "Sincronizado con Active Directory"
  }
}
